<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="550"
    height="450"
    id="milestone-golden-gate"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-100 0 450 400"
    role="presentation"
    aria-labelledby="goldengatejamstacksf"
  >
    <title id="goldengatejamstacksf">Jamstack SF</title>
    <image href="conf-bk.png" x="-50" y="100" height="380" width="330" />
    <g id="Sun">
      <g id="XMLID_437" data-name="XMLID 437">
        <g id="XMLID_438" data-name="XMLID 438">
          <g id="Vector">
            <path
              class="cls-1"
              d="M319.3,60.7c-6.1-10.7-6.1-22.2,0-25.8s16.2,2.2,22.4,12.9,6.1,22.2-.1,25.8S325.5,71.4,319.3,60.7Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M337.6,75.1c-6.1,0-13.7-5.5-18.7-14.1-3-5.3-4.7-10.9-4.7-15.8s1.7-8.9,4.9-10.7,7.3-1.4,11.7,1.1a33.3,33.3,0,0,1,11.3,12,32.7,32.7,0,0,1,4.7,15.8c0,5-1.8,8.8-4.9,10.6A8.1,8.1,0,0,1,337.6,75.1ZM323.5,34.4a7.6,7.6,0,0,0-3.9,1c-2.8,1.6-4.4,5.1-4.4,9.8a31.8,31.8,0,0,0,4.6,15.3h0c6,10.4,15.7,16.1,21.6,12.6,2.8-1.6,4.4-5.1,4.4-9.7a30.7,30.7,0,0,0-4.6-15.3,31.9,31.9,0,0,0-10.9-11.6A13.6,13.6,0,0,0,323.5,34.4Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="Clouds">
      <g id="XMLID_435" data-name="XMLID 435">
        <g id="Vector_2" data-name="Vector 2">
          <path
            class="cls-1"
            d="M211,37.8l3,1.2V32.2c0-5.4,4.3-6.6,8.9-4s8.5,9.2,8.5,14.6v.9a4.3,4.3,0,0,1,3.8.7,13.2,13.2,0,0,1,6.1,10.5v.4l4.3,2.5a8.6,8.6,0,0,1,4,6.8c0,2.6-1.8,3.6-4,2.3L211,46.9a8.6,8.6,0,0,1-4-6.8C207,37.5,208.8,36.6,211,37.8Z"
            transform="translate(-57.9 0)"
          />
          <path
            d="M247.4,68a3.1,3.1,0,0,1-2.1-.7L210.7,47.4a9,9,0,0,1-4.2-7.3,3.3,3.3,0,0,1,1.4-3,3.5,3.5,0,0,1,3.3.2l2.3.9v-6c0-2.4.9-4.3,2.5-5.2s4.5-.8,7.2.8c4.8,2.7,8.7,9.5,8.7,15v.3a5.7,5.7,0,0,1,3.6.8,14.3,14.3,0,0,1,6.3,11h0l4,2.3a9.4,9.4,0,0,1,4.3,7.3,3.3,3.3,0,0,1-1.5,3A1.7,1.7,0,0,1,247.4,68ZM209.2,37.8a1.1,1.1,0,0,0-.8.2q-.9.4-.9,2.1a8.2,8.2,0,0,0,3.7,6.4l34.6,20a2.4,2.4,0,0,0,2.3.3,2.3,2.3,0,0,0,1-2.2,8.4,8.4,0,0,0-3.8-6.4L241,55.7a.5.5,0,0,1-.2-.4v-.4A12.6,12.6,0,0,0,235,44.8a3.8,3.8,0,0,0-3.4-.6h-.5c-.2-.1-.2-.3-.2-.5v-.9c0-5.2-3.7-11.6-8.2-14.2-2.4-1.3-4.7-1.6-6.2-.7s-2,2.2-2,4.3V39a.5.5,0,0,1-.2.4.3.3,0,0,1-.4,0l-3.1-1.1h-.1A2.8,2.8,0,0,0,209.2,37.8Z"
            transform="translate(-57.9 0)"
          />
        </g>
      </g>
      <g id="XMLID_434" data-name="XMLID 434">
        <g id="Vector_3" data-name="Vector 3">
          <path
            class="cls-1"
            d="M245.7,40.1l5.6,3.2V40.9c0-2.9,2-4,4.5-2.6a11.1,11.1,0,0,1,2.7,2.6c.4-3.6,3.2-5,6.7-2.9a15.1,15.1,0,0,1,6.7,11.6V52a8.7,8.7,0,0,1-.5,2.8l4.6,2.6a6.2,6.2,0,0,1,2.5,4.3c0,1.6-1.1,2.3-2.5,1.5L245.8,45.8a5.9,5.9,0,0,1-2.5-4.3C243.2,39.9,244.3,39.3,245.7,40.1Z"
            transform="translate(-57.9 0)"
          />
          <path
            d="M277.1,64a2.3,2.3,0,0,1-1.4-.4L245.6,46.2a6,6,0,0,1-2.8-4.7,2,2,0,0,1,.9-2,2.1,2.1,0,0,1,2.3.1h0l4.8,2.8V40.9a3.8,3.8,0,0,1,1.6-3.4,3.6,3.6,0,0,1,3.6.4,6.7,6.7,0,0,1,2.2,1.9,4.4,4.4,0,0,1,2.2-2.9,5.3,5.3,0,0,1,5,.6,15.7,15.7,0,0,1,7,12.1V52a7.5,7.5,0,0,1-.4,2.6l4.2,2.4a6,6,0,0,1,2.8,4.7,2.3,2.3,0,0,1-1,2.1ZM244.6,40.2h-.4c-.3.2-.4.6-.4,1.2a4.8,4.8,0,0,0,2.3,3.8l30.1,17.5a1.3,1.3,0,0,0,1.3.2,1.3,1.3,0,0,0,.5-1.2,4.8,4.8,0,0,0-2.3-3.8l-4.6-2.7a.5.5,0,0,1-.2-.6,4.7,4.7,0,0,0,.5-2.6V49.6a14.5,14.5,0,0,0-6.5-11.2,4.3,4.3,0,0,0-4.1-.6A3.8,3.8,0,0,0,259,41c-.1.2-.2.4-.4.4a.4.4,0,0,1-.5-.2,8.5,8.5,0,0,0-2.6-2.4,2.7,2.7,0,0,0-2.6-.4,2.7,2.7,0,0,0-1.1,2.5v2.4a.8.8,0,0,1-.2.4h-.5l-5.6-3.2A1.6,1.6,0,0,0,244.6,40.2Z"
            transform="translate(-57.9 0)"
          />
        </g>
      </g>
    </g>
    <g id="Bridge">
      <g id="Bridge_2" data-name="Bridge 2">
        <g id="Group">
          <g id="Group_2" data-name="Group 2">
            <g id="Group_3" data-name="Group 3">
              <g id="XMLID_432" data-name="XMLID 432">
                <g id="Vector_4" data-name="Vector 4">
                  <path
                    class="cls-1"
                    d="M122.6,210.9s-1.5-6.5-4.1-9.9-5.7-4.1-7.7-3.4-1.5,2.8.9,4.1a20,20,0,0,1,8.4,9.3Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M120.1,211.5c-.2,0-.3-.1-.4-.3a18.9,18.9,0,0,0-8.3-9.1,3.2,3.2,0,0,1-2.1-3.2,1.9,1.9,0,0,1,1.3-1.8c1.7-.6,4.9-.9,8.3,3.6a25.2,25.2,0,0,1,4.2,10.1.9.9,0,0,1-.1.5h-2.9Zm-7.5-13.7a4.5,4.5,0,0,0-1.6.3,1.2,1.2,0,0,0-.8.9,2.8,2.8,0,0,0,1.7,2.2,20.4,20.4,0,0,1,8.6,9.3H122c-.5-1.7-1.8-6.5-3.8-9.2s-4-3.5-5.6-3.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_431" data-name="XMLID 431">
              <g id="Vector_5" data-name="Vector 5">
                <path
                  class="cls-1"
                  d="M121.6,210.9h0c-2.6-8.7-7.4-12-9.6-12.5,0,0-.1,0-.1.2h.1c2.2.5,6.9,3.7,9.4,12.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M121.6,211.4c-.3,0-.5-.1-.5-.2V211c-2.5-8.3-7-11.4-9-11.9a.6.6,0,0,1-.6-.6h0a.7.7,0,0,1,.6-.7h.1c2.3.5,7.3,3.8,10,12.8h0C122.1,211.3,121.8,211.4,121.6,211.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_426" data-name="XMLID 426">
            <g id="XMLID_430" data-name="XMLID 430">
              <g id="Vector_6" data-name="Vector 6">
                <path
                  class="cls-1"
                  d="M119,220.2a3.6,3.6,0,0,1-3.8-.9c-.8-1-.3-3-1.1-3.7s-2.2-.7-3.6-.7-3.3-1.6-2.5-3.2,1.1-2.8-.4-4.4-2.9-3.1-1.5-4.7,4.2-.1,5.5.8,2.1.9,3.1-.2,2.9-.6,3.4,1.3.1,3.6,1.2,4.1,1.6-.2,2.9.4,1.9,3.5,1.3,5.5S119,220.2,119,220.2Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M117.7,220.9a3.9,3.9,0,0,1-2.9-1.3,3.3,3.3,0,0,1-.6-2.2,3.3,3.3,0,0,0-.4-1.4c-.6-.6-2-.6-3.3-.6h0a3.5,3.5,0,0,1-2.8-1.4,2.5,2.5,0,0,1-.2-2.5c.8-1.7,1-2.6-.2-3.8s-3.3-3.4-1.6-5.4,4.6-.4,6.2.7,1.6.8,2.4-.1a2.1,2.1,0,0,1,2.2-.7,2.8,2.8,0,0,1,2.1,2.2,6.3,6.3,0,0,1,.3,1.9c.1,1.1.2,1.7.6,1.9a2.1,2.1,0,0,0,1.1.1,2.8,2.8,0,0,1,1.8.2c1.9.8,2.6,3.1,1.6,6.2s-4.5,5.7-4.6,5.8h-.2A2.8,2.8,0,0,1,117.7,220.9Zm1.3-.7Zm-7.5-5.8a4,4,0,0,1,3,.9,2.5,2.5,0,0,1,.6,2,3.4,3.4,0,0,0,.5,1.7,2.8,2.8,0,0,0,3.2.7c.5-.5,3.6-3.6,4.3-5.4s1-4-1.1-4.9a2,2,0,0,0-1.3-.1,2.2,2.2,0,0,1-1.6-.3c-1-.4-1.1-1.4-1.2-2.6a5.7,5.7,0,0,0-.3-1.8,1.9,1.9,0,0,0-1.3-1.4,1.1,1.1,0,0,0-1.2.3c-1.2,1.4-2.3,1.5-3.8.3s-3.7-2.3-4.8-.9-.1,2.4,1.5,4.1,1.2,3.2.4,4.9a1.8,1.8,0,0,0,.1,1.6,2.5,2.5,0,0,0,2,.9Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_429" data-name="XMLID 429">
              <g id="Vector_7" data-name="Vector 7">
                <path
                  class="cls-1"
                  d="M121.1,217.3c.1,0,.1-.1.1-.2-3.8-7.1-11.6-13.2-14.1-14h-.2c0,.1,0,.2.1.2,2.5.8,10.3,6.8,13.9,14Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M121.1,217.8l-.5-.2h-.1c-3.6-6.9-11.2-12.9-13.7-13.7h-.2a1.4,1.4,0,0,1-.2-.6l.2-.3.5-.2h.2c2.5.8,10.5,7.1,14.3,14.3v.2a1.4,1.4,0,0,1-.2.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_428" data-name="XMLID 428">
              <g id="Vector_8" data-name="Vector 8">
                <path
                  class="cls-1"
                  d="M116.3,210.6h0a17.9,17.9,0,0,0-.6-6.1h-.2a17.3,17.3,0,0,1,.7,6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M116.3,211.1l-.4-.2a.8.8,0,0,1-.2-.4,18.5,18.5,0,0,0-.6-5.7v-.2a.3.3,0,0,1,0-.4c0-.2.2-.3.4-.3h.4a.5.5,0,0,1,.3.5h0a16.2,16.2,0,0,1,.7,6.2C116.9,211,116.5,211.1,116.3,211.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_427" data-name="XMLID 427">
              <g id="Vector_9" data-name="Vector 9">
                <path
                  class="cls-1"
                  d="M112.2,211.1l3-1.8h0c0-.1-.1-.1-.2-.1a18,18,0,0,1-5.4,2.6s-.1,0,0,.1h.1A7.3,7.3,0,0,0,112.2,211.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M109.6,212.4h-.2c-.2,0-.3-.2-.3-.4v-.4c.1-.2.2-.3.4-.3a17.2,17.2,0,0,0,5.3-2.5c0-.1.1-.1.2-.1l.6.2c.1.1.1.2.1.4a.8.8,0,0,1-.2.5,19.2,19.2,0,0,1-3.1,1.8,8.6,8.6,0,0,1-2.7.9Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Group_4" data-name="Group 4">
          <g id="Group_5" data-name="Group 5">
            <g id="Group_6" data-name="Group 6">
              <g id="XMLID_425" data-name="XMLID 425">
                <g id="Vector_10" data-name="Vector 10">
                  <path
                    class="cls-1"
                    d="M296.6,253.2a18.6,18.6,0,0,1-1.5-8.1c.2-4.4,2.8-10.7,6.4-10s.9,5.8-.3,8a17.1,17.1,0,0,0-1.9,8.9Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M296.6,253.7c-.2,0-.3-.1-.4-.3a18.1,18.1,0,0,1-1.6-8.3c.2-3.3,1.7-7.8,4-9.7a3.6,3.6,0,0,1,3-.8,2.3,2.3,0,0,1,1.9,1.4c.9,1.8-.5,4.9-1.9,7.4a18.2,18.2,0,0,0-1.8,8.6.5.5,0,0,1-.3.5l-2.7,1.1Zm4.4-18.2a2.8,2.8,0,0,0-1.7.7c-2.1,1.6-3.5,5.8-3.7,8.9a17,17,0,0,0,1.3,7.4l1.9-.8a18,18,0,0,1,1.9-8.8c.7-1.2,2.7-4.9,1.9-6.5a1.3,1.3,0,0,0-1.2-.8Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_424" data-name="XMLID 424">
              <g id="Vector_11" data-name="Vector 11">
                <path
                  class="cls-1"
                  d="M297.9,252.7h.1c-1.4-7.9-.3-13.9,3-16.5v-.2h-.2c-3.4,2.7-4.5,8.8-3.1,16.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M297.9,253.2c-.3,0-.5-.1-.5-.2l-.2-.2c-1.4-8.2-.2-14.5,3.3-17.3l.4-.2.4.2a.6.6,0,0,1,.1.8h-.1c-3.2,2.6-4.2,8.4-2.8,16.1A.7.7,0,0,1,297.9,253.2Zm3.3-17Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_421" data-name="XMLID 421">
            <g id="XMLID_423" data-name="XMLID 423">
              <g id="Vector_12" data-name="Vector 12">
                <path
                  class="cls-1"
                  d="M299.1,258.9a9,9,0,0,0,4.6,0c2.6-.6,3.2-2.2,3.2-2.2s-1.9-1.9-3.6-1.9a13.5,13.5,0,0,1,4.9,0s1.5-.7,1.2-3.1c0,0-1.4-1-4.7-.5a10.6,10.6,0,0,1,4.5-1.6c.3,0-.2-3.3-.5-4.7s-.8-1.3-2-1.1-4.9,1.5-5.2,2.4a8.9,8.9,0,0,0,0,2.9,4.1,4.1,0,0,1-1.3-1.9,4.4,4.4,0,0,0-2.2,1,2.3,2.3,0,0,0-.6,2.7c.1.9.7,2.7,1.5,3.2a5.7,5.7,0,0,1-2.2-3.2,4.6,4.6,0,0,0-1,2.5C295.5,254.8,296.9,257.8,299.1,258.9Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M301.5,259.7a5.3,5.3,0,0,1-2.5-.4h-.1c-2.5-1.2-4-4.5-3.7-6a4.5,4.5,0,0,1,1.2-2.7c.1-.2.2-.2.4-.2a2.8,2.8,0,0,1,.8-2.6,4.7,4.7,0,0,1,2.6-1.1c.2,0,.5.2.5.4a.6.6,0,0,0,.1.4,4.4,4.4,0,0,1,.2-1.6c.6-1.2,4.8-2.4,5.6-2.6h.3c1-.2,1.9-.4,2.3,1.5,0,0,.9,4.5.4,5.1l-.4.2-2,.5a4.3,4.3,0,0,1,2.5.7l.2.3c.4,2.8-1.4,3.6-1.5,3.6h-.3l-2.6-.2a4.6,4.6,0,0,1,1.7,1.4c.2.1.2.3.2.5a4.7,4.7,0,0,1-3.6,2.5Zm-2.2-1.3a7.9,7.9,0,0,0,4.3,0,4.2,4.2,0,0,0,2.7-1.6,5.7,5.7,0,0,0-3-1.5c-.3-.1-.5-.3-.5-.5s.2-.5.4-.5a14,14,0,0,1,5-.1,2.3,2.3,0,0,0,.7-2.2,7.1,7.1,0,0,0-4.1-.3.5.5,0,0,1-.5-.3.7.7,0,0,1,.1-.6,9.8,9.8,0,0,1,4.4-1.6,30.3,30.3,0,0,0-.6-4.2c-.1-.9-.2-.9-1.1-.7h-.3c-1.4.2-4.6,1.5-4.9,2a6.2,6.2,0,0,0,.1,2.7.4.4,0,0,1-.2.5h-.6a11.5,11.5,0,0,1-1.4-1.7,2.6,2.6,0,0,0-1.5.7c-.8.8-.6,1.4-.5,2.3s.8,2.6,1.4,2.9a.5.5,0,0,1,.1.7.4.4,0,0,1-.5.2h-.1a4,4,0,0,1-2.1-2.5,2,2,0,0,0-.4,1.3c-.2,1.2,1,3.9,3.1,5Zm9.8-9.3Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_422" data-name="XMLID 422">
              <g id="Vector_13" data-name="Vector 13">
                <path
                  class="cls-1"
                  d="M299.1,259h.2c.2-4.9,5.6-12.7,8-14.3v-.3h-.2c-2.4,1.6-7.8,9.4-8.1,14.4Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M299.1,259.5a.7.7,0,0,1-.6-.7c.3-5.2,5.8-13.2,8.4-14.8h.2l.6.2a.4.4,0,0,1,.1.3,1.4,1.4,0,0,1-.2.6c-2.4,1.6-7.6,9.2-7.8,13.9A.8.8,0,0,1,299.1,259.5Zm-.3-.7Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Group_7" data-name="Group 7">
          <g id="XMLID_414" data-name="XMLID 414">
            <g id="XMLID_420" data-name="XMLID 420">
              <g id="Vector_14" data-name="Vector 14">
                <path
                  class="cls-1"
                  d="M126,203l24.9-14.4v-3.2L126,199.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M126,203.5h-.2c-.2,0-.3-.2-.3-.4v-3.2c0-.2.1-.3.3-.4l24.9-14.4h.5a.8.8,0,0,1,.2.4v3.2a.8.8,0,0,1-.2.5l-24.9,14.2Zm.5-3.4v2.1l23.9-13.9v-2Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_415" data-name="XMLID 415">
              <g id="XMLID_419" data-name="XMLID 419">
                <g id="Vector_15" data-name="Vector 15">
                  <path
                    class="cls-1"
                    d="M127.4,215.4a1.1,1.1,0,0,0,.9-.5l22.1-25.5a1.2,1.2,0,0,0-.1-1.7h0a1.2,1.2,0,0,0-1.7.1h0l-22.1,25.5a1.3,1.3,0,0,0,.1,1.8A1.1,1.1,0,0,0,127.4,215.4Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M127.4,215.9l-1.1-.4a1.9,1.9,0,0,1-.2-2.5l22.1-25.5a1.7,1.7,0,0,1,2.4-.2h0a1.8,1.8,0,0,1,.2,2.5l-22.1,25.5A1.6,1.6,0,0,1,127.4,215.9Zm22.2-28a.7.7,0,0,0-.6.3l-22.1,25.5a.5.5,0,0,0-.1.8l.2.2.4.2a.5.5,0,0,0,.5-.3l22.2-25.5a.8.8,0,0,0-.1-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_418" data-name="XMLID 418">
                <g id="Vector_16" data-name="Vector 16">
                  <path
                    class="cls-1"
                    d="M149.6,202.6a1.3,1.3,0,0,0,.1-2.5H127.4a1.2,1.2,0,0,0-1.2,1.2h0a1.2,1.2,0,0,0,1.2,1.2Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,203.1H127.4a1.8,1.8,0,0,1-.1-3.5h22.3a1.8,1.8,0,0,1,1.7,1.8A1.8,1.8,0,0,1,149.6,203.1Zm-22.2-2.5a.8.8,0,0,0-.7.8.7.7,0,0,0,.7.7h22.2a.7.7,0,0,0,.7-.7.8.8,0,0,0-.7-.8Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_417" data-name="XMLID 417">
                <g id="Vector_17" data-name="Vector 17">
                  <path
                    class="cls-1"
                    d="M127.4,200.3a1.1,1.1,0,0,0,.9-.4l22.1-25.5a1.2,1.2,0,1,0-1.8-1.6h0l-22.1,25.5a1.2,1.2,0,0,0,.1,1.7h0A.8.8,0,0,0,127.4,200.3Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M127.4,200.8a1.7,1.7,0,0,1-1.2-.4,1.8,1.8,0,0,1-.1-2.4l22.1-25.5a1.7,1.7,0,1,1,2.6,2.2l-22.1,25.5A1.6,1.6,0,0,1,127.4,200.8Zm22.2-27.9-.6.2-22.1,25.5c-.3.3-.3.7.1,1.1h.4l.5-.2L150.1,174a.9.9,0,0,0-.1-1.1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_416" data-name="XMLID 416">
                <g id="Vector_18" data-name="Vector 18">
                  <path
                    class="cls-1"
                    d="M149.6,187.6a1.3,1.3,0,0,0,.1-2.5H127.4a1.2,1.2,0,0,0-1.2,1.2h0a1.2,1.2,0,0,0,1.2,1.2Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,188.1H127.4a1.8,1.8,0,0,1-.1-3.5h22.3a1.8,1.8,0,0,1,1.7,1.8A1.8,1.8,0,0,1,149.6,188.1Zm-22.2-2.5a.8.8,0,0,0-.7.8.7.7,0,0,0,.7.7h22.2a.7.7,0,0,0,.7-.7.8.8,0,0,0-.7-.8Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="XMLID_407" data-name="XMLID 407" class="cls-2">
            <g id="XMLID_413" data-name="XMLID 413" class="cls-2">
              <g id="Vector_19" data-name="Vector 19" class="cls-2">
                <path
                  class="cls-1"
                  d="M126,203l24.9-14.4v-3.2L126,199.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M126,203.5h-.2c-.2,0-.3-.2-.3-.4v-3.2c0-.2.1-.3.3-.4l24.9-14.4h.5a.8.8,0,0,1,.2.4v3.2a.8.8,0,0,1-.2.5l-24.9,14.2Zm.5-3.4v2.1l23.9-13.9v-2Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_408" data-name="XMLID 408" class="cls-2">
              <g id="XMLID_412" data-name="XMLID 412" class="cls-2">
                <g id="Vector_20" data-name="Vector 20" class="cls-2">
                  <path
                    class="cls-1"
                    d="M127.4,215.4a1.1,1.1,0,0,0,.9-.5l22.1-25.5a1.2,1.2,0,0,0-.1-1.7h0a1.2,1.2,0,0,0-1.7.1h0l-22.1,25.5a1.3,1.3,0,0,0,.1,1.8A1.1,1.1,0,0,0,127.4,215.4Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M127.4,215.9l-1.1-.4a1.9,1.9,0,0,1-.2-2.5l22.1-25.5a1.7,1.7,0,0,1,2.4-.2h0a1.8,1.8,0,0,1,.2,2.5l-22.1,25.5A1.6,1.6,0,0,1,127.4,215.9Zm22.2-28a.7.7,0,0,0-.6.3l-22.1,25.5a.5.5,0,0,0-.1.8l.2.2.4.2a.5.5,0,0,0,.5-.3l22.2-25.5a.8.8,0,0,0-.1-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_411" data-name="XMLID 411" class="cls-2">
                <g id="Vector_21" data-name="Vector 21" class="cls-2">
                  <path
                    class="cls-1"
                    d="M149.6,202.6a1.3,1.3,0,0,0,.1-2.5H127.4a1.2,1.2,0,0,0-1.2,1.2h0a1.2,1.2,0,0,0,1.2,1.2Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,203.1H127.4a1.8,1.8,0,0,1-.1-3.5h22.3a1.8,1.8,0,0,1,1.7,1.8A1.8,1.8,0,0,1,149.6,203.1Zm-22.2-2.5a.8.8,0,0,0-.7.8.7.7,0,0,0,.7.7h22.2a.7.7,0,0,0,.7-.7.8.8,0,0,0-.7-.8Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_410" data-name="XMLID 410" class="cls-2">
                <g id="Vector_22" data-name="Vector 22" class="cls-2">
                  <path
                    class="cls-1"
                    d="M127.4,200.3a1.1,1.1,0,0,0,.9-.4l22.1-25.5a1.2,1.2,0,1,0-1.8-1.6h0l-22.1,25.5a1.2,1.2,0,0,0,.1,1.7h0A.8.8,0,0,0,127.4,200.3Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M127.4,200.8a1.7,1.7,0,0,1-1.2-.4,1.8,1.8,0,0,1-.1-2.4l22.1-25.5a1.7,1.7,0,1,1,2.6,2.2l-22.1,25.5A1.6,1.6,0,0,1,127.4,200.8Zm22.2-27.9-.6.2-22.1,25.5c-.3.3-.3.7.1,1.1h.4l.5-.2L150.1,174a.9.9,0,0,0-.1-1.1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_409" data-name="XMLID 409" class="cls-2">
                <g id="Vector_23" data-name="Vector 23" class="cls-2">
                  <path
                    class="cls-1"
                    d="M149.6,187.6a1.3,1.3,0,0,0,.1-2.5H127.4a1.2,1.2,0,0,0-1.2,1.2h0a1.2,1.2,0,0,0,1.2,1.2Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,188.1H127.4a1.8,1.8,0,0,1-.1-3.5h22.3a1.8,1.8,0,0,1,1.7,1.8A1.8,1.8,0,0,1,149.6,188.1Zm-22.2-2.5a.8.8,0,0,0-.7.8.7.7,0,0,0,.7.7h22.2a.7.7,0,0,0,.7-.7.8.8,0,0,0-.7-.8Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="Group_8" data-name="Group 8">
          <g id="XMLID_406" data-name="XMLID 406">
            <g id="Vector_24" data-name="Vector 24">
              <path
                class="cls-1"
                d="M159.2,211.9v-5.1a1.1,1.1,0,0,0-.6-1l-7.1-4.1a1.3,1.3,0,0,0-1.2,0l-34.8,20.1a1.1,1.1,0,0,0-.6,1v5a1.4,1.4,0,0,0,.6,1.1l7.2,4.1a1.1,1.1,0,0,0,1.1,0l34.8-20.1A1.3,1.3,0,0,0,159.2,211.9Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M123.3,233.6c-.4,0-.7,0-.9-.2l-7.1-4.1a1.9,1.9,0,0,1-.9-1.5v-5a2.1,2.1,0,0,1,.9-1.5l34.8-20.1a2.2,2.2,0,0,1,1.6,0l7.2,4.1a1.8,1.8,0,0,1,.8,1.5v5.1a1.6,1.6,0,0,1-.8,1.4l-34.8,20.1A1.1,1.1,0,0,1,123.3,233.6ZM150.9,202h-.3l-34.8,20.1a.7.7,0,0,0-.4.6v5a.7.7,0,0,0,.4.6l7.1,4.2h.7l34.8-20.1a.9.9,0,0,0,.3-.6v-5.1a.7.7,0,0,0-.3-.6l-7.2-4.1Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_405" data-name="XMLID 405">
            <g id="Vector_25" data-name="Vector 25">
              <path
                class="cls-1"
                d="M158.6,205.8l-7.1-4.1a1.3,1.3,0,0,0-1.2,0l-34.8,20.1c-.2.1-.3.4-.2.5l.2.2,7.2,4.1a1.1,1.1,0,0,0,1.1,0l34.8-20.1a.5.5,0,0,0,.3-.5Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M123.3,227.3a1.4,1.4,0,0,1-.9-.3l-7.1-4.1c-.3-.2-.5-.4-.5-.7a1,1,0,0,1,.5-.8l34.8-20.1a1.5,1.5,0,0,1,1.6,0l7.2,4.1h0a.9.9,0,0,1,.4.8.7.7,0,0,1-.4.7L124.1,227A1.1,1.1,0,0,1,123.3,227.3Zm-7.3-5.1,6.9,4h.7l34.6-20-7-4h-.6Zm42.4-15.9h0l.2-.5Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_404" data-name="XMLID 404">
          <g id="Vector_26" data-name="Vector 26">
            <path
              class="cls-1"
              d="M101.9,55.2c10.1,0,18.9-3.8,25.3-7.8,15.1-9.4,26.4-26.2,26.4-35a.9.9,0,0,0-.8-.8h0a.9.9,0,0,0-.8.8c0,7.4-9.7,23.8-25.6,33.7-9.9,6.2-25.5,11.7-43.2,2.9a.9.9,0,0,0-1.1.3h0a.6.6,0,0,0,.3.9.1.1,0,0,1,.1.1A43.5,43.5,0,0,0,101.9,55.2Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M101.9,55.7a43.3,43.3,0,0,1-19.6-4.8,1.2,1.2,0,0,1-.7-.7,1.2,1.2,0,0,1,.1-1,1.2,1.2,0,0,1,.7-.7,1.2,1.2,0,0,1,1,.1c17.5,8.7,32.9,3.2,42.8-2.9,15.7-9.9,25.3-26,25.3-33.3a1.3,1.3,0,1,1,2.6,0h0c0,8.9-11.4,26-26.6,35.5C121.8,51.4,112.7,55.7,101.9,55.7ZM82.8,49.4h0c-.2,0-.2,0-.2.1s-.1.1-.1.2l.2.2a43.9,43.9,0,0,0,19.2,4.7c10.6,0,19.5-4.2,25-7.7,15-9.3,26.2-25.9,26.2-34.6a.3.3,0,0,0-.3-.3h0l-.3.3c0,7.5-9.8,24.1-25.8,34.1-10.1,6.3-25.8,11.9-43.9,3Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="Group_9" data-name="Group 9">
          <g id="XMLID_399" data-name="XMLID 399">
            <g id="XMLID_403" data-name="XMLID 403">
              <g id="Vector_27" data-name="Vector 27">
                <path
                  class="cls-1"
                  d="M156.5,205.5v-1.8a1.2,1.2,0,0,0-.7-1.1l-4.3-2.5a1.3,1.3,0,0,0-1.2,0l-7.1,4.1a1.4,1.4,0,0,0-.6,1.1v1.8a1.3,1.3,0,0,0,.6,1.1l4.4,2.5a1.1,1.1,0,0,0,1.1,0l7.1-4.1A1.4,1.4,0,0,0,156.5,205.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.1,211.3a1.1,1.1,0,0,1-.8-.2l-4.4-2.5a1.8,1.8,0,0,1-.8-1.5v-1.8a1.8,1.8,0,0,1,.8-1.5l7.2-4.1a1.5,1.5,0,0,1,1.6,0l4.4,2.5a1.9,1.9,0,0,1,.9,1.5v1.8a2.8,2.8,0,0,1-.8,1.5l-7.2,4.1A1.5,1.5,0,0,1,148.1,211.3Zm2.8-10.8h-.3l-7.2,4.1a.9.9,0,0,0-.3.6V207a.7.7,0,0,0,.3.6l4.4,2.6h.7l7.1-4.2a.7.7,0,0,0,.4-.6v-1.8a.7.7,0,0,0-.4-.6l-4.4-2.5Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_402" data-name="XMLID 402">
              <g id="Vector_28" data-name="Vector 28">
                <path
                  class="cls-1"
                  d="M142.6,205.3a1.2,1.2,0,0,1,.7-1.1l.8-.4,4.1,2.4v4.6h-.6l-4.4-2.5a1.4,1.4,0,0,1-.6-1.1v-1.9Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,211.3h-.8l-4.5-2.6a1.8,1.8,0,0,1-.8-1.5v-1.8a.4.4,0,0,1,.1-.3,2,2,0,0,1,.8-1.2l.8-.4h.5l4.1,2.4c.2.1.3.2.3.4v4.6C148.7,211.1,148.4,211.3,148.2,211.3Zm-5.1-5.8v1.6a.9.9,0,0,0,.3.7l4.3,2.4v-3.7l-3.7-2.1-.5.3a.7.7,0,0,0-.4.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_400" data-name="XMLID 400">
              <g id="Vector_29" data-name="Vector 29">
                <path
                  class="cls-1"
                  d="M155.8,202.6l-4.3-2.5a1.3,1.3,0,0,0-1.2,0l-7.1,4.1c-.2.1-.3.4-.2.5s.1.1.2.2l4.4,2.5a1.1,1.1,0,0,0,1.1,0l7.1-4.1C156.2,203.1,156.2,202.8,155.8,202.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.1,208.1l-.8-.2-4.4-2.5a1.1,1.1,0,0,1-.2-1.4l.2-.2,7.2-4.1a1.5,1.5,0,0,1,1.6,0l4.4,2.5h0a1,1,0,0,1,.4,1.2l-.4.4-7.1,4.1Zm-4.5-3.5,4.2,2.4h.7l6.9-4-4.2-2.4h-.6Zm12-1.5h0l.2-.5Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_10" data-name="Group 10">
            <g id="XMLID_398" data-name="XMLID 398">
              <g id="Vector_30" data-name="Vector 30">
                <path
                  class="cls-1"
                  d="M150.3,204.9l-2.1,1.3-2.8-1.6V170.1a1.1,1.1,0,0,1,.6-1l4.4-2.5c.3-.2.6-.1.6.3v37A1.8,1.8,0,0,1,150.3,204.9Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,206.6h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V170.1a1.9,1.9,0,0,1,.9-1.5l4.3-2.5h1a1.2,1.2,0,0,1,.4.8v37a2.4,2.4,0,0,1-.9,1.5h0l-2.2,1.2Zm-2.3-2.3,2.3,1.3,1.9-1.1a1,1,0,0,0,.4-.7V167.1l-4.2,2.4a.7.7,0,0,0-.4.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_397" data-name="XMLID 397" class="cls-3">
              <g id="Vector_31" data-name="Vector 31" class="cls-3">
                <path
                  class="cls-1"
                  d="M150.3,204.9l-2.1,1.3-2.8-1.6V170.1a1.1,1.1,0,0,1,.6-1l4.4-2.5c.3-.2.6-.1.6.3v37A1.8,1.8,0,0,1,150.3,204.9Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,206.6h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V170.1a1.9,1.9,0,0,1,.9-1.5l4.3-2.5h1a1.2,1.2,0,0,1,.4.8v37a2.4,2.4,0,0,1-.9,1.5h0l-2.2,1.2Zm-2.3-2.3,2.3,1.3,1.9-1.1a1,1,0,0,0,.4-.7V167.1l-4.2,2.4a.7.7,0,0,0-.4.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_396" data-name="XMLID 396">
            <g id="Vector_32" data-name="Vector 32">
              <path
                class="cls-1"
                d="M153.7,2.6V202.3a1.3,1.3,0,0,1-.6,1.1l-1.6.9a1.3,1.3,0,0,1-1.2,0l-1.6-.9a1.4,1.4,0,0,1-.6-1.1V2.6a1.7,1.7,0,0,1,.6-1l1.6-.9a1.3,1.3,0,0,1,1.2,0l1.6.9A1.7,1.7,0,0,1,153.7,2.6Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M150.9,204.9a1.1,1.1,0,0,1-.8-.2l-1.6-.9a1.9,1.9,0,0,1-.9-1.5V2.6a1.9,1.9,0,0,1,.9-1.5l1.6-.9a2.2,2.2,0,0,1,1.6,0l1.6,1a1.7,1.7,0,0,1,.9,1.4V202.3a1.9,1.9,0,0,1-.9,1.5l-1.6.9A1.1,1.1,0,0,1,150.9,204.9ZM150.9,1h-.3l-1.6.9a.7.7,0,0,0-.4.6V202.3a.8.8,0,0,0,.4.7l1.6.9h.6l1.6-.9a1.6,1.6,0,0,0,.4-.7V2.6c-.1-.2-.2-.5-.4-.6l-1.6-.9Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_395" data-name="XMLID 395">
            <g id="Vector_33" data-name="Vector 33">
              <path
                class="cls-1"
                d="M148.7,1.6l1.6-.9a1.3,1.3,0,0,1,1.2,0l1.6.9a2.1,2.1,0,0,1,.6,1V5.2l-5.3-3.1A.5.5,0,0,1,148.7,1.6Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M153.7,5.7h-.3l-5.3-3.1a.4.4,0,0,1-.2-.5,1.6,1.6,0,0,1,.4-.7h.2l1.6-1a2.2,2.2,0,0,1,1.6,0l1.6,1a1.9,1.9,0,0,1,.9,1.4V5.2c0,.2-.1.3-.3.4Zm-4.6-3.8,4.1,2.4V2.6a.7.7,0,0,0-.4-.6l-1.6-.9h-.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_394" data-name="XMLID 394">
            <g id="Vector_34" data-name="Vector 34">
              <path
                class="cls-1"
                d="M150.9,4.2V203.9c0,.4.3.6.6.4l1.6-.9a1.2,1.2,0,0,0,.7-1.1V2.6c0-.3-.3-.5-.7-.3l-1.6.9A1.7,1.7,0,0,0,150.9,4.2Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M151.3,204.9h-.5a1.5,1.5,0,0,1-.4-.9V4.2a1.9,1.9,0,0,1,.9-1.5l1.6-.9c.5-.2.8-.1.9,0a1,1,0,0,1,.5.8V202.3a1.9,1.9,0,0,1-.9,1.5l-1.6.9Zm2-202.1-1.5.8a.7.7,0,0,0-.4.6V203.8l1.5-.8a.8.8,0,0,0,.4-.7Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_393" data-name="XMLID 393" class="cls-3">
            <g id="Vector_35" data-name="Vector 35" class="cls-3">
              <path
                class="cls-1"
                d="M150.9,4.2V203.9c0,.4.3.6.6.4l1.6-.9a1.2,1.2,0,0,0,.7-1.1V2.6c0-.3-.3-.5-.7-.3l-1.6.9A1.7,1.7,0,0,0,150.9,4.2Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M151.3,204.9h-.5a1.5,1.5,0,0,1-.4-.9V4.2a1.9,1.9,0,0,1,.9-1.5l1.6-.9c.5-.2.8-.1.9,0a1,1,0,0,1,.5.8V202.3a1.9,1.9,0,0,1-.9,1.5l-1.6.9Zm2-202.1-1.5.8a.7.7,0,0,0-.4.6V203.8l1.5-.8a.8.8,0,0,0,.4-.7Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_11" data-name="Group 11">
            <g id="XMLID_392" data-name="XMLID 392">
              <g id="Vector_36" data-name="Vector 36">
                <path
                  class="cls-1"
                  d="M148.7,167.6l4.4-2.6c.3-.1.6,0,.6.4V203l-5.5,3.2V168.6C148.2,168.2,148.4,167.7,148.7,167.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,206.7h-.3c-.1,0-.2-.2-.2-.4V168.6a1.8,1.8,0,0,1,.8-1.5h0l4.3-2.5a.9.9,0,0,1,1.4.8V203c0,.2-.1.4-.3.4l-5.5,3.2ZM149,168a.7.7,0,0,0-.3.6v36.7l4.5-2.6V165.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_391" data-name="XMLID 391" class="cls-3">
              <g id="Vector_37" data-name="Vector 37" class="cls-3">
                <path
                  class="cls-1"
                  d="M148.7,167.6l4.4-2.6c.3-.1.6,0,.6.4V203l-5.5,3.2V168.6C148.2,168.2,148.4,167.7,148.7,167.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,206.7h-.3c-.1,0-.2-.2-.2-.4V168.6a1.8,1.8,0,0,1,.8-1.5h0l4.3-2.5a.9.9,0,0,1,1.4.8V203c0,.2-.1.4-.3.4l-5.5,3.2ZM149,168a.7.7,0,0,0-.3.6v36.7l4.5-2.6V165.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_12" data-name="Group 12">
            <g id="Group_13" data-name="Group 13">
              <g id="XMLID_390" data-name="XMLID 390">
                <g id="Vector_38" data-name="Vector 38">
                  <path
                    class="cls-1"
                    d="M149.6,125.5l-2.7-1.7V95.1l2.7,1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,126h-.3l-2.7-1.7a.5.5,0,0,1-.2-.4V95.1a.5.5,0,0,1,.2-.4h.5l2.7,1.6c.2.1.3.2.3.4v28.8c0,.2-.1.3-.3.4Zm-2.2-2.5,1.7,1.1V97l-1.7-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_389" data-name="XMLID 389" class="cls-4">
                <g id="Vector_39" data-name="Vector 39" class="cls-4">
                  <path
                    class="cls-1"
                    d="M149.6,125.5l-2.7-1.7V95.1l2.7,1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,126h-.3l-2.7-1.7a.5.5,0,0,1-.2-.4V95.1a.5.5,0,0,1,.2-.4h.5l2.7,1.6c.2.1.3.2.3.4v28.8c0,.2-.1.3-.3.4Zm-2.2-2.5,1.7,1.1V97l-1.7-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_14" data-name="Group 14">
              <g id="XMLID_388" data-name="XMLID 388">
                <g id="Vector_40" data-name="Vector 40">
                  <path
                    class="cls-1"
                    d="M146.9,98.3l-2.8-1.6V95.2l1.3.8,1.5-.9Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M146.9,98.8h-.3l-2.8-1.6c-.2,0-.2-.2-.2-.4V95.2c0-.2,0-.4.2-.5h.5l1.1.7,1.2-.7h.5c.2.1.3.2.3.4v3.2c0,.2-.1.4-.3.4Zm-2.3-2.4,1.8,1.1V96l-.7.4h-.6l-.5-.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_387" data-name="XMLID 387" class="cls-4">
                <g id="Vector_41" data-name="Vector 41" class="cls-4">
                  <path
                    class="cls-1"
                    d="M146.9,98.3l-2.8-1.6V95.2l1.3.8,1.5-.9Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M146.9,98.8h-.3l-2.8-1.6c-.2,0-.2-.2-.2-.4V95.2c0-.2,0-.4.2-.5h.5l1.1.7,1.2-.7h.5c.2.1.3.2.3.4v3.2c0,.2-.1.4-.3.4Zm-2.3-2.4,1.8,1.1V96l-.7.4h-.6l-.5-.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_15" data-name="Group 15">
              <g id="XMLID_386" data-name="XMLID 386">
                <g id="Vector_42" data-name="Vector 42">
                  <path class="cls-1" d="M145.4,92.8V96l-2.8-1.6Z" transform="translate(-57.9 0)" />
                  <path
                    d="M145.4,96.5h-.2l-2.8-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.8-1.6h.5a.8.8,0,0,1,.2.5v3.2a.5.5,0,0,1-.2.4Zm-1.8-2.1,1.3.7V93.6Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_385" data-name="XMLID 385" class="cls-4">
                <g id="Vector_43" data-name="Vector 43" class="cls-4">
                  <path class="cls-1" d="M145.4,92.8V96l-2.8-1.6Z" transform="translate(-57.9 0)" />
                  <path
                    d="M145.4,96.5h-.2l-2.8-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.8-1.6h.5a.8.8,0,0,1,.2.5v3.2a.5.5,0,0,1-.2.4Zm-1.8-2.1,1.3.7V93.6Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Group_16" data-name="Group 16">
            <g id="Group_17" data-name="Group 17">
              <g id="XMLID_384" data-name="XMLID 384">
                <g id="Vector_44" data-name="Vector 44">
                  <path
                    class="cls-1"
                    d="M149.6,87l-2.7-1.6V56.7l2.7,1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,87.5h-.3l-2.7-1.6a.5.5,0,0,1-.2-.4V56.7a.5.5,0,0,1,.2-.4h.5l2.7,1.6c.2.1.3.2.3.4V87c0,.2-.1.3-.3.4Zm-2.2-2.4,1.7,1V58.6l-1.7-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_383" data-name="XMLID 383" class="cls-4">
                <g id="Vector_45" data-name="Vector 45" class="cls-4">
                  <path
                    class="cls-1"
                    d="M149.6,87l-2.7-1.6V56.7l2.7,1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,87.5h-.3l-2.7-1.6a.5.5,0,0,1-.2-.4V56.7a.5.5,0,0,1,.2-.4h.5l2.7,1.6c.2.1.3.2.3.4V87c0,.2-.1.3-.3.4Zm-2.2-2.4,1.7,1V58.6l-1.7-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_18" data-name="Group 18">
              <g id="XMLID_382" data-name="XMLID 382">
                <g id="Vector_46" data-name="Vector 46">
                  <path
                    class="cls-1"
                    d="M146.9,59.9l-2.8-1.6V56.8l1.3.7,1.5-.8Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M146.9,60.4h-.3l-2.8-1.6c-.2,0-.2-.2-.2-.4V56.8c0-.2,0-.4.2-.5h.5l1.1.6,1.2-.6h.5c.2.1.3.2.3.4v3.2c0,.2-.1.3-.3.4ZM144.6,58l1.8,1V57.5l-.8.4a.3.3,0,0,1-.4,0l-.6-.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_381" data-name="XMLID 381" class="cls-4">
                <g id="Vector_47" data-name="Vector 47" class="cls-4">
                  <path
                    class="cls-1"
                    d="M146.9,59.9l-2.8-1.6V56.8l1.3.7,1.5-.8Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M146.9,60.4h-.3l-2.8-1.6c-.2,0-.2-.2-.2-.4V56.8c0-.2,0-.4.2-.5h.5l1.1.6,1.2-.6h.5c.2.1.3.2.3.4v3.2c0,.2-.1.3-.3.4ZM144.6,58l1.8,1V57.5l-.8.4a.3.3,0,0,1-.4,0l-.6-.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_19" data-name="Group 19">
              <g id="XMLID_380" data-name="XMLID 380">
                <g id="Vector_48" data-name="Vector 48">
                  <path class="cls-1" d="M145.4,54.3v3.2l-2.8-1.6Z" transform="translate(-57.9 0)" />
                  <path
                    d="M145.4,58c-.1,0-.2,0-.2-.1l-2.8-1.6c-.2,0-.3-.2-.3-.4s.1-.3.3-.4l2.8-1.6a.5.5,0,0,1,.5,0,.5.5,0,0,1,.2.4v3.2c0,.2-.1.4-.2.4Zm-1.8-2.1,1.3.7V55.2Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_379" data-name="XMLID 379" class="cls-4">
                <g id="Vector_49" data-name="Vector 49" class="cls-4">
                  <path class="cls-1" d="M145.4,54.3v3.2l-2.8-1.6Z" transform="translate(-57.9 0)" />
                  <path
                    d="M145.4,58c-.1,0-.2,0-.2-.1l-2.8-1.6c-.2,0-.3-.2-.3-.4s.1-.3.3-.4l2.8-1.6a.5.5,0,0,1,.5,0,.5.5,0,0,1,.2.4v3.2c0,.2-.1.4-.2.4Zm-1.8-2.1,1.3.7V55.2Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Group_20" data-name="Group 20">
            <g id="Group_21" data-name="Group 21">
              <g id="XMLID_378" data-name="XMLID 378">
                <g id="Vector_50" data-name="Vector 50">
                  <path
                    class="cls-1"
                    d="M149.6,55l-2.7-1.6V24.7l2.7,1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,55.5h-.3l-2.7-1.6a.5.5,0,0,1-.2-.4V24.7a.5.5,0,0,1,.2-.4h.5l2.7,1.6c.2.1.3.2.3.4V55c0,.2-.1.3-.3.4Zm-2.2-2.4,1.7,1V26.6l-1.7-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_371" data-name="XMLID 371" class="cls-4">
                <g id="Vector_51" data-name="Vector 51" class="cls-4">
                  <path
                    class="cls-1"
                    d="M149.6,55l-2.7-1.6V24.7l2.7,1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M149.6,55.5h-.3l-2.7-1.6a.5.5,0,0,1-.2-.4V24.7a.5.5,0,0,1,.2-.4h.5l2.7,1.6c.2.1.3.2.3.4V55c0,.2-.1.3-.3.4Zm-2.2-2.4,1.7,1V26.6l-1.7-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_22" data-name="Group 22">
              <g id="XMLID_370" data-name="XMLID 370">
                <g id="Vector_52" data-name="Vector 52">
                  <path
                    class="cls-1"
                    d="M146.9,27.8l-2.8-1.5V24.8l1.3.7,1.5-.8Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M146.9,28.3h-.3l-2.8-1.6a.5.5,0,0,1-.2-.4V24.8c0-.2,0-.4.2-.5h.5l1.1.6,1.2-.6h.5c.2.1.3.2.3.4v3.1a.5.5,0,0,1-.3.5ZM144.6,26l1.8,1V25.5l-.8.4a.3.3,0,0,1-.4,0l-.6-.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_369" data-name="XMLID 369" class="cls-4">
                <g id="Vector_53" data-name="Vector 53" class="cls-4">
                  <path
                    class="cls-1"
                    d="M146.9,27.8l-2.8-1.5V24.8l1.3.7,1.5-.8Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M146.9,28.3h-.3l-2.8-1.6a.5.5,0,0,1-.2-.4V24.8c0-.2,0-.4.2-.5h.5l1.1.6,1.2-.6h.5c.2.1.3.2.3.4v3.1a.5.5,0,0,1-.3.5ZM144.6,26l1.8,1V25.5l-.8.4a.3.3,0,0,1-.4,0l-.6-.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_23" data-name="Group 23">
              <g id="XMLID_368" data-name="XMLID 368">
                <g id="Vector_54" data-name="Vector 54">
                  <path class="cls-1" d="M145.4,22.3v3.2l-2.8-1.6Z" transform="translate(-57.9 0)" />
                  <path
                    d="M145.4,26c-.1,0-.2,0-.2-.1l-2.8-1.6c-.2-.1-.3-.2-.3-.4s.1-.3.3-.4l2.8-1.6h.5a.5.5,0,0,1,.2.4v3.2a.5.5,0,0,1-.2.4Zm-1.8-2.1,1.3.7V23.2Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_367" data-name="XMLID 367" class="cls-4">
                <g id="Vector_55" data-name="Vector 55" class="cls-4">
                  <path class="cls-1" d="M145.4,22.3v3.2l-2.8-1.6Z" transform="translate(-57.9 0)" />
                  <path
                    d="M145.4,26c-.1,0-.2,0-.2-.1l-2.8-1.6c-.2-.1-.3-.2-.3-.4s.1-.3.3-.4l2.8-1.6h.5a.5.5,0,0,1,.2.4v3.2a.5.5,0,0,1-.2.4Zm-1.8-2.1,1.3.7V23.2Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Group_24" data-name="Group 24">
            <g id="Group_25" data-name="Group 25">
              <g id="Group_26" data-name="Group 26">
                <g id="XMLID_366" data-name="XMLID 366">
                  <g id="Vector_56" data-name="Vector 56">
                    <path
                      class="cls-1"
                      d="M149.6,167.1l-2.7-1.6V136.7l2.7,1.7Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M149.6,167.6h-.3l-2.7-1.6-.2-.4V136.7a.5.5,0,0,1,.2-.4h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7c0,.2-.1.3-.3.4Zm-2.2-2.4,1.7,1V138.7l-1.7-1.1Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_365" data-name="XMLID 365" class="cls-2">
                  <g id="Vector_57" data-name="Vector 57" class="cls-2">
                    <path
                      class="cls-1"
                      d="M149.6,167.1l-2.7-1.6V136.7l2.7,1.7Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M149.6,167.6h-.3l-2.7-1.6-.2-.4V136.7a.5.5,0,0,1,.2-.4h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7c0,.2-.1.3-.3.4Zm-2.2-2.4,1.7,1V138.7l-1.7-1.1Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_27" data-name="Group 27">
                <g id="XMLID_364" data-name="XMLID 364">
                  <g id="Vector_58" data-name="Vector 58">
                    <path
                      class="cls-1"
                      d="M146.9,139.9l-2.8-1.5v-1.6l1.3.8,1.5-.9Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M146.9,140.4h-.3l-2.8-1.5a.5.5,0,0,1-.2-.4v-1.6c0-.2,0-.4.2-.5h.5l1.1.7,1.2-.7h.5c.2.1.3.2.3.4V140c0,.2-.1.3-.3.4Zm-2.3-2.3,1.8,1v-1.5l-.7.4h-.6l-.5-.3Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_163" data-name="XMLID 163" class="cls-2">
                  <g id="Vector_59" data-name="Vector 59" class="cls-2">
                    <path
                      class="cls-1"
                      d="M146.9,139.9l-2.8-1.5v-1.6l1.3.8,1.5-.9Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M146.9,140.4h-.3l-2.8-1.5a.5.5,0,0,1-.2-.4v-1.6c0-.2,0-.4.2-.5h.5l1.1.7,1.2-.7h.5c.2.1.3.2.3.4V140c0,.2-.1.3-.3.4Zm-2.3-2.3,1.8,1v-1.5l-.7.4h-.6l-.5-.3Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_28" data-name="Group 28">
                <g id="XMLID_162" data-name="XMLID 162">
                  <g id="Vector_60" data-name="Vector 60">
                    <path
                      class="cls-1"
                      d="M145.4,134.4v3.2l-2.8-1.6Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M145.4,138.1h-.2l-2.8-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.8-1.6h.5a.8.8,0,0,1,.2.5v3.2a.5.5,0,0,1-.2.4Zm-1.8-2.1,1.3.7v-1.5Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_161" data-name="XMLID 161" class="cls-2">
                  <g id="Vector_61" data-name="Vector 61" class="cls-2">
                    <path
                      class="cls-1"
                      d="M145.4,134.4v3.2l-2.8-1.6Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M145.4,138.1h-.2l-2.8-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.8-1.6h.5a.8.8,0,0,1,.2.5v3.2a.5.5,0,0,1-.2.4Zm-1.8-2.1,1.3.7v-1.5Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="XMLID_160" data-name="XMLID 160">
              <g id="Vector_62" data-name="Vector 62">
                <path
                  class="cls-1"
                  d="M150.9,118.4l-2.7-1.6L126,129.6v3.2Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M126,133.3h-.2c-.2-.1-.3-.2-.3-.4v-3.2c0-.2.1-.4.3-.4l22.1-12.9h.5l2.8,1.6a.5.5,0,0,1,.1.7h-.1l-24.9,14.4Zm.5-3.4v2l23.4-13.5-1.7-1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_29" data-name="Group 29">
              <g id="XMLID_159" data-name="XMLID 159">
                <g id="Vector_63" data-name="Vector 63">
                  <path
                    class="cls-1"
                    d="M150.9,166.3l-1.3.8V138.4l-2.7,1.5v-3.2l-1.5.9v-3.2l-13.8,8v3.2l-1.5.8v3.2l-2.7,1.6v28.7l-1.4.7V132.8l24.9-14.4Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M126,181.1h-.2a.5.5,0,0,1-.3-.5V132.8a.5.5,0,0,1,.3-.5L150.7,118h.5a.5.5,0,0,1,.2.4v47.9l-.2.4-1.4.8h-.5a.8.8,0,0,1-.2-.4V139.2l-2,1.1h-.5c-.1,0-.2-.2-.2-.4v-2.3l-.7.4h-.5c-.2-.1-.3-.2-.3-.4v-2.4l-12.8,7.5v2.9c0,.2-.1.3-.3.4l-1.2.7v2.9a.5.5,0,0,1-.3.5l-2.4,1.3v28.5a.5.5,0,0,1-.3.5l-1.3.7Zm.5-48v46.7l.4-.2V151.2a.5.5,0,0,1,.3-.5l2.4-1.4v-2.9c0-.2.1-.3.3-.4l1.2-.7v-2.9a.8.8,0,0,1,.2-.5l13.9-8h.5a.8.8,0,0,1,.2.5v2.3l.7-.4h.5c.2.1.3.2.3.4v2.4l1.9-1.2h.5a.5.5,0,0,1,.3.5v27.8l.3-.2V119.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_158" data-name="XMLID 158" class="cls-3">
                <g id="Vector_64" data-name="Vector 64" class="cls-3">
                  <path
                    class="cls-1"
                    d="M150.9,166.3l-1.3.8V138.4l-2.7,1.5v-3.2l-1.5.9v-3.2l-13.8,8v3.2l-1.5.8v3.2l-2.7,1.6v28.7l-1.4.7V132.8l24.9-14.4Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M126,181.1h-.2a.5.5,0,0,1-.3-.5V132.8a.5.5,0,0,1,.3-.5L150.7,118h.5a.5.5,0,0,1,.2.4v47.9l-.2.4-1.4.8h-.5a.8.8,0,0,1-.2-.4V139.2l-2,1.1h-.5c-.1,0-.2-.2-.2-.4v-2.3l-.7.4h-.5c-.2-.1-.3-.2-.3-.4v-2.4l-12.8,7.5v2.9c0,.2-.1.3-.3.4l-1.2.7v2.9a.5.5,0,0,1-.3.5l-2.4,1.3v28.5a.5.5,0,0,1-.3.5l-1.3.7Zm.5-48v46.7l.4-.2V151.2a.5.5,0,0,1,.3-.5l2.4-1.4v-2.9c0-.2.1-.3.3-.4l1.2-.7v-2.9a.8.8,0,0,1,.2-.5l13.9-8h.5a.8.8,0,0,1,.2.5v2.3l.7-.4h.5c.2.1.3.2.3.4v2.4l1.9-1.2h.5a.5.5,0,0,1,.3.5v27.8l.3-.2V119.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_30" data-name="Group 30">
              <g id="XMLID_157" data-name="XMLID 157">
                <g id="Vector_65" data-name="Vector 65">
                  <path
                    class="cls-1"
                    d="M128.8,141.9h.2l19.4-11.2a.4.4,0,0,0,.1-.5c-.1-.2-.4-.3-.5-.1h-.1l-19.3,11.1c-.2.2-.3.4-.2.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M128.8,142.4a.8.8,0,0,1-.7-.4H128a.9.9,0,0,1-.1-.7c0-.2.2-.4.4-.6l19.4-11.2h.6a.8.8,0,0,1,.6.4.9.9,0,0,1,.1.7.7.7,0,0,1-.4.5l-19.3,11.2Zm0-.8Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_156" data-name="XMLID 156" class="cls-5">
                <g id="Vector_66" data-name="Vector 66" class="cls-5">
                  <path
                    class="cls-1"
                    d="M128.8,141.9h.2l19.4-11.2a.4.4,0,0,0,.1-.5c-.1-.2-.4-.3-.5-.1h-.1l-19.3,11.1c-.2.2-.3.4-.2.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M128.8,142.4a.8.8,0,0,1-.7-.4H128a.9.9,0,0,1-.1-.7c0-.2.2-.4.4-.6l19.4-11.2h.6a.8.8,0,0,1,.6.4.9.9,0,0,1,.1.7.7.7,0,0,1-.4.5l-19.3,11.2Zm0-.8Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_31" data-name="Group 31">
              <g id="XMLID_153" data-name="XMLID 153">
                <g id="XMLID_155" data-name="XMLID 155">
                  <g id="Vector_67" data-name="Vector 67">
                    <path
                      class="cls-1"
                      d="M148.2,128.3a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,1,0-.6,0h0V128a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M148.2,128.8a.9.9,0,0,1-.8-.8h0v-4.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V128A.9.9,0,0,1,148.2,128.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_32" data-name="Group 32">
                  <g id="Vector_68" data-name="Vector 68">
                    <path
                      class="cls-1"
                      d="M146,129.5a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M146,130a.9.9,0,0,1-.8-.8h0v-4.8a.8.8,0,1,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_33" data-name="Group 33">
                  <g id="Vector_69" data-name="Vector 69">
                    <path
                      class="cls-1"
                      d="M143.9,130.8c.2,0,.3-.2.3-.4v-4.7c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.7C143.6,130.6,143.7,130.8,143.9,130.8Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M143.9,131.3a.9.9,0,0,1-.8-.8h0v-4.7c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,143.9,131.3Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_34" data-name="Group 34">
                  <g id="Vector_70" data-name="Vector 70">
                    <path
                      class="cls-1"
                      d="M141.7,132a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M141.7,132.5a.9.9,0,0,1-.8-.8h0v-4.8a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_35" data-name="Group 35">
                  <g id="Vector_71" data-name="Vector 71">
                    <path
                      class="cls-1"
                      d="M139.6,133.3a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,1,0-.6,0V133a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M139.6,133.8a.9.9,0,0,1-.8-.8h0v-4.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V133A.9.9,0,0,1,139.6,133.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_36" data-name="Group 36">
                  <g id="Vector_72" data-name="Vector 72">
                    <path
                      class="cls-1"
                      d="M137.4,134.5a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M137.4,135a.9.9,0,0,1-.8-.8h0v-4.8a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_37" data-name="Group 37">
                  <g id="Vector_73" data-name="Vector 73">
                    <path
                      class="cls-1"
                      d="M135.3,135.7a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M135.3,136.2c-.4.1-.7-.2-.8-.6v-5a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8v4.8a.9.9,0,0,1-.8.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_38" data-name="Group 38">
                  <g id="Vector_74" data-name="Vector 74">
                    <path
                      class="cls-1"
                      d="M133.1,137a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M133.1,137.5a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_39" data-name="Group 39">
                  <g id="Vector_75" data-name="Vector 75">
                    <path
                      class="cls-1"
                      d="M131,138.3c.2,0,.3-.2.3-.4v-4.7c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.7C130.7,138.1,130.8,138.3,131,138.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M131,138.8a.9.9,0,0,1-.8-.9v-4.7c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,131,138.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_154" data-name="XMLID 154">
                  <g id="Vector_76" data-name="Vector 76">
                    <path
                      class="cls-1"
                      d="M128.8,139.5a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M128.8,140a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_150" data-name="XMLID 150" class="cls-4">
                <g id="XMLID_152" data-name="XMLID 152" class="cls-4">
                  <g id="Vector_77" data-name="Vector 77" class="cls-4">
                    <path
                      class="cls-1"
                      d="M148.2,128.3a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,1,0-.6,0h0V128a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M148.2,128.8a.9.9,0,0,1-.8-.8h0v-4.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V128A.9.9,0,0,1,148.2,128.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_40" data-name="Group 40" class="cls-4">
                  <g id="Vector_78" data-name="Vector 78" class="cls-4">
                    <path
                      class="cls-1"
                      d="M146,129.5a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M146,130a.9.9,0,0,1-.8-.8h0v-4.8a.8.8,0,1,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_41" data-name="Group 41" class="cls-4">
                  <g id="Vector_79" data-name="Vector 79" class="cls-4">
                    <path
                      class="cls-1"
                      d="M143.9,130.8c.2,0,.3-.2.3-.4v-4.7c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.7C143.6,130.6,143.7,130.8,143.9,130.8Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M143.9,131.3a.9.9,0,0,1-.8-.8h0v-4.7c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,143.9,131.3Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_42" data-name="Group 42" class="cls-4">
                  <g id="Vector_80" data-name="Vector 80" class="cls-4">
                    <path
                      class="cls-1"
                      d="M141.7,132a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M141.7,132.5a.9.9,0,0,1-.8-.8h0v-4.8a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_43" data-name="Group 43" class="cls-4">
                  <g id="Vector_81" data-name="Vector 81" class="cls-4">
                    <path
                      class="cls-1"
                      d="M139.6,133.3a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,1,0-.6,0V133a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M139.6,133.8a.9.9,0,0,1-.8-.8h0v-4.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V133A.9.9,0,0,1,139.6,133.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_44" data-name="Group 44" class="cls-4">
                  <g id="Vector_82" data-name="Vector 82" class="cls-4">
                    <path
                      class="cls-1"
                      d="M137.4,134.5a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M137.4,135a.9.9,0,0,1-.8-.8h0v-4.8a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_45" data-name="Group 45" class="cls-4">
                  <g id="Vector_83" data-name="Vector 83" class="cls-4">
                    <path
                      class="cls-1"
                      d="M135.3,135.7a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M135.3,136.2c-.4.1-.7-.2-.8-.6v-5a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8v4.8a.9.9,0,0,1-.8.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_46" data-name="Group 46" class="cls-4">
                  <g id="Vector_84" data-name="Vector 84" class="cls-4">
                    <path
                      class="cls-1"
                      d="M133.1,137a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M133.1,137.5a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_47" data-name="Group 47" class="cls-4">
                  <g id="Vector_85" data-name="Vector 85" class="cls-4">
                    <path
                      class="cls-1"
                      d="M131,138.3c.2,0,.3-.2.3-.4v-4.7c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.7C130.7,138.1,130.8,138.3,131,138.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M131,138.8a.9.9,0,0,1-.8-.9v-4.7c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,131,138.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_151" data-name="XMLID 151" class="cls-4">
                  <g id="Vector_86" data-name="Vector 86" class="cls-4">
                    <path
                      class="cls-1"
                      d="M128.8,139.5a.3.3,0,0,0,.3-.3h0v-4.8a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M128.8,140a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Vector_87" data-name="Vector 87">
            <path
              class="cls-1"
              d="M150.9,76.9l-2.7-1.6L126,88.1v3.2Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M126,91.8h-.2c-.2-.1-.3-.2-.3-.4V88.1c0-.2.1-.3.3-.4l22.1-12.8h.5l2.8,1.6a.5.5,0,0,1,.2.4.8.8,0,0,1-.2.5L126.3,91.7Zm.5-3.4v2l23.4-13.5-1.7-1Z"
              transform="translate(-57.9 0)"
            />
          </g>
          <g id="Group_48" data-name="Group 48">
            <g id="Vector_88" data-name="Vector 88">
              <path
                class="cls-1"
                d="M150.9,118.4l-1.3.8V96.8l-2.7,1.6V95.2l-1.5.9V92.9l-13.8,8v3.2l-1.5.8v3.2l-2.7,1.6V132l-1.4.8V91.3l24.9-14.4Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M126,133.3h-.2c-.2-.1-.3-.2-.3-.4V91.3c0-.2.1-.3.3-.4l24.9-14.4h.5a.5.5,0,0,1,.2.4v41.5a.5.5,0,0,1-.2.4l-1.4.8h-.5a.5.5,0,0,1-.2-.4V97.7l-2,1.2h-.5a.8.8,0,0,1-.2-.5V96.1l-.7.4h-.5c-.2-.1-.3-.2-.3-.4V93.8l-12.8,7.4v2.9c0,.2-.1.3-.3.4l-1.2.7v2.9a.5.5,0,0,1-.3.5l-2.4,1.4v22a.5.5,0,0,1-.3.5l-1.3.7Zm.5-41.7v40.3l.4-.2v-22a.5.5,0,0,1,.3-.5l2.4-1.3v-3c0-.2.1-.3.3-.4l1.2-.7v-2.9c0-.2.1-.4.2-.4l13.9-8h.5a.5.5,0,0,1,.2.4v2.3l.7-.4h.5c.2.1.3.2.3.4v2.4l1.9-1.2h.5c.2.1.3.2.3.4v21.5l.3-.2V77.8Z"
                transform="translate(-57.9 0)"
              />
            </g>
            <g id="Vector_89" data-name="Vector 89" class="cls-3">
              <path
                class="cls-1"
                d="M150.9,118.4l-1.3.8V96.8l-2.7,1.6V95.2l-1.5.9V92.9l-13.8,8v3.2l-1.5.8v3.2l-2.7,1.6V132l-1.4.8V91.3l24.9-14.4Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M126,133.3h-.2c-.2-.1-.3-.2-.3-.4V91.3c0-.2.1-.3.3-.4l24.9-14.4h.5a.5.5,0,0,1,.2.4v41.5a.5.5,0,0,1-.2.4l-1.4.8h-.5a.5.5,0,0,1-.2-.4V97.7l-2,1.2h-.5a.8.8,0,0,1-.2-.5V96.1l-.7.4h-.5c-.2-.1-.3-.2-.3-.4V93.8l-12.8,7.4v2.9c0,.2-.1.3-.3.4l-1.2.7v2.9a.5.5,0,0,1-.3.5l-2.4,1.4v22a.5.5,0,0,1-.3.5l-1.3.7Zm.5-41.7v40.3l.4-.2v-22a.5.5,0,0,1,.3-.5l2.4-1.3v-3c0-.2.1-.3.3-.4l1.2-.7v-2.9c0-.2.1-.4.2-.4l13.9-8h.5a.5.5,0,0,1,.2.4v2.3l.7-.4h.5c.2.1.3.2.3.4v2.4l1.9-1.2h.5c.2.1.3.2.3.4v21.5l.3-.2V77.8Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_49" data-name="Group 49">
            <g id="Vector_90" data-name="Vector 90">
              <path
                class="cls-1"
                d="M128.8,100.3h.2l19.4-11.2c.2-.1.2-.4.1-.6s-.4-.2-.6-.1L128.6,99.6a.5.5,0,0,0-.2.6Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M128.8,100.8a.9.9,0,0,1-.8-.4.9.9,0,0,1-.1-.7,1,1,0,0,1,.4-.5L147.7,88a.7.7,0,0,1,.6-.1.7.7,0,0,1,.6.4.7.7,0,0,1,.1.6.7.7,0,0,1-.4.6l-19.3,11.2Zm0-1v.2h0Z"
                transform="translate(-57.9 0)"
              />
            </g>
            <g id="Vector_91" data-name="Vector 91" class="cls-5">
              <path
                class="cls-1"
                d="M128.8,100.3h.2l19.4-11.2c.2-.1.2-.4.1-.6s-.4-.2-.6-.1L128.6,99.6a.5.5,0,0,0-.2.6Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M128.8,100.8a.9.9,0,0,1-.8-.4.9.9,0,0,1-.1-.7,1,1,0,0,1,.4-.5L147.7,88a.7.7,0,0,1,.6-.1.7.7,0,0,1,.6.4.7.7,0,0,1,.1.6.7.7,0,0,1-.4.6l-19.3,11.2Zm0-1v.2h0Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_50" data-name="Group 50">
            <g id="XMLID_149" data-name="XMLID 149">
              <g id="Vector_92" data-name="Vector 92">
                <path
                  class="cls-1"
                  d="M148.2,86.8a.3.3,0,0,0,.3-.3h0V81.7a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,148.2,86.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,87.3c-.4.1-.7-.2-.8-.6v-5a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,148.2,87.3Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_51" data-name="Group 51">
              <g id="Vector_93" data-name="Vector 93">
                <path
                  class="cls-1"
                  d="M146,88a.3.3,0,0,0,.3-.3h0V82.9a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,146,88Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M146,88.5a.9.9,0,0,1-.8-.8h0V82.9a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_52" data-name="Group 52">
              <g id="Vector_94" data-name="Vector 94">
                <path
                  class="cls-1"
                  d="M143.9,89.3a.3.3,0,0,0,.3-.3h0V84.2a.3.3,0,0,0-.6,0h0V89A.3.3,0,0,0,143.9,89.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M143.9,89.8a.9.9,0,0,1-.8-.8h0V84.2c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V89A.9.9,0,0,1,143.9,89.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_53" data-name="Group 53">
              <g id="Vector_95" data-name="Vector 95">
                <path
                  class="cls-1"
                  d="M141.7,90.6a.3.3,0,0,0,.3-.3h0V85.5a.3.3,0,1,0-.6,0h0v4.8A.3.3,0,0,0,141.7,90.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M141.7,91.1a.9.9,0,0,1-.8-.8V85.5a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5A.9.9,0,0,1,141.7,91.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_54" data-name="Group 54">
              <g id="Vector_96" data-name="Vector 96">
                <path
                  class="cls-1"
                  d="M139.6,91.8a.3.3,0,0,0,.3-.3h0V86.7a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,139.6,91.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M139.6,92.3a.9.9,0,0,1-.8-.8h0V86.7c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8A.9.9,0,0,1,139.6,92.3Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_55" data-name="Group 55">
              <g id="Vector_97" data-name="Vector 97">
                <path
                  class="cls-1"
                  d="M137.4,93a.3.3,0,0,0,.3-.3h0V87.9a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,137.4,93Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M137.4,93.5a.9.9,0,0,1-.8-.8h0V87.9a.8.8,0,1,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_56" data-name="Group 56">
              <g id="Vector_98" data-name="Vector 98">
                <path
                  class="cls-1"
                  d="M135.3,94.3c.2,0,.3-.2.3-.4V89.2c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.7C135,94.1,135.1,94.3,135.3,94.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M135.3,94.8a.9.9,0,0,1-.8-.8h0V89.2c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,135.3,94.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_57" data-name="Group 57">
              <g id="Vector_99" data-name="Vector 99">
                <path
                  class="cls-1"
                  d="M133.1,95.5a.3.3,0,0,0,.3-.3h0V90.4a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,133.1,95.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M133.1,96a.9.9,0,0,1-.8-.8V90.4a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5A.9.9,0,0,1,133.1,96Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_58" data-name="Group 58">
              <g id="Vector_100" data-name="Vector 100">
                <path
                  class="cls-1"
                  d="M131,96.8a.3.3,0,0,0,.3-.3h0V91.7a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0v4.8A.3.3,0,0,0,131,96.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M131,97.3a.9.9,0,0,1-.8-.8V91.7c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8A.9.9,0,0,1,131,97.3Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_148" data-name="XMLID 148">
              <g id="Vector_101" data-name="Vector 101">
                <path
                  class="cls-1"
                  d="M128.8,98a.3.3,0,0,0,.3-.3h0V92.9a.3.3,0,1,0-.6,0h0v4.8A.3.3,0,0,0,128.8,98Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,98.5a.9.9,0,0,1-.8-.8h0V92.9a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_147" data-name="XMLID 147" class="cls-4">
              <g id="Vector_102" data-name="Vector 102" class="cls-4">
                <path
                  class="cls-1"
                  d="M148.2,86.8a.3.3,0,0,0,.3-.3h0V81.7a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,148.2,86.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,87.3c-.4.1-.7-.2-.8-.6v-5a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,148.2,87.3Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_59" data-name="Group 59" class="cls-4">
              <g id="Vector_103" data-name="Vector 103" class="cls-4">
                <path
                  class="cls-1"
                  d="M146,88a.3.3,0,0,0,.3-.3h0V82.9a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,146,88Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M146,88.5a.9.9,0,0,1-.8-.8h0V82.9a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_60" data-name="Group 60" class="cls-4">
              <g id="Vector_104" data-name="Vector 104" class="cls-4">
                <path
                  class="cls-1"
                  d="M143.9,89.3a.3.3,0,0,0,.3-.3h0V84.2a.3.3,0,0,0-.6,0h0V89A.3.3,0,0,0,143.9,89.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M143.9,89.8a.9.9,0,0,1-.8-.8h0V84.2c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V89A.9.9,0,0,1,143.9,89.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_61" data-name="Group 61" class="cls-4">
              <g id="Vector_105" data-name="Vector 105" class="cls-4">
                <path
                  class="cls-1"
                  d="M141.7,90.6a.3.3,0,0,0,.3-.3h0V85.5a.3.3,0,1,0-.6,0h0v4.8A.3.3,0,0,0,141.7,90.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M141.7,91.1a.9.9,0,0,1-.8-.8V85.5a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5A.9.9,0,0,1,141.7,91.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_62" data-name="Group 62" class="cls-4">
              <g id="Vector_106" data-name="Vector 106" class="cls-4">
                <path
                  class="cls-1"
                  d="M139.6,91.8a.3.3,0,0,0,.3-.3h0V86.7a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,139.6,91.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M139.6,92.3a.9.9,0,0,1-.8-.8h0V86.7c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8A.9.9,0,0,1,139.6,92.3Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_63" data-name="Group 63" class="cls-4">
              <g id="Vector_107" data-name="Vector 107" class="cls-4">
                <path
                  class="cls-1"
                  d="M137.4,93a.3.3,0,0,0,.3-.3h0V87.9a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,137.4,93Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M137.4,93.5a.9.9,0,0,1-.8-.8h0V87.9a.8.8,0,1,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_64" data-name="Group 64" class="cls-4">
              <g id="Vector_108" data-name="Vector 108" class="cls-4">
                <path
                  class="cls-1"
                  d="M135.3,94.3c.2,0,.3-.2.3-.4V89.2c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.7C135,94.1,135.1,94.3,135.3,94.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M135.3,94.8a.9.9,0,0,1-.8-.8h0V89.2c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,135.3,94.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_65" data-name="Group 65" class="cls-4">
              <g id="Vector_109" data-name="Vector 109" class="cls-4">
                <path
                  class="cls-1"
                  d="M133.1,95.5a.3.3,0,0,0,.3-.3h0V90.4a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,133.1,95.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M133.1,96a.9.9,0,0,1-.8-.8V90.4a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5A.9.9,0,0,1,133.1,96Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_66" data-name="Group 66" class="cls-4">
              <g id="Vector_110" data-name="Vector 110" class="cls-4">
                <path
                  class="cls-1"
                  d="M131,96.8a.3.3,0,0,0,.3-.3h0V91.7a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0v4.8A.3.3,0,0,0,131,96.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M131,97.3a.9.9,0,0,1-.8-.8V91.7c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8A.9.9,0,0,1,131,97.3Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_146" data-name="XMLID 146" class="cls-4">
              <g id="Vector_111" data-name="Vector 111" class="cls-4">
                <path
                  class="cls-1"
                  d="M128.8,98a.3.3,0,0,0,.3-.3h0V92.9a.3.3,0,1,0-.6,0h0v4.8A.3.3,0,0,0,128.8,98Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,98.5a.9.9,0,0,1-.8-.8h0V92.9a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_145" data-name="XMLID 145">
            <g id="Vector_112" data-name="Vector 112">
              <path
                class="cls-1"
                d="M150.9,38.6,148.2,37,126,49.8V53Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M126,53.5h-.2a.5.5,0,0,1-.3-.5V49.8c0-.2.1-.3.3-.4l22.1-12.8a.5.5,0,0,1,.5,0l2.8,1.6a.6.6,0,0,1,.1.8h-.1L126.3,53.5Zm.5-3.4v2.1l23.4-13.6-1.7-1Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_67" data-name="Group 67">
            <g id="Vector_113" data-name="Vector 113">
              <path
                class="cls-1"
                d="M150.9,76.9l-1.3.8V58.6l-2.7,1.6V57l-1.5.8V54.6l-13.8,8v3.1l-1.5.9v3.2l-2.7,1.6V90.5l-1.4.8V53l24.9-14.4Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M126,91.8h-.2c-.2,0-.3-.2-.3-.4V53c0-.2.1-.3.3-.4l24.9-14.4h.5a.8.8,0,0,1,.2.4V76.9a.8.8,0,0,1-.2.5l-1.4.8h-.5a.8.8,0,0,1-.2-.5V59.4l-2,1.2h-.5l-.2-.4V57.8l-.7.4h-.5a.5.5,0,0,1-.3-.5V55.5l-12.8,7.4v2.8a.5.5,0,0,1-.3.5l-1.2.7v2.9a.5.5,0,0,1-.2.4l-2.5,1.5V90.5a.5.5,0,0,1-.2.4l-1.4.8Zm.5-38.5V90.4l.4-.2V71.4a.5.5,0,0,1,.2-.4l2.5-1.5V66.6c0-.2.1-.3.3-.4l1.2-.7V62.6a.5.5,0,0,1,.2-.4l13.9-8h.5a.5.5,0,0,1,.2.4v2.3l.7-.4a.5.5,0,0,1,.5,0,.5.5,0,0,1,.3.5v2.3l1.9-1.2a.5.5,0,0,1,.5,0,.5.5,0,0,1,.3.5V76.8l.3-.2V39.5Z"
                transform="translate(-57.9 0)"
              />
            </g>
            <g id="XMLID_144" data-name="XMLID 144" class="cls-3">
              <g id="Vector_114" data-name="Vector 114" class="cls-3">
                <path
                  class="cls-1"
                  d="M150.9,76.9l-1.3.8V58.6l-2.7,1.6V57l-1.5.8V54.6l-13.8,8v3.1l-1.5.9v3.2l-2.7,1.6V90.5l-1.4.8V53l24.9-14.4Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M126,91.8h-.2c-.2,0-.3-.2-.3-.4V53c0-.2.1-.3.3-.4l24.9-14.4h.5a.8.8,0,0,1,.2.4V76.9a.8.8,0,0,1-.2.5l-1.4.8h-.5a.8.8,0,0,1-.2-.5V59.4l-2,1.2h-.5l-.2-.4V57.8l-.7.4h-.5a.5.5,0,0,1-.3-.5V55.5l-12.8,7.4v2.8a.5.5,0,0,1-.3.5l-1.2.7v2.9a.5.5,0,0,1-.2.4l-2.5,1.5V90.5a.5.5,0,0,1-.2.4l-1.4.8Zm.5-38.5V90.4l.4-.2V71.4a.5.5,0,0,1,.2-.4l2.5-1.5V66.6c0-.2.1-.3.3-.4l1.2-.7V62.6a.5.5,0,0,1,.2-.4l13.9-8h.5a.5.5,0,0,1,.2.4v2.3l.7-.4a.5.5,0,0,1,.5,0,.5.5,0,0,1,.3.5v2.3l1.9-1.2a.5.5,0,0,1,.5,0,.5.5,0,0,1,.3.5V76.8l.3-.2V39.5Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_68" data-name="Group 68">
            <g id="XMLID_143" data-name="XMLID 143">
              <g id="Vector_115" data-name="Vector 115">
                <path
                  class="cls-1"
                  d="M128.8,62.1h.2l19.4-11.2c.1-.1.2-.4.1-.5a.5.5,0,0,0-.6-.2L128.6,61.3a.5.5,0,0,0-.2.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,62.6a1,1,0,0,1-.8-.5.7.7,0,0,1-.1-.6.8.8,0,0,1,.4-.6l19.4-11.2a.7.7,0,0,1,.6-.1.9.9,0,0,1,.7,1.1h0a.7.7,0,0,1-.4.5L129.3,62.4Zm0-1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_142" data-name="XMLID 142" class="cls-5">
              <g id="Vector_116" data-name="Vector 116" class="cls-5">
                <path
                  class="cls-1"
                  d="M128.8,62.1h.2l19.4-11.2c.1-.1.2-.4.1-.5a.5.5,0,0,0-.6-.2L128.6,61.3a.5.5,0,0,0-.2.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,62.6a1,1,0,0,1-.8-.5.7.7,0,0,1-.1-.6.8.8,0,0,1,.4-.6l19.4-11.2a.7.7,0,0,1,.6-.1.9.9,0,0,1,.7,1.1h0a.7.7,0,0,1-.4.5L129.3,62.4Zm0-1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_141" data-name="XMLID 141">
            <g id="Vector_117" data-name="Vector 117">
              <path
                class="cls-1"
                d="M150.9,6.8l-2.7-1.6-22.8,13,.6,2.9Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M126,21.6h-.2c-.1,0-.2-.2-.2-.3l-.7-2.8a.7.7,0,0,1,.3-.6L147.9,4.7h.5l2.8,1.6a.8.8,0,0,1,.2.5.8.8,0,0,1-.2.4L126.3,21.5Zm0-3.1.4,1.8L149.9,6.8l-1.7-1.1Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_140" data-name="XMLID 140">
            <g id="Vector_118" data-name="Vector 118">
              <path
                class="cls-1"
                d="M150.9,38.6l-1.3.8V26.7l-2.7,1.5V25.1l-1.5.8V22.7l-13.8,8v3.2l-1.5.8v3.2l-2.7,1.5V52.2L126,53V21.1L150.9,6.8Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M126,53.5h-.2a.5.5,0,0,1-.3-.5V21.1a.5.5,0,0,1,.3-.5L150.7,6.3h.5a.8.8,0,0,1,.2.5V38.6a.8.8,0,0,1-.2.5l-1.4.8a.5.5,0,0,1-.5,0,.8.8,0,0,1-.2-.5V27.5l-2,1.1h-.5a.5.5,0,0,1-.2-.4V25.9l-.8.4h-.5a.8.8,0,0,1-.2-.4V23.5l-12.8,7.4v3c0,.2-.1.3-.3.4l-1.2.7v2.9c0,.2-.1.4-.3.4l-2.4,1.4V52.2a.8.8,0,0,1-.2.5l-1.4.8Zm.5-32.1V52.1l.4-.2V39.4c0-.2.1-.3.3-.4l2.4-1.4V34.7c0-.2.1-.3.3-.4l1.2-.7V30.7a.8.8,0,0,1,.2-.5l13.9-8h.5a.8.8,0,0,1,.2.5V25l.7-.4h.5a.5.5,0,0,1,.3.5v2.2l1.9-1.1h.5a.5.5,0,0,1,.3.5V38.6l.3-.2V7.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_139" data-name="XMLID 139" class="cls-3">
            <g id="Vector_119" data-name="Vector 119" class="cls-3">
              <path
                class="cls-1"
                d="M150.9,38.6l-1.3.8V26.7l-2.7,1.5V25.1l-1.5.8V22.7l-13.8,8v3.2l-1.5.8v3.2l-2.7,1.5V52.2L126,53V21.1L150.9,6.8Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M126,53.5h-.2a.5.5,0,0,1-.3-.5V21.1a.5.5,0,0,1,.3-.5L150.7,6.3h.5a.8.8,0,0,1,.2.5V38.6a.8.8,0,0,1-.2.5l-1.4.8a.5.5,0,0,1-.5,0,.8.8,0,0,1-.2-.5V27.5l-2,1.1h-.5a.5.5,0,0,1-.2-.4V25.9l-.8.4h-.5a.8.8,0,0,1-.2-.4V23.5l-12.8,7.4v3c0,.2-.1.3-.3.4l-1.2.7v2.9c0,.2-.1.4-.3.4l-2.4,1.4V52.2a.8.8,0,0,1-.2.5l-1.4.8Zm.5-32.1V52.1l.4-.2V39.4c0-.2.1-.3.3-.4l2.4-1.4V34.7c0-.2.1-.3.3-.4l1.2-.7V30.7a.8.8,0,0,1,.2-.5l13.9-8h.5a.8.8,0,0,1,.2.5V25l.7-.4h.5a.5.5,0,0,1,.3.5v2.2l1.9-1.1h.5a.5.5,0,0,1,.3.5V38.6l.3-.2V7.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_69" data-name="Group 69">
            <g id="XMLID_138" data-name="XMLID 138">
              <g id="Vector_120" data-name="Vector 120">
                <path
                  class="cls-1"
                  d="M128.8,30.2h.2L148.4,19a.4.4,0,0,0,.1-.5.5.5,0,0,0-.6-.2L128.6,29.4c-.2.2-.3.4-.2.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,30.7a1,1,0,0,1-.8-.5.7.7,0,0,1-.1-.6.8.8,0,0,1,.4-.6l19.4-11.2h.6a.9.9,0,0,1,.7,1.1h0a.7.7,0,0,1-.4.5L129.3,30.5Zm0-1v.2h0Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_137" data-name="XMLID 137" class="cls-5">
              <g id="Vector_121" data-name="Vector 121" class="cls-5">
                <path
                  class="cls-1"
                  d="M128.8,30.2h.2L148.4,19a.4.4,0,0,0,.1-.5.5.5,0,0,0-.6-.2L128.6,29.4c-.2.2-.3.4-.2.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,30.7a1,1,0,0,1-.8-.5.7.7,0,0,1-.1-.6.8.8,0,0,1,.4-.6l19.4-11.2h.6a.9.9,0,0,1,.7,1.1h0a.7.7,0,0,1-.4.5L129.3,30.5Zm0-1v.2h0Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_70" data-name="Group 70">
            <g id="XMLID_136" data-name="XMLID 136">
              <g id="Vector_122" data-name="Vector 122">
                <path
                  class="cls-1"
                  d="M148.2,48.4a.3.3,0,0,0,.3-.3h0V43.3a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,48.9a.9.9,0,0,1-.8-.8h0V43.3a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_71" data-name="Group 71">
              <g id="Vector_123" data-name="Vector 123">
                <path
                  class="cls-1"
                  d="M146,49.6a.3.3,0,0,0,.3-.3h0V44.5a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M146,50.1a.9.9,0,0,1-.8-.8h0V44.5a.8.8,0,1,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_72" data-name="Group 72">
              <g id="Vector_124" data-name="Vector 124">
                <path
                  class="cls-1"
                  d="M143.9,50.9a.3.3,0,0,0,.3-.3h0V45.8a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M143.9,51.4a.9.9,0,0,1-.8-.8h0V45.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8A.9.9,0,0,1,143.9,51.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_73" data-name="Group 73">
              <g id="Vector_125" data-name="Vector 125">
                <path
                  class="cls-1"
                  d="M141.7,52.1a.3.3,0,0,0,.3-.3h0V47a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M141.7,52.6a.9.9,0,0,1-.8-.8h0V47a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_74" data-name="Group 74">
              <g id="Vector_126" data-name="Vector 126">
                <path
                  class="cls-1"
                  d="M139.6,53.3a.3.3,0,0,0,.3-.3h0V48.2a.3.3,0,1,0-.6,0v4.9C139.3,53.2,139.4,53.3,139.6,53.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M139.6,53.8c-.4.1-.7-.2-.8-.6h0V48.2a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8V53a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_75" data-name="Group 75">
              <g id="Vector_127" data-name="Vector 127">
                <path
                  class="cls-1"
                  d="M137.4,54.6a.3.3,0,0,0,.3-.3h0V49.5a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M137.4,55.1a.9.9,0,0,1-.8-.8h0V49.5a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_76" data-name="Group 76">
              <g id="Vector_128" data-name="Vector 128">
                <path
                  class="cls-1"
                  d="M135.3,55.9c.2,0,.3-.2.3-.4V50.8c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.7C135,55.7,135.1,55.9,135.3,55.9Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M135.3,56.4a.9.9,0,0,1-.8-.8h0V50.8c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,135.3,56.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_77" data-name="Group 77">
              <g id="Vector_129" data-name="Vector 129">
                <path
                  class="cls-1"
                  d="M133.1,57.1a.3.3,0,0,0,.3-.3h0V52a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M133.1,57.6a.9.9,0,0,1-.8-.8V52a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_78" data-name="Group 78">
              <g id="Vector_130" data-name="Vector 130">
                <path
                  class="cls-1"
                  d="M131,58.3a.3.3,0,0,0,.3-.3h0V53.2a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0V58a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M131,58.8c-.4.1-.7-.2-.8-.6v-5c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V58a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_135" data-name="XMLID 135">
              <g id="Vector_131" data-name="Vector 131">
                <path
                  class="cls-1"
                  d="M128.8,59.5a.3.3,0,0,0,.3-.3h0V54.4a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,60a.9.9,0,0,1-.8-.8h0V54.4a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_134" data-name="XMLID 134" class="cls-4">
              <g id="Vector_132" data-name="Vector 132" class="cls-4">
                <path
                  class="cls-1"
                  d="M148.2,48.4a.3.3,0,0,0,.3-.3h0V43.3a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,48.9a.9.9,0,0,1-.8-.8h0V43.3a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_79" data-name="Group 79" class="cls-4">
              <g id="Vector_133" data-name="Vector 133" class="cls-4">
                <path
                  class="cls-1"
                  d="M146,49.6a.3.3,0,0,0,.3-.3h0V44.5a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M146,50.1a.9.9,0,0,1-.8-.8h0V44.5a.8.8,0,1,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_80" data-name="Group 80" class="cls-4">
              <g id="Vector_134" data-name="Vector 134" class="cls-4">
                <path
                  class="cls-1"
                  d="M143.9,50.9a.3.3,0,0,0,.3-.3h0V45.8a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M143.9,51.4a.9.9,0,0,1-.8-.8h0V45.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8A.9.9,0,0,1,143.9,51.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_81" data-name="Group 81" class="cls-4">
              <g id="Vector_135" data-name="Vector 135" class="cls-4">
                <path
                  class="cls-1"
                  d="M141.7,52.1a.3.3,0,0,0,.3-.3h0V47a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M141.7,52.6a.9.9,0,0,1-.8-.8h0V47a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_82" data-name="Group 82" class="cls-4">
              <g id="Vector_136" data-name="Vector 136" class="cls-4">
                <path
                  class="cls-1"
                  d="M139.6,53.3a.3.3,0,0,0,.3-.3h0V48.2a.3.3,0,1,0-.6,0v4.9C139.3,53.2,139.4,53.3,139.6,53.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M139.6,53.8c-.4.1-.7-.2-.8-.6h0V48.2a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8V53a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_83" data-name="Group 83" class="cls-4">
              <g id="Vector_137" data-name="Vector 137" class="cls-4">
                <path
                  class="cls-1"
                  d="M137.4,54.6a.3.3,0,0,0,.3-.3h0V49.5a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M137.4,55.1a.9.9,0,0,1-.8-.8h0V49.5a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_84" data-name="Group 84" class="cls-4">
              <g id="Vector_138" data-name="Vector 138" class="cls-4">
                <path
                  class="cls-1"
                  d="M135.3,55.9c.2,0,.3-.2.3-.4V50.8c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.7C135,55.7,135.1,55.9,135.3,55.9Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M135.3,56.4a.9.9,0,0,1-.8-.8h0V50.8c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,135.3,56.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_85" data-name="Group 85" class="cls-4">
              <g id="Vector_139" data-name="Vector 139" class="cls-4">
                <path
                  class="cls-1"
                  d="M133.1,57.1a.3.3,0,0,0,.3-.3h0V52a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M133.1,57.6a.9.9,0,0,1-.8-.8V52a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_86" data-name="Group 86" class="cls-4">
              <g id="Vector_140" data-name="Vector 140" class="cls-4">
                <path
                  class="cls-1"
                  d="M131,58.3a.3.3,0,0,0,.3-.3h0V53.2a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0V58a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M131,58.8c-.4.1-.7-.2-.8-.6v-5c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V58a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_133" data-name="XMLID 133" class="cls-4">
              <g id="Vector_141" data-name="Vector 141" class="cls-4">
                <path
                  class="cls-1"
                  d="M128.8,59.5a.3.3,0,0,0,.3-.3h0V54.4a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,60a.9.9,0,0,1-.8-.8h0V54.4a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_87" data-name="Group 87">
            <g id="XMLID_132" data-name="XMLID 132">
              <g id="Vector_142" data-name="Vector 142">
                <path
                  class="cls-1"
                  d="M148.2,16.4a.3.3,0,0,0,.3-.3h0V11.3a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,16.9a.9.9,0,0,1-.8-.8h0V11.3c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_88" data-name="Group 88">
              <g id="Vector_143" data-name="Vector 143">
                <path
                  class="cls-1"
                  d="M146,17.6a.3.3,0,0,0,.3-.3h0V12.5a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M146,18.1a.9.9,0,0,1-.8-.8h0V12.5a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_89" data-name="Group 89">
              <g id="Vector_144" data-name="Vector 144">
                <path
                  class="cls-1"
                  d="M143.9,18.9a.3.3,0,0,0,.3-.3h0V13.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M143.9,19.4a.9.9,0,0,1-.8-.8h0V13.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8A.9.9,0,0,1,143.9,19.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_90" data-name="Group 90">
              <g id="Vector_145" data-name="Vector 145">
                <path
                  class="cls-1"
                  d="M141.7,20.1a.3.3,0,0,0,.3-.3h0V15a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M141.7,20.6a.9.9,0,0,1-.8-.8V15a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_91" data-name="Group 91">
              <g id="Vector_146" data-name="Vector 146">
                <path
                  class="cls-1"
                  d="M139.6,21.3a.3.3,0,0,0,.3-.3h0V16.2a.3.3,0,0,0-.6,0V21a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M139.6,21.8c-.4.1-.7-.2-.8-.6v-5a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8V21a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_92" data-name="Group 92">
              <g id="Vector_147" data-name="Vector 147">
                <path
                  class="cls-1"
                  d="M137.4,22.6a.3.3,0,0,0,.3-.3h0V17.5a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M137.4,23.1a.9.9,0,0,1-.8-.8h0V17.5a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_93" data-name="Group 93">
              <g id="Vector_148" data-name="Vector 148">
                <path
                  class="cls-1"
                  d="M135.3,23.8a.3.3,0,0,0,.3-.3h0V18.7l-.3-.3a.3.3,0,0,0-.3.3h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M135.3,24.3c-.4.1-.7-.2-.8-.6v-5a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_94" data-name="Group 94">
              <g id="Vector_149" data-name="Vector 149">
                <path
                  class="cls-1"
                  d="M133.1,25.1a.3.3,0,0,0,.3-.3h0V20a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M133.1,25.6a.9.9,0,0,1-.8-.8V20a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_95" data-name="Group 95">
              <g id="Vector_150" data-name="Vector 150">
                <path
                  class="cls-1"
                  d="M131,26.3a.3.3,0,0,0,.3-.3h0V21.2a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0V26a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M131,26.8a.9.9,0,0,1-.8-.8h0V21.2c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V26A.9.9,0,0,1,131,26.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_131" data-name="XMLID 131">
              <g id="Vector_151" data-name="Vector 151">
                <path
                  class="cls-1"
                  d="M128.8,27.5a.3.3,0,0,0,.3-.3h0V22.4a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,28a.9.9,0,0,1-.8-.8h0V22.4a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_130" data-name="XMLID 130" class="cls-4">
              <g id="Vector_152" data-name="Vector 152" class="cls-4">
                <path
                  class="cls-1"
                  d="M148.2,16.4a.3.3,0,0,0,.3-.3h0V11.3a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M148.2,16.9a.9.9,0,0,1-.8-.8h0V11.3c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_96" data-name="Group 96" class="cls-4">
              <g id="Vector_153" data-name="Vector 153" class="cls-4">
                <path
                  class="cls-1"
                  d="M146,17.6a.3.3,0,0,0,.3-.3h0V12.5a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M146,18.1a.9.9,0,0,1-.8-.8h0V12.5a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_97" data-name="Group 97" class="cls-4">
              <g id="Vector_154" data-name="Vector 154" class="cls-4">
                <path
                  class="cls-1"
                  d="M143.9,18.9a.3.3,0,0,0,.3-.3h0V13.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M143.9,19.4a.9.9,0,0,1-.8-.8h0V13.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0v4.8A.9.9,0,0,1,143.9,19.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_98" data-name="Group 98" class="cls-4">
              <g id="Vector_155" data-name="Vector 155" class="cls-4">
                <path
                  class="cls-1"
                  d="M141.7,20.1a.3.3,0,0,0,.3-.3h0V15a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M141.7,20.6a.9.9,0,0,1-.8-.8V15a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_99" data-name="Group 99" class="cls-4">
              <g id="Vector_156" data-name="Vector 156" class="cls-4">
                <path
                  class="cls-1"
                  d="M139.6,21.3a.3.3,0,0,0,.3-.3h0V16.2a.3.3,0,0,0-.6,0V21a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M139.6,21.8c-.4.1-.7-.2-.8-.6v-5a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8V21a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_100" data-name="Group 100" class="cls-4">
              <g id="Vector_157" data-name="Vector 157" class="cls-4">
                <path
                  class="cls-1"
                  d="M137.4,22.6a.3.3,0,0,0,.3-.3h0V17.5a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M137.4,23.1a.9.9,0,0,1-.8-.8h0V17.5a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_101" data-name="Group 101" class="cls-4">
              <g id="Vector_158" data-name="Vector 158" class="cls-4">
                <path
                  class="cls-1"
                  d="M135.3,23.8a.3.3,0,0,0,.3-.3h0V18.7l-.3-.3a.3.3,0,0,0-.3.3h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M135.3,24.3c-.4.1-.7-.2-.8-.6v-5a.9.9,0,0,1,.8-.8h0a.9.9,0,0,1,.8.8v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_102" data-name="Group 102" class="cls-4">
              <g id="Vector_159" data-name="Vector 159" class="cls-4">
                <path
                  class="cls-1"
                  d="M133.1,25.1a.3.3,0,0,0,.3-.3h0V20a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M133.1,25.6a.9.9,0,0,1-.8-.8V20a.9.9,0,0,1,.8-.8h0c.4-.1.7.2.8.6v5a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_103" data-name="Group 103" class="cls-4">
              <g id="Vector_160" data-name="Vector 160" class="cls-4">
                <path
                  class="cls-1"
                  d="M131,26.3a.3.3,0,0,0,.3-.3h0V21.2a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0V26a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M131,26.8a.9.9,0,0,1-.8-.8h0V21.2c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8h0V26A.9.9,0,0,1,131,26.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_129" data-name="XMLID 129" class="cls-4">
              <g id="Vector_161" data-name="Vector 161" class="cls-4">
                <path
                  class="cls-1"
                  d="M128.8,27.5a.3.3,0,0,0,.3-.3h0V22.4a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M128.8,28a.9.9,0,0,1-.8-.8h0V22.4a.8.8,0,0,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_128" data-name="XMLID 128">
            <g id="Vector_162" data-name="Vector 162">
              <path
                class="cls-1"
                d="M271.5,263.1,127.8,180.2v3.2l143.7,82.8Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M271.5,266.7h-.3L127.5,183.8l-.2-.4v-3.2a.8.8,0,0,1,.2-.5h.5l143.7,83c.2.1.3.2.3.4v3.1a.5.5,0,0,1-.3.5ZM128.3,183.1,271,265.4v-2L128.3,181Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_127" data-name="XMLID 127">
          <g id="Vector_163" data-name="Vector 163">
            <path
              class="cls-1"
              d="M71.2,63.2c10.7,0,21.7-4.2,31.7-12.1C115.5,40.9,123,27.5,123,20.5c.1-.4-.2-.7-.6-.8h-.2a.9.9,0,0,0-.8.8h0c0,6.5-7.5,19.6-19.6,29.3-8.6,7-22.5,14.5-39.2,10.8a.8.8,0,0,0-.9.7h0c-.2.4.1.8.6.9A38,38,0,0,0,71.2,63.2Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M71.2,63.7a39.4,39.4,0,0,1-9-1,1.5,1.5,0,0,1-.9-.6,1.2,1.2,0,0,1-.1-1,1.6,1.6,0,0,1,.6-.8,1.2,1.2,0,0,1,1-.1c16.5,3.6,30.2-3.8,38.7-10.8,12-9.6,19.4-22.5,19.4-28.9a1.3,1.3,0,1,1,2.6,0c0,7.1-7.6,20.7-20.3,31C93.2,59.5,82.1,63.7,71.2,63.7Zm-8.8-2.6h0c-.2,0-.2.1-.3.2s0,.1.1.2l.2.2a43.1,43.1,0,0,0,8.8.9c10.7,0,21.5-4.1,31.4-12,12.5-10.1,19.9-23.3,19.9-30.2a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3h0c0,6.6-7.5,19.9-19.8,29.7-8.7,7.1-22.6,14.7-39.7,11Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_126" data-name="XMLID 126">
          <g id="Vector_164" data-name="Vector 164">
            <path
              class="cls-1"
              d="M233,209.9a20.4,20.4,0,0,0,11-3.2c29.8-17.2,53.2-99.5,53.2-112.2a.8.8,0,0,0-1.6,0c0,6-6,29.7-15.3,53.5-8.3,21.2-21.4,48.3-37.1,57.3-6.7,3.9-13.2,4-19.6.4-20.2-11.7-38-60.9-49.3-100.1-12.6-43.8-20.7-87.2-20.7-93.7.1-.4-.2-.7-.6-.8h-.2a.9.9,0,0,0-.8.8h0c0,6.8,7.9,49.5,20.8,94.1,11.4,39.5,29.4,89.1,50,101A19.5,19.5,0,0,0,233,209.9Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M233,210.4a20,20,0,0,1-10.4-3c-20.8-12-38.8-61.7-50.3-101.3-12.9-44.7-20.8-87.4-20.8-94.2a1.3,1.3,0,1,1,2.6,0h0c0,6.5,8.1,49.8,20.7,93.5,11.3,39.1,28.9,88.2,49.1,99.8,6.1,3.5,12.5,3.4,19-.3,15.6-9,28.7-36,37-57.1,9.3-23.7,15.2-47.4,15.2-53.3a1.3,1.3,0,0,1,2.6,0c0,12.7-23.5,95.3-53.5,112.6A22.2,22.2,0,0,1,233,210.4ZM152.8,11.6a.3.3,0,0,0-.3.3h0c0,6.8,7.9,49.3,20.8,94,11.4,39.4,29.3,88.8,49.8,100.7,6.8,3.9,13.8,3.7,20.6-.3,29.7-17.2,53-99.2,53-111.8a.3.3,0,1,0-.6,0c0,5.9-6,29.8-15.3,53.7-8.3,21.2-21.6,48.4-37.4,57.5-6.8,4-13.6,4.1-20,.4-20.5-11.8-38.2-61.1-49.5-100.4-12.7-43.8-20.8-87.3-20.8-93.8A.3.3,0,0,0,152.8,11.6Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_123" data-name="XMLID 123">
          <g id="XMLID_125" data-name="XMLID 125">
            <g id="Vector_165" data-name="Vector 165">
              <path
                class="cls-6"
                d="M94.6,161l33.2,19.2L150,167.3l-33.2-19.2Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M127.8,180.7h-.3L94.4,161.4c-.2-.1-.3-.2-.3-.4s.1-.4.3-.4l22.2-12.9h.5l33.1,19.2c.2.1.2.2.2.4s0,.4-.2.4L128,180.6ZM95.6,161l32.2,18.6L149,167.3l-32.2-18.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_124" data-name="XMLID 124">
            <g id="Vector_166" data-name="Vector 166">
              <path
                class="cls-1"
                d="M120.9,176.2v3.2L94.6,164.2V161Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M120.9,179.9h-.3L94.4,164.6c-.2-.1-.3-.2-.3-.4V161c0-.2.1-.4.3-.4h.5l26.2,15.1a.5.5,0,0,1,.3.5v3.2c0,.2-.1.3-.3.4Zm-25.8-16,25.3,14.6v-2L95.1,161.9Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_122" data-name="XMLID 122">
          <g id="Vector_167" data-name="Vector 167">
            <path
              class="cls-1"
              d="M303.3,295.1v-5a1.2,1.2,0,0,0-.7-1.1l-7.1-4.1a1.3,1.3,0,0,0-1.2,0L259.6,305a1.4,1.4,0,0,0-.6,1.1v5a1.1,1.1,0,0,0,.6,1l7.1,4.2h1.2l34.7-20.1A1.2,1.2,0,0,0,303.3,295.1Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M267.3,316.9l-.9-.2-7.1-4.1a1.8,1.8,0,0,1-.8-1.5v-5a1.8,1.8,0,0,1,.8-1.5l34.8-20.1a1.7,1.7,0,0,1,1.7,0l7.1,4.1a2.1,2.1,0,0,1,.9,1.5v5a2.1,2.1,0,0,1-.9,1.5l-34.8,20.1Zm27.6-31.6h-.3l-34.8,20.1a.9.9,0,0,0-.3.6v5a.7.7,0,0,0,.3.6l7.1,4.1a.9.9,0,0,0,.7,0l34.8-20.1a.7.7,0,0,0,.4-.6v-5a.7.7,0,0,0-.4-.6l-7.1-4.1Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_121" data-name="XMLID 121">
          <g id="Vector_168" data-name="Vector 168">
            <path
              class="cls-1"
              d="M259.1,306.1a1.3,1.3,0,0,1,.6-1.1l2.1-1.2,5.6,3.2v9.4h-.6l-7.2-4.2a1.1,1.1,0,0,1-.6-1v-5Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M267.4,316.9l-.8-.2h-.1l-7.1-4.1a1.9,1.9,0,0,1-.9-1.5v-5c0-.1.1-.2.1-.3a1.6,1.6,0,0,1,.9-1.2l2.1-1.2h.5l5.5,3.2c.2,0,.3.2.3.4v9.4A.5.5,0,0,1,267.4,316.9Zm-7.9-10.6v4.8a.7.7,0,0,0,.4.6l7,4.1v-8.5l-5.1-2.9-1.9,1.1a.7.7,0,0,0-.3.6v.2Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_120" data-name="XMLID 120">
          <g id="Vector_169" data-name="Vector 169">
            <path
              class="cls-1"
              d="M302.7,289.1l-7.1-4.1a1.3,1.3,0,0,0-1.2,0l-34.8,20.1c-.2.1-.3.4-.2.5l.2.2,7.2,4.1a1.1,1.1,0,0,0,1.1,0l34.8-20.1c.2-.1.3-.4.2-.5S302.8,289.1,302.7,289.1Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M267.3,310.5l-.8-.2-7.1-4.1a1,1,0,0,1-.5-.8.8.8,0,0,1,.5-.7l34.8-20.1a1.5,1.5,0,0,1,1.6,0l7.2,4.1h0a.8.8,0,0,1,.4.7.9.9,0,0,1-.4.8l-34.8,20.1Zm-7.3-5.1,7,4a.9.9,0,0,0,.7,0l34.6-20-7-4h-.6Zm42.5-15.9h0l.2-.4Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_115" data-name="XMLID 115">
          <g id="XMLID_119" data-name="XMLID 119">
            <g id="Vector_170" data-name="Vector 170">
              <path
                class="cls-1"
                d="M275.7,303.1v-1.8a1.4,1.4,0,0,0-.6-1.1l-4.4-2.5a1.3,1.3,0,0,0-1.2,0l-7.1,4.1a1.4,1.4,0,0,0-.6,1.1v1.8a1.3,1.3,0,0,0,.6,1.1l4.4,2.5a1.1,1.1,0,0,0,1.1,0l7.2-4.1A1.4,1.4,0,0,0,275.7,303.1Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M267.3,308.9l-.8-.2-4.4-2.5a1.8,1.8,0,0,1-.8-1.5v-1.8a1.8,1.8,0,0,1,.8-1.5l7.2-4.1a1.5,1.5,0,0,1,1.6,0l4.4,2.5a1.9,1.9,0,0,1,.9,1.5v1.8a2.1,2.1,0,0,1-.9,1.5l-7.1,4.1Zm2.8-10.8h-.3l-7.2,4.2a.9.9,0,0,0-.3.6v1.8a.7.7,0,0,0,.3.6l4.4,2.5h.7l7.1-4.1a.7.7,0,0,0,.4-.6v-1.8a.7.7,0,0,0-.4-.6l-4.4-2.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_118" data-name="XMLID 118">
            <g id="Vector_171" data-name="Vector 171">
              <path
                class="cls-1"
                d="M261.8,302.9a1.2,1.2,0,0,1,.7-1.1l.8-.4,4.1,2.4v4.6h-.6l-4.4-2.5a1.4,1.4,0,0,1-.6-1.1V303Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M267.4,308.9l-.8-.2h-.1l-4.4-2.5a1.8,1.8,0,0,1-.8-1.5v-1.8a.4.4,0,0,1,.1-.3,2,2,0,0,1,.8-1.2l.8-.4a.5.5,0,0,1,.5,0l4.1,2.4c.2,0,.3.2.3.4v4.6A.5.5,0,0,1,267.4,308.9Zm-5.1-5.8v1.6a.7.7,0,0,0,.4.6l4.2,2.5v-3.7l-3.7-2.1-.5.3a.7.7,0,0,0-.4.6Zm-.5-.2Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_116" data-name="XMLID 116">
            <g id="Vector_172" data-name="Vector 172">
              <path
                class="cls-1"
                d="M275.1,300.3l-4.4-2.5a1.3,1.3,0,0,0-1.2,0l-7.1,4.1c-.2.1-.3.4-.2.5s.1.1.2.2l4.4,2.5a1.1,1.1,0,0,0,1.1,0l7.2-4.1c.2-.1.3-.4.2-.5Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M267.3,305.7l-.8-.2-4.4-2.5a.9.9,0,0,1-.4-.8.7.7,0,0,1,.4-.7l7.2-4.2a2.5,2.5,0,0,1,1.7,0l4.3,2.6h0a.8.8,0,0,1,.5.7,1,1,0,0,1-.5.8l-7.1,4.1Zm-4.5-3.5,4.2,2.4h.7l6.9-4.1-4.2-2.4a.6.6,0,0,0-.6,0Zm12-1.5h0l.3-.4Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
        </g>
        <g id="Vector_173" data-name="Vector 173">
          <path
            class="cls-1"
            d="M265.2,100.8l1.6-.9a1.1,1.1,0,0,1,1.1,0l1.6.9a1.4,1.4,0,0,1,.6,1.1v2.5l-5.3-3.1A1,1,0,0,1,265.2,100.8Z"
            transform="translate(-57.9 0)"
          />
          <path
            d="M270.1,104.9h-.2l-5.4-3a1.4,1.4,0,0,1-.2-.6,1.6,1.6,0,0,1,.6-.8l1.6-.9a1.7,1.7,0,0,1,1.7,0l1.6.9a2.2,2.2,0,0,1,.8,1.4v2.5a.5.5,0,0,1-.2.4Zm-4.5-3.7,4,2.3v-1.6c0-.3-.2-.6-.3-.6l-1.6-1H267Z"
            transform="translate(-57.9 0)"
          />
        </g>
        <g id="XMLID_114" data-name="XMLID 114">
          <g id="Vector_174" data-name="Vector 174">
            <path
              class="cls-1"
              d="M115,222.8a1.1,1.1,0,0,1,.6-1l2.2-1.3,5.5,3.2v9.4h-.6l-7.2-4.1a1.4,1.4,0,0,1-.6-1.1v-5.1Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M123.3,233.6h-.8l-7.2-4.2a1.9,1.9,0,0,1-.9-1.5v-5.3a1.6,1.6,0,0,1,.9-1.2l2.1-1.2h.5l5.5,3.2c.2.1.3.2.3.4v9.4A.4.4,0,0,1,123.3,233.6ZM115.4,223v4.8a.8.8,0,0,0,.4.7l7,4V224l-5.1-2.9-1.9,1.1a.7.7,0,0,0-.3.6c0,.1,0,.2-.1.2Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_109" data-name="XMLID 109">
          <g id="XMLID_113" data-name="XMLID 113">
            <g id="Vector_175" data-name="Vector 175">
              <path
                class="cls-1"
                d="M131.6,219.9V218a1.1,1.1,0,0,0-.6-1l-4.4-2.6h-1.2l-7.1,4.2a1.1,1.1,0,0,0-.6,1v1.9a1.1,1.1,0,0,0,.6,1l4.4,2.5a1.1,1.1,0,0,0,1.1,0l7.2-4.1A1.3,1.3,0,0,0,131.6,219.9Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M123.3,225.7a1.4,1.4,0,0,1-.9-.3l-4.3-2.5a1.6,1.6,0,0,1-.9-1.5v-1.8a1.8,1.8,0,0,1,.8-1.5l7.2-4.1a1.7,1.7,0,0,1,1.7,0l4.3,2.5a1.9,1.9,0,0,1,.9,1.5v1.9a1.7,1.7,0,0,1-.9,1.4l-7.1,4.1A1.1,1.1,0,0,1,123.3,225.7Zm2.7-10.9h-.3l-7.1,4.1a.7.7,0,0,0-.4.6v1.9c0,.2.1.6.3.6l4.4,2.6h.7l7.1-4.1a.7.7,0,0,0,.4-.6V218a.7.7,0,0,0-.4-.6l-4.4-2.5Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_112" data-name="XMLID 112">
            <g id="Vector_176" data-name="Vector 176">
              <path
                class="cls-1"
                d="M117.8,219.7a1.3,1.3,0,0,1,.6-1.1l.8-.4,4.1,2.4v4.6h-.6l-4.4-2.5a1.4,1.4,0,0,1-.6-1.1v-1.9Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M123.3,225.7l-.8-.2h-.1l-4.3-2.5a1.6,1.6,0,0,1-.9-1.5v-1.8a.4.4,0,0,1,.1-.3,2,2,0,0,1,.8-1.2l.8-.4h.5l4.1,2.4c.2,0,.3.2.3.4v4.6A.5.5,0,0,1,123.3,225.7Zm-5.1-5.8v1.6a.7.7,0,0,0,.4.6l4.2,2.5v-3.7l-3.6-2.1-.6.3a.7.7,0,0,0-.3.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_110" data-name="XMLID 110">
            <g id="Vector_177" data-name="Vector 177">
              <path
                class="cls-1"
                d="M131,217l-4.4-2.5a1.3,1.3,0,0,0-1.2,0l-7.1,4.1c-.2.1-.3.4-.2.5l.2.2,4.4,2.5a1.1,1.1,0,0,0,1.1,0l7.2-4.1c.2-.1.3-.4.2-.5Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M123.3,222.5a1.4,1.4,0,0,1-.9-.3l-4.3-2.5c-.4-.2-.5-.4-.5-.7a.9.9,0,0,1,.4-.8l7.2-4.1a1.7,1.7,0,0,1,1.7,0l4.3,2.5a1,1,0,0,1,.5.8.8.8,0,0,1-.5.7l-7.1,4.2Zm-4.6-3.5,4.2,2.4h.7l6.9-4-4.2-2.5h-.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_108" data-name="XMLID 108">
          <g id="Vector_178" data-name="Vector 178">
            <path
              class="cls-1"
              d="M126,18.6V218.3a1.3,1.3,0,0,1-.6,1.1l-2.1,1.2-2.8-1.6V18.6a1.3,1.3,0,0,1,.6-1l1.6-1h1.2l1.6,1A1.2,1.2,0,0,1,126,18.6Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M123.3,221.1H123l-2.7-1.6c-.2-.1-.3-.2-.3-.4V18.6a1.9,1.9,0,0,1,.9-1.5l1.6-.9a1.7,1.7,0,0,1,1.7,0l1.5.9a1.8,1.8,0,0,1,.8,1.5V218.3a1.8,1.8,0,0,1-.8,1.5l-2.2,1.2Zm-2.3-2.4,2.3,1.3,1.9-1.1a.7.7,0,0,0,.3-.6V18.6a.7.7,0,0,0-.3-.6l-1.6-.9H123l-1.6.9a.7.7,0,0,0-.4.6Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_107" data-name="XMLID 107" class="cls-4">
          <g id="Vector_179" data-name="Vector 179" class="cls-4">
            <path
              class="cls-1"
              d="M126,18.6V218.3a1.3,1.3,0,0,1-.6,1.1l-2.1,1.2-2.8-1.6V18.6a1.3,1.3,0,0,1,.6-1l1.6-1h1.2l1.6,1A1.2,1.2,0,0,1,126,18.6Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M123.3,221.1H123l-2.7-1.6c-.2-.1-.3-.2-.3-.4V18.6a1.9,1.9,0,0,1,.9-1.5l1.6-.9a1.7,1.7,0,0,1,1.7,0l1.5.9a1.8,1.8,0,0,1,.8,1.5V218.3a1.8,1.8,0,0,1-.8,1.5l-2.2,1.2Zm-2.3-2.4,2.3,1.3,1.9-1.1a.7.7,0,0,0,.3-.6V18.6a.7.7,0,0,0-.3-.6l-1.6-.9H123l-1.6.9a.7.7,0,0,0-.4.6Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="Vector_180" data-name="Vector 180">
          <path
            class="cls-1"
            d="M121.1,17.6l1.6-1h1.1l1.6,1a1.3,1.3,0,0,1,.6,1v2.5l-5.3-3A.7.7,0,0,1,121.1,17.6Z"
            transform="translate(-57.9 0)"
          />
          <path
            d="M126,21.6h-.2l-5.3-3.1a.7.7,0,0,1-.3-.6,1,1,0,0,1,.5-.6c0-.1.1-.1.1-.2l1.6-.9a1.7,1.7,0,0,1,1.7,0l1.6.9a1.6,1.6,0,0,1,.8,1.4v2.6c0,.2,0,.4-.2.5Zm-4.5-3.7,4,2.4V18.6a.9.9,0,0,0-.3-.6l-1.6-.9h-.7Z"
            transform="translate(-57.9 0)"
          />
        </g>
        <g id="Vector_181" data-name="Vector 181">
          <path
            class="cls-1"
            d="M123.3,20.1V219.9c0,.3.2.5.6.3l1.6-.9a1.3,1.3,0,0,0,.6-1V18.6c0-.4-.2-.6-.6-.4l-1.6.9A1.3,1.3,0,0,0,123.3,20.1Z"
            transform="translate(-57.9 0)"
          />
          <path
            d="M123.6,220.8h-.4a.9.9,0,0,1-.4-.8V20.1a1.6,1.6,0,0,1,.8-1.4l1.6-.9a.9.9,0,0,1,1-.1,1.1,1.1,0,0,1,.4.9V218.3a1.7,1.7,0,0,1-.9,1.4l-1.6,1Zm2-202.1-1.5.8a.9.9,0,0,0-.3.6V219.7l1.4-.8a.7.7,0,0,0,.4-.6Z"
            transform="translate(-57.9 0)"
          />
        </g>
        <g id="Vector_182" data-name="Vector 182" class="cls-2">
          <path
            class="cls-1"
            d="M123.3,20.1V219.9c0,.3.2.5.6.3l1.6-.9a1.3,1.3,0,0,0,.6-1V18.6c0-.4-.2-.6-.6-.4l-1.6.9A1.3,1.3,0,0,0,123.3,20.1Z"
            transform="translate(-57.9 0)"
          />
          <path
            d="M123.6,220.8h-.4a.9.9,0,0,1-.4-.8V20.1a1.6,1.6,0,0,1,.8-1.4l1.6-.9a.9.9,0,0,1,1-.1,1.1,1.1,0,0,1,.4.9V218.3a1.7,1.7,0,0,1-.9,1.4l-1.6,1Zm2-202.1-1.5.8a.9.9,0,0,0-.3.6V219.7l1.4-.8a.7.7,0,0,0,.4-.6Z"
            transform="translate(-57.9 0)"
          />
        </g>
        <g id="Group_104" data-name="Group 104">
          <g id="Vector_183" data-name="Vector 183">
            <path
              class="cls-1"
              d="M123.8,181.9l4.4-2.5c.3-.2.6,0,.6.4v37.6l-5.5,3.2V183A1.6,1.6,0,0,1,123.8,181.9Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M123.3,221.1H123a.5.5,0,0,1-.2-.4V183a1.8,1.8,0,0,1,.8-1.5h0l4.3-2.5a1.2,1.2,0,0,1,1-.1,1.1,1.1,0,0,1,.4.9v37.6a.5.5,0,0,1-.2.4l-5.6,3.2Zm.8-38.7a.7.7,0,0,0-.3.6v36.7l4.5-2.6V179.9Z"
              transform="translate(-57.9 0)"
            />
          </g>
          <g id="Vector_184" data-name="Vector 184" class="cls-2">
            <path
              class="cls-1"
              d="M123.8,181.9l4.4-2.5c.3-.2.6,0,.6.4v37.6l-5.5,3.2V183A1.6,1.6,0,0,1,123.8,181.9Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M123.3,221.1H123a.5.5,0,0,1-.2-.4V183a1.8,1.8,0,0,1,.8-1.5h0l4.3-2.5a1.2,1.2,0,0,1,1-.1,1.1,1.1,0,0,1,.4.9v37.6a.5.5,0,0,1-.2.4l-5.6,3.2Zm.8-38.7a.7.7,0,0,0-.3.6v36.7l4.5-2.6V179.9Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_106" data-name="XMLID 106">
          <g id="Vector_185" data-name="Vector 185">
            <path
              class="cls-6"
              d="M147.2,165.7l124.3,71.5v25.9L127.8,180.2V177Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M271.5,263.6h-.3l-143.7-83a.8.8,0,0,1-.2-.4V177a.8.8,0,0,1,.2-.5L147,165.3h.5l124.2,71.4a.5.5,0,0,1,.3.5v25.9c0,.2-.1.4-.3.4ZM128.3,179.9,271,262.2V237.5L147.2,166.3l-18.9,11Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="Group_105" data-name="Group 105">
          <g id="XMLID_101" data-name="XMLID 101">
            <g id="XMLID_105" data-name="XMLID 105">
              <g id="Vector_186" data-name="Vector 186">
                <path
                  class="cls-1"
                  d="M300.5,288.7v-1.8a1.4,1.4,0,0,0-.6-1.1l-4.4-2.5a1.3,1.3,0,0,0-1.2,0l-7.1,4.1a1.4,1.4,0,0,0-.6,1.1v1.8a1.4,1.4,0,0,0,.6,1.1l4.4,2.5a1.3,1.3,0,0,0,1.2,0l7.1-4.1A1.4,1.4,0,0,0,300.5,288.7Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.2,294.5a1.5,1.5,0,0,1-.9-.2l-4.3-2.5a1.9,1.9,0,0,1-.9-1.5v-1.8a2.1,2.1,0,0,1,.9-1.5l7.1-4.1a1.7,1.7,0,0,1,1.7,0l4.3,2.5a1.9,1.9,0,0,1,.9,1.5v1.8a1.6,1.6,0,0,1-.9,1.5l-7.1,4.1A1.1,1.1,0,0,1,292.2,294.5Zm2.7-10.8h-.3l-7.1,4.1a.7.7,0,0,0-.4.6v1.8a.9.9,0,0,0,.3.6l4.4,2.6h.7l7.1-4.2a.7.7,0,0,0,.4-.6v-1.8a.9.9,0,0,0-.3-.6l-4.4-2.5Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_104" data-name="XMLID 104">
              <g id="Vector_187" data-name="Vector 187">
                <path
                  class="cls-1"
                  d="M286.7,288.6a1.4,1.4,0,0,1,.6-1.1l.8-.4,4.2,2.4v4.6h-.7l-4.3-2.6a1.1,1.1,0,0,1-.6-1v-1.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,294.6l-.8-.2-4.5-2.5a1.8,1.8,0,0,1-.8-1.5v-1.8c0-.2,0-.3.1-.3a1.3,1.3,0,0,1,.8-1.2l.8-.5h.5l4.1,2.4a.5.5,0,0,1,.3.5v4.6A.5.5,0,0,1,292.3,294.6Zm-5.1-5.8v1.6a.9.9,0,0,0,.3.6l4.3,2.4v-3.6l-3.7-2.2-.5.3a1,1,0,0,0-.4.7Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_102" data-name="XMLID 102">
              <g id="Vector_188" data-name="Vector 188">
                <path
                  class="cls-1"
                  d="M299.9,285.9l-4.3-2.5a1.3,1.3,0,0,0-1.2,0l-7.1,4.1c-.2.1-.3.4-.2.5s.1.1.2.2l4.3,2.5a1.3,1.3,0,0,0,1.2,0l7.1-4.1c.2-.1.3-.4.2-.5S300,285.9,299.9,285.9Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.2,291.3a1.1,1.1,0,0,1-.8-.2l-4.4-2.5a.9.9,0,0,1-.4-.8.8.8,0,0,1,.4-.7l7.2-4.1a1.5,1.5,0,0,1,1.6,0l4.4,2.5h0c.3.2.5.4.5.7a1,1,0,0,1-.5.8l-7.1,4.1A1.5,1.5,0,0,1,292.2,291.3Zm-4.5-3.5,4.2,2.5h.7l6.9-4.1-4.2-2.4h-.6Zm12-1.5h0l.2-.5Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_106" data-name="Group 106">
            <g id="XMLID_100" data-name="XMLID 100">
              <g id="Vector_189" data-name="Vector 189">
                <path
                  class="cls-1"
                  d="M294.4,288.2l-2.1,1.2-2.8-1.6V253.4a1.1,1.1,0,0,1,.6-1l4.4-2.6c.3-.1.6,0,.6.4v36.9A1.9,1.9,0,0,1,294.4,288.2Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,289.9H292l-2.8-1.6c-.1,0-.2-.2-.2-.4V253.4a1.9,1.9,0,0,1,.9-1.5l4.3-2.5a.8.8,0,0,1,.9,0,.9.9,0,0,1,.5.8v36.9a2.4,2.4,0,0,1-.9,1.5h0l-2.2,1.2Zm-2.3-2.4,2.3,1.3,1.9-1c.1-.2.4-.5.4-.7V250.4l-4.2,2.4a.5.5,0,0,0-.4.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_99" data-name="XMLID 99" class="cls-3">
              <g id="Vector_190" data-name="Vector 190" class="cls-3">
                <path
                  class="cls-1"
                  d="M294.4,288.2l-2.1,1.2-2.8-1.6V253.4a1.1,1.1,0,0,1,.6-1l4.4-2.6c.3-.1.6,0,.6.4v36.9A1.9,1.9,0,0,1,294.4,288.2Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,289.9H292l-2.8-1.6c-.1,0-.2-.2-.2-.4V253.4a1.9,1.9,0,0,1,.9-1.5l4.3-2.5a.8.8,0,0,1,.9,0,.9.9,0,0,1,.5.8v36.9a2.4,2.4,0,0,1-.9,1.5h0l-2.2,1.2Zm-2.3-2.4,2.3,1.3,1.9-1c.1-.2.4-.5.4-.7V250.4l-4.2,2.4a.5.5,0,0,0-.4.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_98" data-name="XMLID 98">
            <g id="Vector_191" data-name="Vector 191">
              <path
                class="cls-1"
                d="M297.8,85.9V285.6a1.1,1.1,0,0,1-.6,1l-1.6,1a1.3,1.3,0,0,1-1.2,0l-1.6-1a1.1,1.1,0,0,1-.6-1V85.9a1.1,1.1,0,0,1,.6-1l1.6-1a1.3,1.3,0,0,1,1.2,0l1.6,1A1.1,1.1,0,0,1,297.8,85.9Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M295,288.2l-.8-.2-1.6-.9a1.6,1.6,0,0,1-.9-1.5V85.9a1.9,1.9,0,0,1,.9-1.5l1.6-.9a1.5,1.5,0,0,1,1.6,0l1.6.9a2.1,2.1,0,0,1,.9,1.5V285.6a1.9,1.9,0,0,1-.9,1.5l-1.6.9Zm0-203.9h-.3l-1.6.9a.7.7,0,0,0-.4.6V285.6a.7.7,0,0,0,.4.6l1.6.9h.6l1.6-.9a.7.7,0,0,0,.4-.6V85.9a.7.7,0,0,0-.4-.6l-1.6-.9Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_97" data-name="XMLID 97">
            <g id="Vector_192" data-name="Vector 192">
              <path
                class="cls-1"
                d="M292.8,84.9l1.6-1a1.3,1.3,0,0,1,1.2,0l1.6,1c.3.1.5.6.6,1v2.5l-5.4-3.1Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M297.8,88.9h-.3l-5.3-3.1a.5.5,0,0,1-.2-.6,2.2,2.2,0,0,1,.5-.8h.1l1.6-.9a1.5,1.5,0,0,1,1.6,0l1.6.9a1.9,1.9,0,0,1,.9,1.4v2.6a.5.5,0,0,1-.3.5Zm-4.6-3.7,4.1,2.4V85.9a.7.7,0,0,0-.4-.6l-1.6-.9h-.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_96" data-name="XMLID 96">
            <g id="Vector_193" data-name="Vector 193">
              <path
                class="cls-1"
                d="M295,87.5V287.2c0,.4.3.6.6.4l1.6-1a1.4,1.4,0,0,0,.7-1V85.9c0-.4-.3-.6-.7-.4l-1.6,1A1.1,1.1,0,0,0,295,87.5Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M295.4,288.1h-.5a.9.9,0,0,1-.4-.8V87.5a1.9,1.9,0,0,1,.9-1.5l1.6-.9c.5-.2.8-.1.9,0a.9.9,0,0,1,.5.8V285.6a2.1,2.1,0,0,1-.9,1.5l-1.6.9Zm2-202.1-1.5.9a.7.7,0,0,0-.4.6V287l1.5-.8a.7.7,0,0,0,.4-.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_95" data-name="XMLID 95" class="cls-3">
            <g id="Vector_194" data-name="Vector 194" class="cls-3">
              <path
                class="cls-1"
                d="M295,87.5V287.2c0,.4.3.6.6.4l1.6-1a1.4,1.4,0,0,0,.7-1V85.9c0-.4-.3-.6-.7-.4l-1.6,1A1.1,1.1,0,0,0,295,87.5Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M295.4,288.1h-.5a.9.9,0,0,1-.4-.8V87.5a1.9,1.9,0,0,1,.9-1.5l1.6-.9c.5-.2.8-.1.9,0a.9.9,0,0,1,.5.8V285.6a2.1,2.1,0,0,1-.9,1.5l-1.6.9Zm2-202.1-1.5.9a.7.7,0,0,0-.4.6V287l1.5-.8a.7.7,0,0,0,.4-.6Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_107" data-name="Group 107">
            <g id="XMLID_94" data-name="XMLID 94">
              <g id="Vector_195" data-name="Vector 195">
                <path
                  class="cls-1"
                  d="M292.8,250.8l4.4-2.5c.3-.2.6-.1.6.4v37.6l-5.5,3.2V251.9A1.6,1.6,0,0,1,292.8,250.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,290H292a.5.5,0,0,1-.2-.4V251.9a1.8,1.8,0,0,1,.8-1.5h0l4.3-2.5a1.2,1.2,0,0,1,1-.1,1.5,1.5,0,0,1,.4.9v37.6c0,.2-.1.3-.3.4l-5.5,3.2Zm.8-38.7c-.2,0-.3.3-.3.6v36.7l4.5-2.6V248.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_93" data-name="XMLID 93" class="cls-3">
              <g id="Vector_196" data-name="Vector 196" class="cls-3">
                <path
                  class="cls-1"
                  d="M292.8,250.8l4.4-2.5c.3-.2.6-.1.6.4v37.6l-5.5,3.2V251.9A1.6,1.6,0,0,1,292.8,250.8Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,290H292a.5.5,0,0,1-.2-.4V251.9a1.8,1.8,0,0,1,.8-1.5h0l4.3-2.5a1.2,1.2,0,0,1,1-.1,1.5,1.5,0,0,1,.4.9v37.6c0,.2-.1.3-.3.4l-5.5,3.2Zm.8-38.7c-.2,0-.3.3-.3.6v36.7l4.5-2.6V248.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_108" data-name="Group 108">
            <g id="Group_109" data-name="Group 109">
              <g id="XMLID_92" data-name="XMLID 92">
                <g id="Vector_197" data-name="Vector 197">
                  <path
                    class="cls-1"
                    d="M293.7,208.7l-2.8-1.6V178.4l2.8,1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.7,209.2h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V178.4a.5.5,0,0,1,.3-.5h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7c0,.2-.1.3-.3.4Zm-2.3-2.4,1.8,1V180.3l-1.8-1.1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_91" data-name="XMLID 91" class="cls-4">
                <g id="Vector_198" data-name="Vector 198" class="cls-4">
                  <path
                    class="cls-1"
                    d="M293.7,208.7l-2.8-1.6V178.4l2.8,1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.7,209.2h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V178.4a.5.5,0,0,1,.3-.5h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7c0,.2-.1.3-.3.4Zm-2.3-2.4,1.8,1V180.3l-1.8-1.1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_110" data-name="Group 110">
              <g id="XMLID_90" data-name="XMLID 90">
                <g id="Vector_199" data-name="Vector 199">
                  <path
                    class="cls-1"
                    d="M290.9,181.6l-2.8-1.6v-1.6l1.4.8,1.4-.8Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M290.9,182.1h-.2l-2.8-1.6c-.2-.1-.3-.2-.3-.4v-1.7c0-.2.1-.3.3-.4h.5l1.1.6,1.2-.7h.5a.8.8,0,0,1,.2.5v3.2a.8.8,0,0,1-.2.4Zm-2.3-2.4,1.8,1v-1.5l-.7.4h-.4l-.7-.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_89" data-name="XMLID 89" class="cls-4">
                <g id="Vector_200" data-name="Vector 200" class="cls-4">
                  <path
                    class="cls-1"
                    d="M290.9,181.6l-2.8-1.6v-1.6l1.4.8,1.4-.8Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M290.9,182.1h-.2l-2.8-1.6c-.2-.1-.3-.2-.3-.4v-1.7c0-.2.1-.3.3-.4h.5l1.1.6,1.2-.7h.5a.8.8,0,0,1,.2.5v3.2a.8.8,0,0,1-.2.4Zm-2.3-2.4,1.8,1v-1.5l-.7.4h-.4l-.7-.3Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_111" data-name="Group 111">
              <g id="XMLID_88" data-name="XMLID 88">
                <g id="Vector_201" data-name="Vector 201">
                  <path class="cls-1" d="M289.5,176v3.2l-2.8-1.6Z" transform="translate(-57.9 0)" />
                  <path
                    d="M289.5,179.7h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.7-1.6h.5a.5.5,0,0,1,.3.5v3.2c0,.2-.1.3-.3.4S289.6,179.7,289.5,179.7Zm-1.8-2.1,1.3.7v-1.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_87" data-name="XMLID 87" class="cls-4">
                <g id="Vector_202" data-name="Vector 202" class="cls-4">
                  <path class="cls-1" d="M289.5,176v3.2l-2.8-1.6Z" transform="translate(-57.9 0)" />
                  <path
                    d="M289.5,179.7h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.7-1.6h.5a.5.5,0,0,1,.3.5v3.2c0,.2-.1.3-.3.4S289.6,179.7,289.5,179.7Zm-1.8-2.1,1.3.7v-1.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Group_112" data-name="Group 112">
            <g id="Group_113" data-name="Group 113">
              <g id="XMLID_86" data-name="XMLID 86">
                <g id="Vector_203" data-name="Vector 203">
                  <path
                    class="cls-1"
                    d="M293.7,170.3l-2.8-1.6V139.9l2.8,1.7Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.7,170.8h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V139.9c0-.2.1-.3.3-.4h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7c0,.2-.1.3-.3.4Zm-2.3-2.4,1.8,1V141.9l-1.8-1.1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_85" data-name="XMLID 85" class="cls-4">
                <g id="Vector_204" data-name="Vector 204" class="cls-4">
                  <path
                    class="cls-1"
                    d="M293.7,170.3l-2.8-1.6V139.9l2.8,1.7Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.7,170.8h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V139.9c0-.2.1-.3.3-.4h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7c0,.2-.1.3-.3.4Zm-2.3-2.4,1.8,1V141.9l-1.8-1.1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_114" data-name="Group 114">
              <g id="XMLID_84" data-name="XMLID 84">
                <g id="Vector_205" data-name="Vector 205">
                  <path
                    class="cls-1"
                    d="M290.9,143.1l-2.8-1.5V140l1.4.8,1.4-.9Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M290.9,143.6h-.2l-2.8-1.5c-.2-.1-.3-.2-.3-.4v-1.6a.5.5,0,0,1,.3-.5h.5l1.1.7,1.1-.7h.6a.5.5,0,0,1,.2.4v3.2a.5.5,0,0,1-.2.4Zm-2.3-2.3,1.8,1v-1.5l-.6.4h-.6l-.6-.4Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_83" data-name="XMLID 83" class="cls-4">
                <g id="Vector_206" data-name="Vector 206" class="cls-4">
                  <path
                    class="cls-1"
                    d="M290.9,143.1l-2.8-1.5V140l1.4.8,1.4-.9Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M290.9,143.6h-.2l-2.8-1.5c-.2-.1-.3-.2-.3-.4v-1.6a.5.5,0,0,1,.3-.5h.5l1.1.7,1.1-.7h.6a.5.5,0,0,1,.2.4v3.2a.5.5,0,0,1-.2.4Zm-2.3-2.3,1.8,1v-1.5l-.6.4h-.6l-.6-.4Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_115" data-name="Group 115">
              <g id="XMLID_82" data-name="XMLID 82">
                <g id="Vector_207" data-name="Vector 207">
                  <path
                    class="cls-1"
                    d="M289.5,137.6v3.2l-2.8-1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M289.5,141.3h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.7-1.6h.5a.5.5,0,0,1,.3.5v3.2c0,.2-.1.3-.3.4Zm-1.8-2.1,1.3.7v-1.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_81" data-name="XMLID 81" class="cls-4">
                <g id="Vector_208" data-name="Vector 208" class="cls-4">
                  <path
                    class="cls-1"
                    d="M289.5,137.6v3.2l-2.8-1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M289.5,141.3h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.7-1.6h.5a.5.5,0,0,1,.3.5v3.2c0,.2-.1.3-.3.4Zm-1.8-2.1,1.3.7v-1.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Group_116" data-name="Group 116">
            <g id="Group_117" data-name="Group 117">
              <g id="XMLID_80" data-name="XMLID 80">
                <g id="Vector_209" data-name="Vector 209">
                  <path
                    class="cls-1"
                    d="M293.7,138.3l-2.8-1.6V107.9l2.8,1.7Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.7,138.8h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V107.9c0-.2.1-.4.3-.4h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7c0,.2-.1.3-.3.4Zm-2.3-2.4,1.8,1V109.8l-1.8-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_79" data-name="XMLID 79" class="cls-4">
                <g id="Vector_210" data-name="Vector 210" class="cls-4">
                  <path
                    class="cls-1"
                    d="M293.7,138.3l-2.8-1.6V107.9l2.8,1.7Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.7,138.8h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V107.9c0-.2.1-.4.3-.4h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7c0,.2-.1.3-.3.4Zm-2.3-2.4,1.8,1V109.8l-1.8-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_118" data-name="Group 118">
              <g id="XMLID_78" data-name="XMLID 78">
                <g id="Vector_211" data-name="Vector 211">
                  <path
                    class="cls-1"
                    d="M290.9,111.1l-2.8-1.5V108l1.4.8,1.4-.9Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M290.9,111.6h-.2l-2.8-1.5c-.2-.1-.3-.2-.3-.4V108a.5.5,0,0,1,.3-.5h.5l1.1.7,1.1-.7h.6c.1,0,.2.2.2.4v3.2a.5.5,0,0,1-.2.4Zm-2.3-2.3,1.8.9v-1.4l-.6.4h-.6l-.6-.4Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_77" data-name="XMLID 77" class="cls-4">
                <g id="Vector_212" data-name="Vector 212" class="cls-4">
                  <path
                    class="cls-1"
                    d="M290.9,111.1l-2.8-1.5V108l1.4.8,1.4-.9Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M290.9,111.6h-.2l-2.8-1.5c-.2-.1-.3-.2-.3-.4V108a.5.5,0,0,1,.3-.5h.5l1.1.7,1.1-.7h.6c.1,0,.2.2.2.4v3.2a.5.5,0,0,1-.2.4Zm-2.3-2.3,1.8.9v-1.4l-.6.4h-.6l-.6-.4Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_119" data-name="Group 119">
              <g id="XMLID_76" data-name="XMLID 76">
                <g id="Vector_213" data-name="Vector 213">
                  <path
                    class="cls-1"
                    d="M289.5,105.6v3.2l-2.8-1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M289.5,109.3h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.7-1.6a.5.5,0,0,1,.5,0,.5.5,0,0,1,.3.5v3.2c0,.2-.1.3-.3.4Zm-1.8-2.1,1.3.7v-1.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_75" data-name="XMLID 75" class="cls-4">
                <g id="Vector_214" data-name="Vector 214" class="cls-4">
                  <path
                    class="cls-1"
                    d="M289.5,105.6v3.2l-2.8-1.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M289.5,109.3h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.3-.5l2.7-1.6a.5.5,0,0,1,.5,0,.5.5,0,0,1,.3.5v3.2c0,.2-.1.3-.3.4Zm-1.8-2.1,1.3.7v-1.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Vector_215" data-name="Vector 215">
            <path
              class="cls-1"
              d="M295,160.2l-2.7-1.6-22.2,12.8v3.2Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M270.1,175.1h-.2c-.2-.1-.3-.2-.3-.4v-3.3a.5.5,0,0,1,.3-.5L292,158.2h.5l2.8,1.6c.1,0,.2.2.2.4a.5.5,0,0,1-.2.4L270.4,175Zm.5-3.4v2L294,160.2l-1.7-1Z"
              transform="translate(-57.9 0)"
            />
          </g>
          <g id="Group_120" data-name="Group 120">
            <g id="Vector_216" data-name="Vector 216">
              <path
                class="cls-1"
                d="M295,201.7l-1.3.8V180.1l-2.8,1.6v-3.2l-1.4.9v-3.2l-13.8,8v3.1l-1.6.8v3.2l-2.6,1.6v22.3l-1.4.8V174.6L295,160.2Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M270.1,216.5h-.2a.5.5,0,0,1-.3-.5V174.6a.5.5,0,0,1,.3-.5l24.9-14.3h.5c.1,0,.2.2.2.4v41.5l-.2.4-1.4.8h-.5l-.2-.4V181l-2,1.1h-.5c-.2-.1-.3-.2-.3-.4v-2.3l-.6.4h-.5c-.2-.1-.3-.2-.3-.4V177l-12.8,7.4v2.9c0,.2-.1.3-.3.4l-1.3.7v2.9a.8.8,0,0,1-.2.5l-2.4,1.4v22a.5.5,0,0,1-.3.5l-1.3.8Zm.5-41.6v40.3l.4-.2V192.9l.2-.4,2.4-1.4v-3c0-.2.1-.3.3-.4l1.3-.7v-2.8a.8.8,0,0,1,.2-.5l13.8-8h.5a.5.5,0,0,1,.3.5v2.3l.6-.4h.6a.5.5,0,0,1,.2.4v2.3l2-1.1h.5c.2.1.3.2.3.4v21.5l.3-.2V161.1Z"
                transform="translate(-57.9 0)"
              />
            </g>
            <g id="Vector_217" data-name="Vector 217" class="cls-3">
              <path
                class="cls-1"
                d="M295,201.7l-1.3.8V180.1l-2.8,1.6v-3.2l-1.4.9v-3.2l-13.8,8v3.1l-1.6.8v3.2l-2.6,1.6v22.3l-1.4.8V174.6L295,160.2Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M270.1,216.5h-.2a.5.5,0,0,1-.3-.5V174.6a.5.5,0,0,1,.3-.5l24.9-14.3h.5c.1,0,.2.2.2.4v41.5l-.2.4-1.4.8h-.5l-.2-.4V181l-2,1.1h-.5c-.2-.1-.3-.2-.3-.4v-2.3l-.6.4h-.5c-.2-.1-.3-.2-.3-.4V177l-12.8,7.4v2.9c0,.2-.1.3-.3.4l-1.3.7v2.9a.8.8,0,0,1-.2.5l-2.4,1.4v22a.5.5,0,0,1-.3.5l-1.3.8Zm.5-41.6v40.3l.4-.2V192.9l.2-.4,2.4-1.4v-3c0-.2.1-.3.3-.4l1.3-.7v-2.8a.8.8,0,0,1,.2-.5l13.8-8h.5a.5.5,0,0,1,.3.5v2.3l.6-.4h.6a.5.5,0,0,1,.2.4v2.3l2-1.1h.5c.2.1.3.2.3.4v21.5l.3-.2V161.1Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_121" data-name="Group 121">
            <g id="Vector_218" data-name="Vector 218">
              <path
                class="cls-1"
                d="M272.9,183.6h.2l19.3-11.2c.2-.2.3-.4.2-.6a.5.5,0,0,0-.6-.1l-19.3,11.2a.4.4,0,0,0-.2.5Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M272.9,184.1a.9.9,0,0,1-.8-.5c-.3-.3-.1-.9.3-1.2l19.4-11.2h.6l.6.4a1.1,1.1,0,0,1-.3,1.3L273.4,184Zm0-1v.2h0Z"
                transform="translate(-57.9 0)"
              />
            </g>
            <g id="Vector_219" data-name="Vector 219" class="cls-5">
              <path
                class="cls-1"
                d="M272.9,183.6h.2l19.3-11.2c.2-.2.3-.4.2-.6a.5.5,0,0,0-.6-.1l-19.3,11.2a.4.4,0,0,0-.2.5Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M272.9,184.1a.9.9,0,0,1-.8-.5c-.3-.3-.1-.9.3-1.2l19.4-11.2h.6l.6.4a1.1,1.1,0,0,1-.3,1.3L273.4,184Zm0-1v.2h0Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_122" data-name="Group 122">
            <g id="XMLID_74" data-name="XMLID 74">
              <g id="Vector_220" data-name="Vector 220">
                <path
                  class="cls-1"
                  d="M292.3,170.1a.3.3,0,0,0,.3-.3V165a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,292.3,170.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,170.6a.9.9,0,0,1-.8-.8V165c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,292.3,170.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_123" data-name="Group 123">
              <g id="Vector_221" data-name="Vector 221">
                <path
                  class="cls-1"
                  d="M290.1,171.3a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0V171a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M290.1,171.8a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_124" data-name="Group 124">
              <g id="Vector_222" data-name="Vector 222">
                <path
                  class="cls-1"
                  d="M288,172.5a.3.3,0,0,0,.3-.3v-4.8l-.3-.3a.3.3,0,0,0-.3.3v4.8A.3.3,0,0,0,288,172.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M288,173c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8A.9.9,0,0,1,288,173Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_125" data-name="Group 125">
              <g id="Vector_223" data-name="Vector 223">
                <path
                  class="cls-1"
                  d="M285.8,173.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M285.8,174.3a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,1,1,1.6,0v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_126" data-name="Group 126">
              <g id="Vector_224" data-name="Vector 224">
                <path
                  class="cls-1"
                  d="M283.7,175.1l.3-.3V170c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.8A.3.3,0,0,0,283.7,175.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M283.7,175.6a.9.9,0,0,1-.8-.8V170c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,283.7,175.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_127" data-name="Group 127">
              <g id="Vector_225" data-name="Vector 225">
                <path
                  class="cls-1"
                  d="M281.5,176.3a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0V176a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M281.5,176.8a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,1,1,1.6,0h0V176a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_128" data-name="Group 128">
              <g id="Vector_226" data-name="Vector 226">
                <path
                  class="cls-1"
                  d="M279.4,177.5a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,279.4,177.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M279.4,178c-.4.1-.8-.3-.9-.7h0v-4.8a.9.9,0,0,1,.9-.8.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,279.4,178Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_129" data-name="Group 129">
              <g id="Vector_227" data-name="Vector 227">
                <path
                  class="cls-1"
                  d="M277.2,178.7a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M277.2,179.2c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_130" data-name="Group 130">
              <g id="Vector_228" data-name="Vector 228">
                <path
                  class="cls-1"
                  d="M275.1,180l.3-.3v-4.8a.3.3,0,0,0-.3-.3c-.2,0-.4.1-.4.3v4.8C274.7,179.9,274.9,180,275.1,180Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M275.1,180.5a.9.9,0,0,1-.9-.8v-4.8a.9.9,0,0,1,.8-.8h.1a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,275.1,180.5Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_73" data-name="XMLID 73">
              <g id="Vector_229" data-name="Vector 229">
                <path
                  class="cls-1"
                  d="M272.9,181.2a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,181.7c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_72" data-name="XMLID 72" class="cls-4">
              <g id="Vector_230" data-name="Vector 230" class="cls-4">
                <path
                  class="cls-1"
                  d="M292.3,170.1a.3.3,0,0,0,.3-.3V165a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,292.3,170.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,170.6a.9.9,0,0,1-.8-.8V165c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,292.3,170.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_131" data-name="Group 131" class="cls-4">
              <g id="Vector_231" data-name="Vector 231" class="cls-4">
                <path
                  class="cls-1"
                  d="M290.1,171.3a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0V171a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M290.1,171.8a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_132" data-name="Group 132" class="cls-4">
              <g id="Vector_232" data-name="Vector 232" class="cls-4">
                <path
                  class="cls-1"
                  d="M288,172.5a.3.3,0,0,0,.3-.3v-4.8l-.3-.3a.3.3,0,0,0-.3.3v4.8A.3.3,0,0,0,288,172.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M288,173c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8A.9.9,0,0,1,288,173Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_133" data-name="Group 133" class="cls-4">
              <g id="Vector_233" data-name="Vector 233" class="cls-4">
                <path
                  class="cls-1"
                  d="M285.8,173.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M285.8,174.3a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,1,1,1.6,0v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_134" data-name="Group 134" class="cls-4">
              <g id="Vector_234" data-name="Vector 234" class="cls-4">
                <path
                  class="cls-1"
                  d="M283.7,175.1l.3-.3V170c0-.2-.1-.4-.3-.4s-.3.2-.3.4v4.8A.3.3,0,0,0,283.7,175.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M283.7,175.6a.9.9,0,0,1-.8-.8V170c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,283.7,175.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_135" data-name="Group 135" class="cls-4">
              <g id="Vector_235" data-name="Vector 235" class="cls-4">
                <path
                  class="cls-1"
                  d="M281.5,176.3a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0V176a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M281.5,176.8a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,1,1,1.6,0h0V176a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_136" data-name="Group 136" class="cls-4">
              <g id="Vector_236" data-name="Vector 236" class="cls-4">
                <path
                  class="cls-1"
                  d="M279.4,177.5a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,279.4,177.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M279.4,178c-.4.1-.8-.3-.9-.7h0v-4.8a.9.9,0,0,1,.9-.8.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,279.4,178Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_137" data-name="Group 137" class="cls-4">
              <g id="Vector_237" data-name="Vector 237" class="cls-4">
                <path
                  class="cls-1"
                  d="M277.2,178.7a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M277.2,179.2c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_138" data-name="Group 138" class="cls-4">
              <g id="Vector_238" data-name="Vector 238" class="cls-4">
                <path
                  class="cls-1"
                  d="M275.1,180l.3-.3v-4.8a.3.3,0,0,0-.3-.3c-.2,0-.4.1-.4.3v4.8C274.7,179.9,274.9,180,275.1,180Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M275.1,180.5a.9.9,0,0,1-.9-.8v-4.8a.9.9,0,0,1,.8-.8h.1a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,275.1,180.5Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_71" data-name="XMLID 71" class="cls-4">
              <g id="Vector_239" data-name="Vector 239" class="cls-4">
                <path
                  class="cls-1"
                  d="M272.9,181.2a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,181.7c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_70" data-name="XMLID 70">
            <g id="Vector_240" data-name="Vector 240">
              <path
                class="cls-1"
                d="M295,121.9l-2.7-1.6-22.2,12.8v3.2Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M270.1,136.8h-.2c-.2-.1-.3-.2-.3-.4v-3.2c0-.2.1-.4.3-.4L292,120h.5l2.8,1.6a.5.5,0,0,1,.1.7h-.1l-24.9,14.4Zm.5-3.4v2L294,121.9l-1.7-1Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_139" data-name="Group 139">
            <g id="Vector_241" data-name="Vector 241">
              <path
                class="cls-1"
                d="M295,160.2l-1.3.8V141.8l-2.8,1.6v-3.2l-1.4.8v-3.2l-13.8,8V149l-1.6.9v3.2l-2.6,1.6v19.1l-1.4.8V136.3L295,121.9Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M270.1,175.1h-.2c-.2-.1-.3-.2-.3-.4V136.3c0-.2.1-.4.3-.4l24.9-14.4h.5a.5.5,0,0,1,.2.4v38.3a.5.5,0,0,1-.2.4l-1.4.8h-.5a.5.5,0,0,1-.2-.4V142.7l-2,1.1h-.5c-.2,0-.3-.2-.3-.4v-2.3l-.7.4h-.5c-.1,0-.2-.2-.2-.4v-2.3l-12.8,7.3V149c0,.2-.1.4-.3.4l-1.3.8v2.9l-.2.4-2.4,1.4v18.9c0,.2-.1.3-.3.4l-1.3.8Zm.5-38.5v37.1l.4-.2V154.7a.8.8,0,0,1,.2-.5l2.4-1.4v-2.9a.5.5,0,0,1,.3-.5l1.3-.7v-2.9a.5.5,0,0,1,.2-.4l13.8-8h.5c.2.1.3.2.3.4v2.4l.7-.4h.5a.5.5,0,0,1,.2.4v2.3l2-1.1h.5c.2.1.3.2.3.4v18.3l.3-.2V122.8Z"
                transform="translate(-57.9 0)"
              />
            </g>
            <g id="XMLID_69" data-name="XMLID 69" class="cls-3">
              <g id="Vector_242" data-name="Vector 242" class="cls-3">
                <path
                  class="cls-1"
                  d="M295,160.2l-1.3.8V141.8l-2.8,1.6v-3.2l-1.4.8v-3.2l-13.8,8V149l-1.6.9v3.2l-2.6,1.6v19.1l-1.4.8V136.3L295,121.9Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M270.1,175.1h-.2c-.2-.1-.3-.2-.3-.4V136.3c0-.2.1-.4.3-.4l24.9-14.4h.5a.5.5,0,0,1,.2.4v38.3a.5.5,0,0,1-.2.4l-1.4.8h-.5a.5.5,0,0,1-.2-.4V142.7l-2,1.1h-.5c-.2,0-.3-.2-.3-.4v-2.3l-.7.4h-.5c-.1,0-.2-.2-.2-.4v-2.3l-12.8,7.3V149c0,.2-.1.4-.3.4l-1.3.8v2.9l-.2.4-2.4,1.4v18.9c0,.2-.1.3-.3.4l-1.3.8Zm.5-38.5v37.1l.4-.2V154.7a.8.8,0,0,1,.2-.5l2.4-1.4v-2.9a.5.5,0,0,1,.3-.5l1.3-.7v-2.9a.5.5,0,0,1,.2-.4l13.8-8h.5c.2.1.3.2.3.4v2.4l.7-.4h.5a.5.5,0,0,1,.2.4v2.3l2-1.1h.5c.2.1.3.2.3.4v18.3l.3-.2V122.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_140" data-name="Group 140">
            <g id="XMLID_68" data-name="XMLID 68">
              <g id="Vector_243" data-name="Vector 243">
                <path
                  class="cls-1"
                  d="M272.9,145.3h.2l19.3-11.2a.5.5,0,0,0,.2-.6.5.5,0,0,0-.6-.1l-19.3,11.2a.4.4,0,0,0-.2.5C272.6,145.3,272.7,145.3,272.9,145.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,145.8a.9.9,0,0,1-.8-.4.7.7,0,0,1,.2-1.1h.1L291.8,133a.7.7,0,0,1,.6-.1.9.9,0,0,1,.6.3.9.9,0,0,1,.1.7.7.7,0,0,1-.4.6l-19.3,11.2Zm0-1v.2h0Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_67" data-name="XMLID 67" class="cls-5">
              <g id="Vector_244" data-name="Vector 244" class="cls-5">
                <path
                  class="cls-1"
                  d="M272.9,145.3h.2l19.3-11.2a.5.5,0,0,0,.2-.6.5.5,0,0,0-.6-.1l-19.3,11.2a.4.4,0,0,0-.2.5C272.6,145.3,272.7,145.3,272.9,145.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,145.8a.9.9,0,0,1-.8-.4.7.7,0,0,1,.2-1.1h.1L291.8,133a.7.7,0,0,1,.6-.1.9.9,0,0,1,.6.3.9.9,0,0,1,.1.7.7.7,0,0,1-.4.6l-19.3,11.2Zm0-1v.2h0Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_66" data-name="XMLID 66">
            <g id="Vector_245" data-name="Vector 245">
              <path
                class="cls-1"
                d="M295,90l-2.7-1.6-22.8,13.1.6,2.8Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M270.1,104.8h-.2a.5.5,0,0,1-.2-.4l-.7-2.8a.5.5,0,0,1,.3-.5L292,87.9h.5l2.8,1.6a.6.6,0,0,1,.1.8h-.1l-24.9,14.4Zm0-3,.4,1.8L294,90l-1.7-1.1Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_65" data-name="XMLID 65">
            <g id="Vector_246" data-name="Vector 246">
              <path
                class="cls-1"
                d="M295,121.9l-1.3.7V109.9l-2.8,1.6v-3.2l-1.4.8v-3.2l-13.8,8v3.2l-1.6.9v3.2l-2.6,1.5v12.8l-1.4.8v-32L295,90Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M270.1,136.8h-.2c-.2-.1-.3-.2-.3-.4v-32c0-.2.1-.3.3-.4l24.9-14.4h.5a.8.8,0,0,1,.2.5V122c0,.2-.1.4-.2.4l-1.4.8h-.5a.8.8,0,0,1-.2-.5V110.8l-2,1.1h-.5c-.2-.1-.3-.2-.3-.4v-2.3l-.6.4h-.5a.5.5,0,0,1-.3-.5v-2.3l-12.8,7.4v2.9c0,.2-.1.4-.3.4l-1.3.8v2.9l-.2.4L272,123v12.5c0,.2-.1.3-.3.4l-1.3.8Zm.5-32.2v30.8l.4-.2V122.7a.5.5,0,0,1,.2-.4l2.4-1.4V118a.5.5,0,0,1,.3-.5l1.3-.7v-2.9a.5.5,0,0,1,.2-.4l13.8-8h.5c.2.1.3.2.3.4v2.3l.6-.4h.6a.8.8,0,0,1,.2.5v2.3l2-1.1h.5c.2.1.3.2.3.4v11.9l.3-.2V90.8Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_64" data-name="XMLID 64" class="cls-3">
            <g id="Vector_247" data-name="Vector 247" class="cls-3">
              <path
                class="cls-1"
                d="M295,121.9l-1.3.7V109.9l-2.8,1.6v-3.2l-1.4.8v-3.2l-13.8,8v3.2l-1.6.9v3.2l-2.6,1.5v12.8l-1.4.8v-32L295,90Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M270.1,136.8h-.2c-.2-.1-.3-.2-.3-.4v-32c0-.2.1-.3.3-.4l24.9-14.4h.5a.8.8,0,0,1,.2.5V122c0,.2-.1.4-.2.4l-1.4.8h-.5a.8.8,0,0,1-.2-.5V110.8l-2,1.1h-.5c-.2-.1-.3-.2-.3-.4v-2.3l-.6.4h-.5a.5.5,0,0,1-.3-.5v-2.3l-12.8,7.4v2.9c0,.2-.1.4-.3.4l-1.3.8v2.9l-.2.4L272,123v12.5c0,.2-.1.3-.3.4l-1.3.8Zm.5-32.2v30.8l.4-.2V122.7a.5.5,0,0,1,.2-.4l2.4-1.4V118a.5.5,0,0,1,.3-.5l1.3-.7v-2.9a.5.5,0,0,1,.2-.4l13.8-8h.5c.2.1.3.2.3.4v2.3l.6-.4h.6a.8.8,0,0,1,.2.5v2.3l2-1.1h.5c.2.1.3.2.3.4v11.9l.3-.2V90.8Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="Group_141" data-name="Group 141">
            <g id="XMLID_63" data-name="XMLID 63">
              <g id="Vector_248" data-name="Vector 248">
                <path
                  class="cls-1"
                  d="M272.9,113.4h.2l19.3-11.2a.5.5,0,0,0,.2-.6.5.5,0,0,0-.6-.1l-19.3,11.2c-.2.1-.3.4-.2.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,113.9a.9.9,0,0,1-.7-.3h-.1a1,1,0,0,1,.3-1.2l19.4-11.2a.7.7,0,0,1,1.1.2h.1a1,1,0,0,1-.3,1.2l-19.3,11.2Zm0-.9Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_62" data-name="XMLID 62" class="cls-5">
              <g id="Vector_249" data-name="Vector 249" class="cls-5">
                <path
                  class="cls-1"
                  d="M272.9,113.4h.2l19.3-11.2a.5.5,0,0,0,.2-.6.5.5,0,0,0-.6-.1l-19.3,11.2c-.2.1-.3.4-.2.5Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,113.9a.9.9,0,0,1-.7-.3h-.1a1,1,0,0,1,.3-1.2l19.4-11.2a.7.7,0,0,1,1.1.2h.1a1,1,0,0,1-.3,1.2l-19.3,11.2Zm0-.9Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_142" data-name="Group 142">
            <g id="XMLID_61" data-name="XMLID 61">
              <g id="Vector_250" data-name="Vector 250">
                <path
                  class="cls-1"
                  d="M292.3,131.6a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,292.3,131.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,132.1c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0v4.8A.9.9,0,0,1,292.3,132.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_143" data-name="Group 143">
              <g id="Vector_251" data-name="Vector 251">
                <path
                  class="cls-1"
                  d="M290.1,132.9a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M290.1,133.4a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_144" data-name="Group 144">
              <g id="Vector_252" data-name="Vector 252">
                <path
                  class="cls-1"
                  d="M288,134.1a.3.3,0,0,0,.3-.3V129a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,288,134.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M288,134.6c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0v4.8A.9.9,0,0,1,288,134.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_145" data-name="Group 145">
              <g id="Vector_253" data-name="Vector 253">
                <path
                  class="cls-1"
                  d="M285.8,135.4a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M285.8,135.9a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,0,1,1.6,0h0v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_146" data-name="Group 146">
              <g id="Vector_254" data-name="Vector 254">
                <path
                  class="cls-1"
                  d="M283.7,136.6a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,283.7,136.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M283.7,137.1a.9.9,0,0,1-.8-.8v-4.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,283.7,137.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_147" data-name="Group 147">
              <g id="Vector_255" data-name="Vector 255">
                <path
                  class="cls-1"
                  d="M281.5,137.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M281.5,138.3c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_148" data-name="Group 148">
              <g id="Vector_256" data-name="Vector 256">
                <path
                  class="cls-1"
                  d="M279.4,139.1a.3.3,0,0,0,.3-.3V134a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,279.4,139.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M279.4,139.6a.9.9,0,0,1-.9-.8V134a.9.9,0,0,1,.9-.8.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,279.4,139.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_149" data-name="Group 149">
              <g id="Vector_257" data-name="Vector 257">
                <path
                  class="cls-1"
                  d="M277.2,140.3a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0V140a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M277.2,140.8c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0h0V140c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_150" data-name="Group 150">
              <g id="Vector_258" data-name="Vector 258">
                <path
                  class="cls-1"
                  d="M275.1,141.6l.3-.3v-4.8a.3.3,0,0,0-.3-.3c-.2,0-.4.1-.4.3v4.8C274.7,141.5,274.9,141.6,275.1,141.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M275.1,142.1a.9.9,0,0,1-.9-.8v-4.8a.9.9,0,0,1,.8-.8h.1a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,275.1,142.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_60" data-name="XMLID 60">
              <g id="Vector_259" data-name="Vector 259">
                <path
                  class="cls-1"
                  d="M272.9,142.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,143.3c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_59" data-name="XMLID 59" class="cls-4">
              <g id="Vector_260" data-name="Vector 260" class="cls-4">
                <path
                  class="cls-1"
                  d="M292.3,131.6a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,292.3,131.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,132.1c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0v4.8A.9.9,0,0,1,292.3,132.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_151" data-name="Group 151" class="cls-4">
              <g id="Vector_261" data-name="Vector 261" class="cls-4">
                <path
                  class="cls-1"
                  d="M290.1,132.9a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M290.1,133.4a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8c.4-.1.7.2.8.6v5c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_152" data-name="Group 152" class="cls-4">
              <g id="Vector_262" data-name="Vector 262" class="cls-4">
                <path
                  class="cls-1"
                  d="M288,134.1a.3.3,0,0,0,.3-.3V129a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,288,134.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M288,134.6c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0v4.8A.9.9,0,0,1,288,134.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_153" data-name="Group 153" class="cls-4">
              <g id="Vector_263" data-name="Vector 263" class="cls-4">
                <path
                  class="cls-1"
                  d="M285.8,135.4a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M285.8,135.9a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,0,1,1.6,0h0v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_154" data-name="Group 154" class="cls-4">
              <g id="Vector_264" data-name="Vector 264" class="cls-4">
                <path
                  class="cls-1"
                  d="M283.7,136.6a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,283.7,136.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M283.7,137.1a.9.9,0,0,1-.8-.8v-4.8c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,283.7,137.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_155" data-name="Group 155" class="cls-4">
              <g id="Vector_265" data-name="Vector 265" class="cls-4">
                <path
                  class="cls-1"
                  d="M281.5,137.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M281.5,138.3c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_156" data-name="Group 156" class="cls-4">
              <g id="Vector_266" data-name="Vector 266" class="cls-4">
                <path
                  class="cls-1"
                  d="M279.4,139.1a.3.3,0,0,0,.3-.3V134a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,279.4,139.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M279.4,139.6a.9.9,0,0,1-.9-.8V134a.9.9,0,0,1,.9-.8.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,279.4,139.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_157" data-name="Group 157" class="cls-4">
              <g id="Vector_267" data-name="Vector 267" class="cls-4">
                <path
                  class="cls-1"
                  d="M277.2,140.3a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0V140a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M277.2,140.8c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0h0V140c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_158" data-name="Group 158" class="cls-4">
              <g id="Vector_268" data-name="Vector 268" class="cls-4">
                <path
                  class="cls-1"
                  d="M275.1,141.6l.3-.3v-4.8a.3.3,0,0,0-.3-.3c-.2,0-.4.1-.4.3v4.8C274.7,141.5,274.9,141.6,275.1,141.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M275.1,142.1a.9.9,0,0,1-.9-.8v-4.8a.9.9,0,0,1,.8-.8h.1a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,275.1,142.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_58" data-name="XMLID 58" class="cls-4">
              <g id="Vector_269" data-name="Vector 269" class="cls-4">
                <path
                  class="cls-1"
                  d="M272.9,142.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,143.3c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_159" data-name="Group 159">
            <g id="XMLID_57" data-name="XMLID 57">
              <g id="Vector_270" data-name="Vector 270">
                <path
                  class="cls-1"
                  d="M292.3,99.6a.3.3,0,0,0,.3-.3V94.5a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,292.3,99.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,100.1c-.4.1-.7-.2-.8-.6v-5c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,292.3,100.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_160" data-name="Group 160">
              <g id="Vector_271" data-name="Vector 271">
                <path
                  class="cls-1"
                  d="M290.1,100.9a.3.3,0,0,0,.3-.3V95.8a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M290.1,101.4a.9.9,0,0,1-.8-.8V95.8a.9.9,0,0,1,.8-.8c.4-.1.7.2.8.6v5A.9.9,0,0,1,290.1,101.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_161" data-name="Group 161">
              <g id="Vector_272" data-name="Vector 272">
                <path
                  class="cls-1"
                  d="M288,102.1a.3.3,0,0,0,.3-.3V97a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,288,102.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M288,102.6c-.4.1-.7-.2-.8-.6V97a.8.8,0,0,1,1.6,0v4.8A.9.9,0,0,1,288,102.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_162" data-name="Group 162">
              <g id="Vector_273" data-name="Vector 273">
                <path
                  class="cls-1"
                  d="M285.8,103.3a.3.3,0,0,0,.3-.3V98.2a.3.3,0,0,0-.6,0V103a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M285.8,103.8c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0h0V103c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_163" data-name="Group 163">
              <g id="Vector_274" data-name="Vector 274">
                <path
                  class="cls-1"
                  d="M283.7,104.6a.3.3,0,0,0,.3-.3V99.5a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,283.7,104.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M283.7,105.1a.9.9,0,0,1-.8-.8V99.5c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,283.7,105.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_164" data-name="Group 164">
              <g id="Vector_275" data-name="Vector 275">
                <path
                  class="cls-1"
                  d="M281.5,105.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M281.5,106.3c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_165" data-name="Group 165">
              <g id="Vector_276" data-name="Vector 276">
                <path
                  class="cls-1"
                  d="M279.4,107.1a.3.3,0,0,0,.3-.3V102a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,279.4,107.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M279.4,107.6a.9.9,0,0,1-.9-.8V102a.9.9,0,0,1,.8-.8h.1a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,279.4,107.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_166" data-name="Group 166">
              <g id="Vector_277" data-name="Vector 277">
                <path
                  class="cls-1"
                  d="M277.2,108.3a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0h0V108a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M277.2,108.8c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0h0V108c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_167" data-name="Group 167">
              <g id="Vector_278" data-name="Vector 278">
                <path
                  class="cls-1"
                  d="M275.1,109.6c.2,0,.3-.2.3-.4v-4.7c0-.2-.1-.4-.3-.4a.4.4,0,0,0-.4.4v4.7A.4.4,0,0,0,275.1,109.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M275.1,110.1a.9.9,0,0,1-.9-.9v-4.7a.9.9,0,0,1,.9-.9.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,275.1,110.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_56" data-name="XMLID 56">
              <g id="Vector_279" data-name="Vector 279">
                <path
                  class="cls-1"
                  d="M272.9,110.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,111.3a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,0,1,1.6,0v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_55" data-name="XMLID 55" class="cls-4">
              <g id="Vector_280" data-name="Vector 280" class="cls-4">
                <path
                  class="cls-1"
                  d="M292.3,99.6a.3.3,0,0,0,.3-.3V94.5a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,292.3,99.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M292.3,100.1c-.4.1-.7-.2-.8-.6v-5c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,292.3,100.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_168" data-name="Group 168" class="cls-4">
              <g id="Vector_281" data-name="Vector 281" class="cls-4">
                <path
                  class="cls-1"
                  d="M290.1,100.9a.3.3,0,0,0,.3-.3V95.8a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M290.1,101.4a.9.9,0,0,1-.8-.8V95.8a.9.9,0,0,1,.8-.8c.4-.1.7.2.8.6v5A.9.9,0,0,1,290.1,101.4Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_169" data-name="Group 169" class="cls-4">
              <g id="Vector_282" data-name="Vector 282" class="cls-4">
                <path
                  class="cls-1"
                  d="M288,102.1a.3.3,0,0,0,.3-.3V97a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,288,102.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M288,102.6c-.4.1-.7-.2-.8-.6V97a.8.8,0,0,1,1.6,0v4.8A.9.9,0,0,1,288,102.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_170" data-name="Group 170" class="cls-4">
              <g id="Vector_283" data-name="Vector 283" class="cls-4">
                <path
                  class="cls-1"
                  d="M285.8,103.3a.3.3,0,0,0,.3-.3V98.2a.3.3,0,0,0-.6,0V103a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M285.8,103.8c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0h0V103c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_171" data-name="Group 171" class="cls-4">
              <g id="Vector_284" data-name="Vector 284" class="cls-4">
                <path
                  class="cls-1"
                  d="M283.7,104.6a.3.3,0,0,0,.3-.3V99.5a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,283.7,104.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M283.7,105.1a.9.9,0,0,1-.8-.8V99.5c-.1-.4.2-.7.6-.8h.2a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,283.7,105.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_172" data-name="Group 172" class="cls-4">
              <g id="Vector_285" data-name="Vector 285" class="cls-4">
                <path
                  class="cls-1"
                  d="M281.5,105.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M281.5,106.3c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_173" data-name="Group 173" class="cls-4">
              <g id="Vector_286" data-name="Vector 286" class="cls-4">
                <path
                  class="cls-1"
                  d="M279.4,107.1a.3.3,0,0,0,.3-.3V102a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,279.4,107.1Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M279.4,107.6a.9.9,0,0,1-.9-.8V102a.9.9,0,0,1,.8-.8h.1a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,279.4,107.6Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_174" data-name="Group 174" class="cls-4">
              <g id="Vector_287" data-name="Vector 287" class="cls-4">
                <path
                  class="cls-1"
                  d="M277.2,108.3a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0h0V108a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M277.2,108.8c-.4.1-.7-.2-.8-.6v-5a.8.8,0,0,1,1.6,0h0V108c.1.4-.2.7-.6.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_175" data-name="Group 175" class="cls-4">
              <g id="Vector_288" data-name="Vector 288" class="cls-4">
                <path
                  class="cls-1"
                  d="M275.1,109.6c.2,0,.3-.2.3-.4v-4.7c0-.2-.1-.4-.3-.4a.4.4,0,0,0-.4.4v4.7A.4.4,0,0,0,275.1,109.6Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M275.1,110.1a.9.9,0,0,1-.9-.9v-4.7a.9.9,0,0,1,.9-.9.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,275.1,110.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_54" data-name="XMLID 54" class="cls-4">
              <g id="Vector_289" data-name="Vector 289" class="cls-4">
                <path
                  class="cls-1"
                  d="M272.9,110.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M272.9,111.3a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,0,1,1.6,0v4.8a.9.9,0,0,1-.8.8Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
          </g>
          <g id="Group_176" data-name="Group 176">
            <g id="Group_177" data-name="Group 177">
              <g id="Group_178" data-name="Group 178">
                <g id="XMLID_53" data-name="XMLID 53">
                  <g id="Vector_290" data-name="Vector 290">
                    <path
                      class="cls-1"
                      d="M293.7,250.3l-2.8-1.6V220l2.8,1.6Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M293.7,250.8h-.3l-2.7-1.7c-.2-.1-.3-.2-.3-.4V220a.5.5,0,0,1,.3-.5h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7a.5.5,0,0,1-.3.5Zm-2.3-2.4,1.8,1V221.9l-1.8-1.1Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_52" data-name="XMLID 52" class="cls-2">
                  <g id="Vector_291" data-name="Vector 291" class="cls-2">
                    <path
                      class="cls-1"
                      d="M293.7,250.3l-2.8-1.6V220l2.8,1.6Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M293.7,250.8h-.3l-2.7-1.7c-.2-.1-.3-.2-.3-.4V220a.5.5,0,0,1,.3-.5h.5l2.7,1.6a.5.5,0,0,1,.3.5v28.7a.5.5,0,0,1-.3.5Zm-2.3-2.4,1.8,1V221.9l-1.8-1.1Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_179" data-name="Group 179">
                <g id="XMLID_51" data-name="XMLID 51">
                  <g id="Vector_292" data-name="Vector 292">
                    <path
                      class="cls-1"
                      d="M290.9,223.2l-2.8-1.6V220l1.4.8,1.4-.8Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M290.9,223.7h-.2l-2.8-1.5a.5.5,0,0,1-.3-.5v-1.6c0-.2.1-.3.3-.4h.5l1.1.7,1.1-.8h.6a.8.8,0,0,1,.2.5v3.2a.8.8,0,0,1-.2.4Zm-2.3-2.4,1.8,1v-1.4l-.6.4h-.6l-.6-.4Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_50" data-name="XMLID 50" class="cls-2">
                  <g id="Vector_293" data-name="Vector 293" class="cls-2">
                    <path
                      class="cls-1"
                      d="M290.9,223.2l-2.8-1.6V220l1.4.8,1.4-.8Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M290.9,223.7h-.2l-2.8-1.5a.5.5,0,0,1-.3-.5v-1.6c0-.2.1-.3.3-.4h.5l1.1.7,1.1-.8h.6a.8.8,0,0,1,.2.5v3.2a.8.8,0,0,1-.2.4Zm-2.3-2.4,1.8,1v-1.4l-.6.4h-.6l-.6-.4Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_180" data-name="Group 180">
                <g id="XMLID_49" data-name="XMLID 49">
                  <g id="Vector_294" data-name="Vector 294">
                    <path
                      class="cls-1"
                      d="M289.5,217.6v3.2l-2.8-1.6Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M289.5,221.3h-.3l-2.7-1.6a.5.5,0,0,1-.3-.5c0-.2.1-.3.3-.4l2.7-1.6h.5c.2.1.3.2.3.4v3.2a.5.5,0,0,1-.3.5Zm-1.8-2.1,1.3.8v-1.5Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_48" data-name="XMLID 48" class="cls-2">
                  <g id="Vector_295" data-name="Vector 295" class="cls-2">
                    <path
                      class="cls-1"
                      d="M289.5,217.6v3.2l-2.8-1.6Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M289.5,221.3h-.3l-2.7-1.6a.5.5,0,0,1-.3-.5c0-.2.1-.3.3-.4l2.7-1.6h.5c.2.1.3.2.3.4v3.2a.5.5,0,0,1-.3.5Zm-1.8-2.1,1.3.8v-1.5Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="XMLID_47" data-name="XMLID 47">
              <g id="Vector_296" data-name="Vector 296">
                <path
                  class="cls-1"
                  d="M295,201.7l-2.7-1.6-22.2,12.7V216Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M270.1,216.5h-.2a.5.5,0,0,1-.3-.5v-3.2c0-.2.1-.3.3-.4L292,199.6h.5l2.8,1.6a.8.8,0,0,1,.2.5l-.2.4-24.9,14.4Zm.5-3.4v2.1L294,201.7l-1.7-1.1Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="Group_181" data-name="Group 181">
              <g id="XMLID_46" data-name="XMLID 46">
                <g id="Vector_297" data-name="Vector 297">
                  <path
                    class="cls-1"
                    d="M295,249.5l-1.3.8V221.6l-2.8,1.6V220l-1.4.8v-3.2l-13.8,8v3.2l-1.6.9v3.2l-2.6,1.5v28.7l-1.4.8V216L295,201.7Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M270.1,264.4h-.2c-.2,0-.3-.2-.3-.4V216c0-.2.1-.3.3-.4l24.9-14.4h.5a.8.8,0,0,1,.2.5v47.8a.8.8,0,0,1-.2.5l-1.4.8h-.5a.8.8,0,0,1-.2-.5V222.4l-2,1.2h-.5c-.2-.1-.3-.2-.3-.4v-2.3l-.6.4h-.5a.5.5,0,0,1-.3-.5v-2.3l-12.8,7.4v2.9a.5.5,0,0,1-.3.5l-1.3.7v2.9a.5.5,0,0,1-.2.4l-2.4,1.4v28.4c0,.2-.1.4-.3.4l-1.3.8Zm.5-48.1V263l.4-.2V234.4a.5.5,0,0,1,.2-.4l2.4-1.4v-2.9a.5.5,0,0,1,.3-.5l1.3-.7v-2.9a.5.5,0,0,1,.2-.4l13.8-8h.5c.2.1.3.2.3.4v2.3l.6-.4h.6a.8.8,0,0,1,.2.5v2.3l2-1.2h.5a.5.5,0,0,1,.3.5v27.9l.3-.3V202.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_45" data-name="XMLID 45" class="cls-3">
                <g id="Vector_298" data-name="Vector 298" class="cls-3">
                  <path
                    class="cls-1"
                    d="M295,249.5l-1.3.8V221.6l-2.8,1.6V220l-1.4.8v-3.2l-13.8,8v3.2l-1.6.9v3.2l-2.6,1.5v28.7l-1.4.8V216L295,201.7Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M270.1,264.4h-.2c-.2,0-.3-.2-.3-.4V216c0-.2.1-.3.3-.4l24.9-14.4h.5a.8.8,0,0,1,.2.5v47.8a.8.8,0,0,1-.2.5l-1.4.8h-.5a.8.8,0,0,1-.2-.5V222.4l-2,1.2h-.5c-.2-.1-.3-.2-.3-.4v-2.3l-.6.4h-.5a.5.5,0,0,1-.3-.5v-2.3l-12.8,7.4v2.9a.5.5,0,0,1-.3.5l-1.3.7v2.9a.5.5,0,0,1-.2.4l-2.4,1.4v28.4c0,.2-.1.4-.3.4l-1.3.8Zm.5-48.1V263l.4-.2V234.4a.5.5,0,0,1,.2-.4l2.4-1.4v-2.9a.5.5,0,0,1,.3-.5l1.3-.7v-2.9a.5.5,0,0,1,.2-.4l13.8-8h.5c.2.1.3.2.3.4v2.3l.6-.4h.6a.8.8,0,0,1,.2.5v2.3l2-1.2h.5a.5.5,0,0,1,.3.5v27.9l.3-.3V202.5Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_182" data-name="Group 182">
              <g id="XMLID_44" data-name="XMLID 44">
                <g id="Vector_299" data-name="Vector 299">
                  <path
                    class="cls-1"
                    d="M272.9,225.1h.2l19.3-11.2a.4.4,0,0,0,.2-.5c-.2-.2-.4-.3-.6-.1l-19.3,11.1c-.2.2-.3.4-.2.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M272.9,225.6a.9.9,0,0,1-.8-.5.7.7,0,0,1-.1-.6c0-.2.2-.4.4-.6l19.4-11.2h.6l.6.4a.9.9,0,0,1,.1.7.7.7,0,0,1-.4.5l-19.3,11.1Zm0-1v.2h0Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_35" data-name="XMLID 35" class="cls-5">
                <g id="Vector_300" data-name="Vector 300" class="cls-5">
                  <path
                    class="cls-1"
                    d="M272.9,225.1h.2l19.3-11.2a.4.4,0,0,0,.2-.5c-.2-.2-.4-.3-.6-.1l-19.3,11.1c-.2.2-.3.4-.2.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M272.9,225.6a.9.9,0,0,1-.8-.5.7.7,0,0,1-.1-.6c0-.2.2-.4.4-.6l19.4-11.2h.6l.6.4a.9.9,0,0,1,.1.7.7.7,0,0,1-.4.5l-19.3,11.1Zm0-1v.2h0Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
            <g id="Group_183" data-name="Group 183">
              <g id="XMLID_32" data-name="XMLID 32">
                <g id="XMLID_34" data-name="XMLID 34">
                  <g id="Vector_301" data-name="Vector 301">
                    <path
                      class="cls-1"
                      d="M292.3,211.6l.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,292.3,211.6Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M292.3,212.1a.9.9,0,0,1-.8-.8h0v-4.7c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,292.3,212.1Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_184" data-name="Group 184">
                  <g id="Vector_302" data-name="Vector 302">
                    <path
                      class="cls-1"
                      d="M290.1,212.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M290.1,213.3a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8c.4-.1.7.2.8.6v5A.9.9,0,0,1,290.1,213.3Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_185" data-name="Group 185">
                  <g id="Vector_303" data-name="Vector 303">
                    <path
                      class="cls-1"
                      d="M288,214a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,288,214Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M288,214.5c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8A.9.9,0,0,1,288,214.5Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_186" data-name="Group 186">
                  <g id="Vector_304" data-name="Vector 304">
                    <path
                      class="cls-1"
                      d="M285.8,215.2a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M285.8,215.7c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_187" data-name="Group 187">
                  <g id="Vector_305" data-name="Vector 305">
                    <path
                      class="cls-1"
                      d="M283.7,216.5a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,283.7,216.5Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M283.7,217a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,0,1,1.6,0v4.8A.9.9,0,0,1,283.7,217Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_188" data-name="Group 188">
                  <g id="Vector_306" data-name="Vector 306">
                    <path
                      class="cls-1"
                      d="M281.5,217.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M281.5,218.3a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,1,1,1.6,0v4.8a.9.9,0,0,1-.8.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_189" data-name="Group 189">
                  <g id="Vector_307" data-name="Vector 307">
                    <path
                      class="cls-1"
                      d="M279.4,219a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,279.4,219Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M279.4,219.5a.9.9,0,0,1-.9-.8v-4.8a.9.9,0,0,1,.8-.8h.1a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,279.4,219.5Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_190" data-name="Group 190">
                  <g id="Vector_308" data-name="Vector 308">
                    <path
                      class="cls-1"
                      d="M277.2,220.2a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M277.2,220.7c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_191" data-name="Group 191">
                  <g id="Vector_309" data-name="Vector 309">
                    <path
                      class="cls-1"
                      d="M275.1,221.5c.2,0,.3-.2.3-.4v-4.8c-.1-.2-.4-.3-.5-.2l-.2.2v4.8a.4.4,0,0,0,.4.4Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M275.1,221.9c-.4.1-.8-.3-.9-.7h0v-4.7a.9.9,0,0,1,.9-.9.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,275.1,221.9Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_33" data-name="XMLID 33">
                  <g id="Vector_310" data-name="Vector 310">
                    <path
                      class="cls-1"
                      d="M272.9,222.7a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M272.9,223.2a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,1,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_29" data-name="XMLID 29" class="cls-4">
                <g id="XMLID_31" data-name="XMLID 31" class="cls-4">
                  <g id="Vector_311" data-name="Vector 311" class="cls-4">
                    <path
                      class="cls-1"
                      d="M292.3,211.6l.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,292.3,211.6Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M292.3,212.1a.9.9,0,0,1-.8-.8h0v-4.7c-.1-.4.3-.8.7-.9h.1a.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,292.3,212.1Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_192" data-name="Group 192" class="cls-4">
                  <g id="Vector_312" data-name="Vector 312" class="cls-4">
                    <path
                      class="cls-1"
                      d="M290.1,212.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M290.1,213.3a.9.9,0,0,1-.8-.8v-4.8a.9.9,0,0,1,.8-.8c.4-.1.7.2.8.6v5A.9.9,0,0,1,290.1,213.3Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_193" data-name="Group 193" class="cls-4">
                  <g id="Vector_313" data-name="Vector 313" class="cls-4">
                    <path
                      class="cls-1"
                      d="M288,214a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8A.3.3,0,0,0,288,214Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M288,214.5c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8A.9.9,0,0,1,288,214.5Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_194" data-name="Group 194" class="cls-4">
                  <g id="Vector_314" data-name="Vector 314" class="cls-4">
                    <path
                      class="cls-1"
                      d="M285.8,215.2a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M285.8,215.7c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_195" data-name="Group 195" class="cls-4">
                  <g id="Vector_315" data-name="Vector 315" class="cls-4">
                    <path
                      class="cls-1"
                      d="M283.7,216.5a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,283.7,216.5Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M283.7,217a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,0,1,1.6,0v4.8A.9.9,0,0,1,283.7,217Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_196" data-name="Group 196" class="cls-4">
                  <g id="Vector_316" data-name="Vector 316" class="cls-4">
                    <path
                      class="cls-1"
                      d="M281.5,217.8a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M281.5,218.3a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,1,1,1.6,0v4.8a.9.9,0,0,1-.8.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_197" data-name="Group 197" class="cls-4">
                  <g id="Vector_317" data-name="Vector 317" class="cls-4">
                    <path
                      class="cls-1"
                      d="M279.4,219a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,0,0-.6,0v4.8A.3.3,0,0,0,279.4,219Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M279.4,219.5a.9.9,0,0,1-.9-.8v-4.8a.9.9,0,0,1,.8-.8h.1a.9.9,0,0,1,.8.8v4.8A.9.9,0,0,1,279.4,219.5Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_198" data-name="Group 198" class="cls-4">
                  <g id="Vector_318" data-name="Vector 318" class="cls-4">
                    <path
                      class="cls-1"
                      d="M277.2,220.2a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M277.2,220.7c-.4.1-.7-.2-.8-.6v-5a.8.8,0,1,1,1.6,0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="Group_199" data-name="Group 199" class="cls-4">
                  <g id="Vector_319" data-name="Vector 319" class="cls-4">
                    <path
                      class="cls-1"
                      d="M275.1,221.5c.2,0,.3-.2.3-.4v-4.8c-.1-.2-.4-.3-.5-.2l-.2.2v4.8a.4.4,0,0,0,.4.4Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M275.1,221.9c-.4.1-.8-.3-.9-.7h0v-4.7a.9.9,0,0,1,.9-.9.9.9,0,0,1,.8.9v4.7A.9.9,0,0,1,275.1,221.9Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_30" data-name="XMLID 30" class="cls-4">
                  <g id="Vector_320" data-name="Vector 320" class="cls-4">
                    <path
                      class="cls-1"
                      d="M272.9,222.7a.3.3,0,0,0,.3-.3v-4.8a.3.3,0,1,0-.6,0h0v4.8a.3.3,0,0,0,.3.3Z"
                      transform="translate(-57.9 0)"
                    />
                    <path
                      d="M272.9,223.2a.9.9,0,0,1-.8-.8v-4.8a.8.8,0,1,1,1.6,0h0v4.8c.1.4-.2.7-.6.8Z"
                      transform="translate(-57.9 0)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_28" data-name="XMLID 28">
          <g id="Vector_321" data-name="Vector 321">
            <path
              class="cls-1"
              d="M270.1,101.8V301.5a1.3,1.3,0,0,1-.6,1.1l-2.1,1.2-2.8-1.6V101.8a1.3,1.3,0,0,1,.6-1l1.6-1H268l1.6,1A1.4,1.4,0,0,1,270.1,101.8Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M267.4,304.3h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V101.8a1.9,1.9,0,0,1,.9-1.5l1.6-.9a1.5,1.5,0,0,1,1.6,0l1.6.9h.1a2.7,2.7,0,0,1,.7,1.4V301.5a1.9,1.9,0,0,1-.9,1.5l-2.1,1.2Zm-2.3-2.4,2.3,1.3,1.9-1.1a.7.7,0,0,0,.3-.6V101.8a.9.9,0,0,0-.3-.6l-1.6-.9h-.6l-1.6.9a.7.7,0,0,0-.4.6Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_27" data-name="XMLID 27" class="cls-4">
          <g id="Vector_322" data-name="Vector 322" class="cls-4">
            <path
              class="cls-1"
              d="M270.1,101.8V301.5a1.3,1.3,0,0,1-.6,1.1l-2.1,1.2-2.8-1.6V101.8a1.3,1.3,0,0,1,.6-1l1.6-1H268l1.6,1A1.4,1.4,0,0,1,270.1,101.8Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M267.4,304.3h-.3l-2.7-1.6c-.2-.1-.3-.2-.3-.4V101.8a1.9,1.9,0,0,1,.9-1.5l1.6-.9a1.5,1.5,0,0,1,1.6,0l1.6.9h.1a2.7,2.7,0,0,1,.7,1.4V301.5a1.9,1.9,0,0,1-.9,1.5l-2.1,1.2Zm-2.3-2.4,2.3,1.3,1.9-1.1a.7.7,0,0,0,.3-.6V101.8a.9.9,0,0,0-.3-.6l-1.6-.9h-.6l-1.6.9a.7.7,0,0,0-.4.6Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="Vector_323" data-name="Vector 323">
          <path
            class="cls-1"
            d="M267.4,103.4V303.1c0,.4.2.6.6.4l1.6-.9a1.4,1.4,0,0,0,.6-1.1V101.8c0-.4-.2-.5-.6-.4l-1.6,1A1.1,1.1,0,0,0,267.4,103.4Z"
            transform="translate(-57.9 0)"
          />
          <path
            d="M267.7,304.1l-.4-.2c-.3-.1-.4-.4-.4-.8V103.4a1.9,1.9,0,0,1,.8-1.5l1.6-.9a.9.9,0,0,1,1.4.8V301.5a1.6,1.6,0,0,1-.9,1.5l-1.6.9Zm2-202.1-1.5.8a.7.7,0,0,0-.3.6V303l1.4-.9a.7.7,0,0,0,.4-.6Z"
            transform="translate(-57.9 0)"
          />
        </g>
        <g id="Vector_324" data-name="Vector 324" class="cls-2">
          <path
            class="cls-1"
            d="M267.4,103.4V303.1c0,.4.2.6.6.4l1.6-.9a1.4,1.4,0,0,0,.6-1.1V101.8c0-.4-.2-.5-.6-.4l-1.6,1A1.1,1.1,0,0,0,267.4,103.4Z"
            transform="translate(-57.9 0)"
          />
          <path
            d="M267.7,304.1l-.4-.2c-.3-.1-.4-.4-.4-.8V103.4a1.9,1.9,0,0,1,.8-1.5l1.6-.9a.9.9,0,0,1,1.4.8V301.5a1.6,1.6,0,0,1-.9,1.5l-1.6.9Zm2-202.1-1.5.8a.7.7,0,0,0-.3.6V303l1.4-.9a.7.7,0,0,0,.4-.6Z"
            transform="translate(-57.9 0)"
          />
        </g>
        <g id="Group_200" data-name="Group 200">
          <g id="Vector_325" data-name="Vector 325">
            <path
              class="cls-1"
              d="M267.9,265.1l4.4-2.5c.3-.2.6,0,.6.4v37.6l-5.5,3.2V266.2A1.6,1.6,0,0,1,267.9,265.1Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M267.4,304.3h-.3a.5.5,0,0,1-.2-.4V266.2a1.8,1.8,0,0,1,.8-1.5h0l4.3-2.5a1.2,1.2,0,0,1,1-.1,1.5,1.5,0,0,1,.4.9v37.6a.5.5,0,0,1-.2.4l-5.6,3.2Zm.8-38.7a.7.7,0,0,0-.3.6v36.7l4.5-2.6V263.1Z"
              transform="translate(-57.9 0)"
            />
          </g>
          <g id="Vector_326" data-name="Vector 326" class="cls-2">
            <path
              class="cls-1"
              d="M267.9,265.1l4.4-2.5c.3-.2.6,0,.6.4v37.6l-5.5,3.2V266.2A1.6,1.6,0,0,1,267.9,265.1Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M267.4,304.3h-.3a.5.5,0,0,1-.2-.4V266.2a1.8,1.8,0,0,1,.8-1.5h0l4.3-2.5a1.2,1.2,0,0,1,1-.1,1.5,1.5,0,0,1,.4.9v37.6a.5.5,0,0,1-.2.4l-5.6,3.2Zm.8-38.7a.7.7,0,0,0-.3.6v36.7l4.5-2.6V263.1Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="Group_201" data-name="Group 201">
          <g id="XMLID_20" data-name="XMLID 20">
            <g id="XMLID_26" data-name="XMLID 26">
              <g id="Vector_327" data-name="Vector 327">
                <path
                  class="cls-1"
                  d="M270.1,286.3,295,271.9v-3.2l-24.9,14.4Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M270.1,286.8h-.2c-.2-.1-.3-.2-.3-.4v-3.2a.5.5,0,0,1,.3-.5l24.9-14.3h.5a.5.5,0,0,1,.2.4V272a.5.5,0,0,1-.2.4l-24.9,14.4Zm.5-3.4v2l23.9-13.8v-2Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_21" data-name="XMLID 21">
              <g id="XMLID_25" data-name="XMLID 25">
                <g id="Vector_328" data-name="Vector 328">
                  <path
                    class="cls-1"
                    d="M271.5,298.6a1.1,1.1,0,0,0,.9-.4l22.1-25.5a1.2,1.2,0,0,0-1.8-1.6l-22.1,25.5a1.2,1.2,0,0,0,.1,1.7h0A1.1,1.1,0,0,0,271.5,298.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M271.5,299.1a1.7,1.7,0,0,1-1.2-.4,1.8,1.8,0,0,1-.1-2.4l22.1-25.5a1.7,1.7,0,0,1,2.6,2.2l-22.1,25.5A1.6,1.6,0,0,1,271.5,299.1Zm22.2-27.9a.9.9,0,0,0-.7.3l-22.1,25.4a.9.9,0,0,0,.1,1.1h.5l.5-.2,22.2-25.4a.9.9,0,0,0-.1-1.1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_24" data-name="XMLID 24">
                <g id="Vector_329" data-name="Vector 329">
                  <path
                    class="cls-1"
                    d="M293.6,285.8a1.2,1.2,0,0,0,0-2.4H271.4a1.2,1.2,0,0,0,0,2.4Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.6,286.3H271.4a1.8,1.8,0,0,1-1.7-1.7h0a1.8,1.8,0,0,1,1.7-1.7h22.2a1.8,1.8,0,0,1,1.7,1.7h0a1.6,1.6,0,0,1-1.5,1.7Zm-22.2-2.4a.7.7,0,0,0,0,1.4h22.2a.7.7,0,1,0,0-1.4Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_23" data-name="XMLID 23">
                <g id="Vector_330" data-name="Vector 330">
                  <path
                    class="cls-1"
                    d="M271.5,283.6a1.1,1.1,0,0,0,.9-.5l22.1-25.5a1.2,1.2,0,0,0-.1-1.7h0a1.4,1.4,0,0,0-1.7.1l-22.1,25.5a1.3,1.3,0,0,0,.1,1.8A1.1,1.1,0,0,0,271.5,283.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M271.5,284.1a1.3,1.3,0,0,1-1.2-.5,1.8,1.8,0,0,1-.1-2.4l22.1-25.5a1.7,1.7,0,0,1,2.4-.2h0a1.9,1.9,0,0,1,.2,2.5l-22.1,25.5A1.6,1.6,0,0,1,271.5,284.1Zm22.2-28a.9.9,0,0,0-.7.3l-22.1,25.5a.8.8,0,0,0,.1,1,.5.5,0,0,0,.8.1l.2-.2,22.2-25.5a.8.8,0,0,0-.1-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_22" data-name="XMLID 22">
                <g id="Vector_331" data-name="Vector 331">
                  <path
                    class="cls-1"
                    d="M293.6,270.9a1.2,1.2,0,0,0,1.2-1.2h0a1.2,1.2,0,0,0-1.2-1.2H271.4a1.2,1.2,0,0,0-1.2,1.2h0a1.3,1.3,0,0,0,1.2,1.3Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.6,271.4H271.4a1.8,1.8,0,0,1-1.7-1.8,1.8,1.8,0,0,1,1.7-1.7h22.2a1.8,1.8,0,0,1,1.7,1.7h0a1.8,1.8,0,0,1-1.6,1.8Zm-22.2-2.5a.7.7,0,0,0-.7.7h0a.8.8,0,0,0,.7.8h22.2a.8.8,0,0,0,.7-.8.7.7,0,0,0-.7-.7H271.4Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="XMLID_13" data-name="XMLID 13" class="cls-2">
            <g id="XMLID_19" data-name="XMLID 19" class="cls-2">
              <g id="Vector_332" data-name="Vector 332" class="cls-2">
                <path
                  class="cls-1"
                  d="M270.1,286.3,295,271.9v-3.2l-24.9,14.4Z"
                  transform="translate(-57.9 0)"
                />
                <path
                  d="M270.1,286.8h-.2c-.2-.1-.3-.2-.3-.4v-3.2a.5.5,0,0,1,.3-.5l24.9-14.3h.5a.5.5,0,0,1,.2.4V272a.5.5,0,0,1-.2.4l-24.9,14.4Zm.5-3.4v2l23.9-13.8v-2Z"
                  transform="translate(-57.9 0)"
                />
              </g>
            </g>
            <g id="XMLID_14" data-name="XMLID 14" class="cls-2">
              <g id="XMLID_18" data-name="XMLID 18" class="cls-2">
                <g id="Vector_333" data-name="Vector 333" class="cls-2">
                  <path
                    class="cls-1"
                    d="M271.5,298.6a1.1,1.1,0,0,0,.9-.4l22.1-25.5a1.2,1.2,0,0,0-1.8-1.6l-22.1,25.5a1.2,1.2,0,0,0,.1,1.7h0A1.1,1.1,0,0,0,271.5,298.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M271.5,299.1a1.7,1.7,0,0,1-1.2-.4,1.8,1.8,0,0,1-.1-2.4l22.1-25.5a1.7,1.7,0,0,1,2.6,2.2l-22.1,25.5A1.6,1.6,0,0,1,271.5,299.1Zm22.2-27.9a.9.9,0,0,0-.7.3l-22.1,25.4a.9.9,0,0,0,.1,1.1h.5l.5-.2,22.2-25.4a.9.9,0,0,0-.1-1.1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_17" data-name="XMLID 17" class="cls-2">
                <g id="Vector_334" data-name="Vector 334" class="cls-2">
                  <path
                    class="cls-1"
                    d="M293.6,285.8a1.2,1.2,0,0,0,0-2.4H271.4a1.2,1.2,0,0,0,0,2.4Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.6,286.3H271.4a1.8,1.8,0,0,1-1.7-1.7h0a1.8,1.8,0,0,1,1.7-1.7h22.2a1.8,1.8,0,0,1,1.7,1.7h0a1.6,1.6,0,0,1-1.5,1.7Zm-22.2-2.4a.7.7,0,0,0,0,1.4h22.2a.7.7,0,1,0,0-1.4Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_16" data-name="XMLID 16" class="cls-2">
                <g id="Vector_335" data-name="Vector 335" class="cls-2">
                  <path
                    class="cls-1"
                    d="M271.5,283.6a1.1,1.1,0,0,0,.9-.5l22.1-25.5a1.2,1.2,0,0,0-.1-1.7h0a1.4,1.4,0,0,0-1.7.1l-22.1,25.5a1.3,1.3,0,0,0,.1,1.8A1.1,1.1,0,0,0,271.5,283.6Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M271.5,284.1a1.3,1.3,0,0,1-1.2-.5,1.8,1.8,0,0,1-.1-2.4l22.1-25.5a1.7,1.7,0,0,1,2.4-.2h0a1.9,1.9,0,0,1,.2,2.5l-22.1,25.5A1.6,1.6,0,0,1,271.5,284.1Zm22.2-28a.9.9,0,0,0-.7.3l-22.1,25.5a.8.8,0,0,0,.1,1,.5.5,0,0,0,.8.1l.2-.2,22.2-25.5a.8.8,0,0,0-.1-1Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
              <g id="XMLID_15" data-name="XMLID 15" class="cls-2">
                <g id="Vector_336" data-name="Vector 336" class="cls-2">
                  <path
                    class="cls-1"
                    d="M293.6,270.9a1.2,1.2,0,0,0,1.2-1.2h0a1.2,1.2,0,0,0-1.2-1.2H271.4a1.2,1.2,0,0,0-1.2,1.2h0a1.3,1.3,0,0,0,1.2,1.3Z"
                    transform="translate(-57.9 0)"
                  />
                  <path
                    d="M293.6,271.4H271.4a1.8,1.8,0,0,1-1.7-1.8,1.8,1.8,0,0,1,1.7-1.7h22.2a1.8,1.8,0,0,1,1.7,1.7h0a1.8,1.8,0,0,1-1.6,1.8Zm-22.2-2.5a.7.7,0,0,0-.7.7h0a.8.8,0,0,0,.7.8h22.2a.8.8,0,0,0,.7-.8.7.7,0,0,0-.7-.7H271.4Z"
                    transform="translate(-57.9 0)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_9" data-name="XMLID 9">
          <g id="XMLID_12" data-name="XMLID 12">
            <g id="Vector_337" data-name="Vector 337">
              <path
                class="cls-6"
                d="M271.5,263.1l30,17.8,22.2-12.8-52.2-30.9Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M301.5,281.4h-.3l-30-17.8c-.1,0-.2-.2-.2-.4v-26a.8.8,0,0,1,.2-.5h.5l52.2,30.9c.2,0,.3.2.3.4s-.1.3-.3.4l-22.2,12.8ZM272,262.8l29.5,17.5,21.2-12.2-50.7-30Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_11" data-name="XMLID 11">
            <g id="Vector_338" data-name="Vector 338">
              <path
                class="cls-1"
                d="M301.5,280.9v3.2l-30-17.9v-3.1Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M301.5,284.6h-.3l-30-17.8a.8.8,0,0,1-.2-.5v-3.1a.5.5,0,0,1,.2-.4.5.5,0,0,1,.5,0l30,17.7a.5.5,0,0,1,.3.5v3.2c0,.2-.1.3-.3.4ZM272,266l29,17.2v-2L272,264Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
          <g id="XMLID_10" data-name="XMLID 10">
            <g id="Vector_339" data-name="Vector 339">
              <path
                class="cls-1"
                d="M301.5,284.1l22.2-12.8v-3.2l-22.2,12.8Z"
                transform="translate(-57.9 0)"
              />
              <path
                d="M301.5,284.6h-.3a.8.8,0,0,1-.2-.4V281a.8.8,0,0,1,.2-.5l22.2-12.7a.5.5,0,0,1,.5,0c.2,0,.3.2.3.4v3.2c0,.2-.1.3-.3.4l-22.2,12.8Zm.5-3.4v2L323.2,271v-2Z"
                transform="translate(-57.9 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_8" data-name="XMLID 8">
          <g id="Vector_340" data-name="Vector 340">
            <path
              class="cls-1"
              d="M334.7,221.1a.5.5,0,0,0,.6-.4.8.8,0,0,0,0-1h-.2c-36.9-22.9-68.5-102.7-68.5-116.7a.9.9,0,0,0-.8-.8c-.4-.1-.7.2-.8.6v.2c0,7.1,8.2,31.1,20.3,55.2,8.9,17.6,27.1,49.3,48.9,62.9Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M334.7,221.6l-.7-.2c-21.9-13.5-40.2-45.3-49.2-63.1-12.2-24.2-20.3-48.2-20.3-55.4a1.3,1.3,0,0,1,2.6,0h0c0,14,31.5,93.4,68.3,116.3a1.4,1.4,0,0,1,.4,1.8A1.3,1.3,0,0,1,334.7,221.6Zm-68.9-119a.3.3,0,0,0-.3.3c0,7.1,8.1,30.9,20.2,55,8.9,17.6,27.1,49.2,48.8,62.6h.4a.4.4,0,0,0,.1-.3l-.2-.2c-37-23-68.7-103-68.7-117.1a.3.3,0,0,0-.3-.3Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_3" data-name="XMLID 3">
          <g id="Vector_341" data-name="Vector 341">
            <path
              class="cls-1"
              d="M202.4,218.4a20.4,20.4,0,0,0,11-3.2c29.8-17.2,53.2-99.5,53.2-112.2a.8.8,0,0,0-1.6,0c0,6-6,29.8-15.3,53.6-8.3,21.1-21.4,48.2-37.1,57.2-6.7,3.9-13.2,4-19.6.4-20.2-11.7-37.9-60.8-49.3-100.1C131.1,70.4,123,27,123,20.5c.1-.4-.2-.7-.6-.8h-.2a.9.9,0,0,0-.8.8h0c0,6.8,7.9,49.5,20.8,94.1,11.4,39.5,29.4,89.1,50,101A20.3,20.3,0,0,0,202.4,218.4Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M202.4,218.9A19.9,19.9,0,0,1,192,216c-20.8-12-38.8-61.7-50.3-101.3C128.8,70,120.9,27.3,120.9,20.5a1.3,1.3,0,1,1,2.6,0c0,6.5,8.1,49.8,20.7,93.5,11.3,39.1,28.9,88.1,49.1,99.8,6.1,3.5,12.5,3.4,19-.4,15.6-8.9,28.7-35.9,37-57,9.3-23.8,15.2-47.5,15.2-53.4a1.3,1.3,0,0,1,2.6,0h0c0,12.7-23.5,95.4-53.5,112.7A23.4,23.4,0,0,1,202.4,218.9ZM122.2,20.2a.3.3,0,0,0-.3.3h0c0,6.8,7.9,49.3,20.8,94,11.4,39.4,29.3,88.9,49.8,100.7,6.5,3.7,13.7,3.6,20.6-.4,29.7-17.1,53-99.1,53-111.8l-.3-.3a.3.3,0,0,0-.3.3c0,6-6,29.8-15.3,53.7-8.3,21.3-21.6,48.5-37.4,57.6-6.8,3.9-13.6,4-20,.3-20.5-11.8-38.2-61.1-49.5-100.4-12.7-43.7-20.8-87.1-20.8-93.7a.3.3,0,0,0-.3-.3Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
        <g id="XMLID_2" data-name="XMLID 2">
          <g id="Vector_342" data-name="Vector 342">
            <path
              class="cls-1"
              d="M357.9,207.6l.6-.3a.8.8,0,0,0-.1-1.1c-34.5-28.4-61.2-99.2-61.2-111.5a.8.8,0,0,0-1.6,0c0,12.5,27,84,61.8,112.7C357.5,207.6,357.7,207.6,357.9,207.6Z"
              transform="translate(-57.9 0)"
            />
            <path
              d="M357.9,208.1a1.4,1.4,0,0,1-.9-.3c-34.8-28.9-61.9-100.5-61.9-113.1a1.3,1.3,0,0,1,2.6,0c0,12.3,26.7,82.8,61,111.1a2.2,2.2,0,0,1,.5.8,1.7,1.7,0,0,1-.3,1A1.2,1.2,0,0,1,357.9,208.1ZM296.4,94.4a.3.3,0,0,0-.3.3c0,12.5,26.9,83.7,61.6,112.4h.1s.1.1.3-.1v-.4c-34.6-28.5-61.4-99.5-61.4-111.9Z"
              transform="translate(-57.9 0)"
            />
          </g>
        </g>
      </g>
    </g>
    <g>
      <path
        class="cls-1"
        d="M64.9,163.4a3.4,3.4,0,0,0,.1,1,1.3,1.3,0,0,0,.1.6c0,.3.1.6.1.9a2.4,2.4,0,0,1,.2.8,1.9,1.9,0,0,1,.2.7l.3,1c.1.2.1.4.2.6a6.9,6.9,0,0,0,.5,1.3v.2a30.8,30.8,0,0,0,10.7,14.2V170.4l-12.6-7.3Z"
        transform="translate(-57.9 0)"
      />
      <polygon class="cls-1" points="22.3 171.9 22.3 185.8 27.6 182.7 34.2 178.8 22.3 171.9" />
      <path
        class="cls-1"
        d="M80.9,186.9a9.8,9.8,0,0,0,5.3.9h.9l1.8-.7c2.2-1.2,3.5-3.7,3.9-7Z"
        transform="translate(-57.9 0)"
      />
      <polygon class="cls-1" points="35 161.9 31.6 163.8 22.9 168.9 35 175.9 35 161.9" />
      <polygon class="cls-1" points="22.4 154.1 22.3 167.9 34.3 160.9 22.4 154.1" />
      <path
        class="cls-7"
        d="M114.4,182.7c4-2.3,6.2-7.1,6.2-13.5h0V145.9h0a.5.5,0,0,0-.3-.5h-.1l-20.1-11.6h0C94.4,130.5,89,130,85,132.3L64.1,144.2h-.2c-3.8,2.4-6,7.2-6,13.5-.1,13.1,9.2,29.1,20.5,35.6a18.6,18.6,0,0,0,9.5,2.9,10,10,0,0,0,5.6-1.4l.5-.3ZM64.7,145.3a9.6,9.6,0,0,1,5-1.3,17.5,17.5,0,0,1,8.9,2.7l20.1,11.6v23h0c0,6-2.1,10.5-5.7,12.5s-8.7,1.6-13.9-1.4C68,186,59,170.5,59.1,157.8,59.1,151.8,61.1,147.3,64.7,145.3Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-6"
        d="M79.1,192.4c5.2,3,10.1,3.6,13.8,1.4s5.7-6.5,5.7-12.5h0v-23l-20-11.6a17.5,17.5,0,0,0-8.9-2.7,9.6,9.6,0,0,0-5,1.3c-3.6,2-5.6,6.5-5.6,12.5C59,170.5,68,186,79.1,192.4Zm-1.2-5.9h-.3c-7.6-4.9-13.7-15.3-14.1-24.3a.7.7,0,0,1,.3-.6h.6l13.8,8a.7.7,0,0,1,.3.6v15.9a.5.5,0,0,1-.3.5Zm15.9-8a.5.5,0,0,1,.3.5c-.2,4.2-1.8,7.4-4.6,8.9a7.9,7.9,0,0,1-4.2,1.2,14.1,14.1,0,0,1-6-1.6.7.7,0,0,1-.3-.6V171a.5.5,0,0,1,.3-.5h.6Zm.1-17.9a.5.5,0,0,1,.3.5V177a.7.7,0,0,1-.3.6h-.7l-13.8-8.1a.5.5,0,0,1-.3-.5V153.1a.5.5,0,0,1,.3-.5H80Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-7"
        d="M78.5,186V170.1a.7.7,0,0,0-.3-.6l-13.8-8h-.6a.7.7,0,0,0-.3.6c.4,9,6.5,19.4,14.1,24.3h.6C78.4,186.3,78.5,186.2,78.5,186Zm-1.2-1.3a30.8,30.8,0,0,1-10.7-14.2v-.2a6.9,6.9,0,0,1-.5-1.3c-.1-.2-.1-.4-.2-.6l-.3-1a1.9,1.9,0,0,0-.2-.7,2.4,2.4,0,0,0-.2-.8c0-.3-.1-.6-.1-.9a1.3,1.3,0,0,1-.1-.6,3.4,3.4,0,0,1-.1-1,.4.4,0,0,1-.1-.3l12.6,7.3Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-7"
        d="M80,170.5h-.6a.5.5,0,0,0-.3.5v15.9a.7.7,0,0,0,.3.6,14.1,14.1,0,0,0,6,1.6,7.9,7.9,0,0,0,4.2-1.2c2.8-1.5,4.4-4.7,4.6-8.9a.5.5,0,0,0-.3-.5ZM88.9,187l-1.8.7h-.9a9.8,9.8,0,0,1-5.3-.9l11.9-6.9C92.4,183.3,91.1,185.8,88.9,187Zm-3.3-4.3-5.4,3.2V172.1L92,178.9Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-7"
        d="M79.4,152.6a.5.5,0,0,0-.3.5V169a.5.5,0,0,0,.3.5l13.8,8.1h.6a.7.7,0,0,0,.3-.6V161.1a.5.5,0,0,0-.3-.5l-13.9-8ZM80.9,169l8.6-5,3.5-2v14Zm-.6-1V154.1L92.2,161Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-1"
        d="M118.9,205.2c2.5,1.4,4.9,1.6,6.3.4s1.4-4.1,1.4-6.6V181.9l-5.1-2.9v18c0,1.3,0,2.7-.9,3.2a1.7,1.7,0,0,1-1.8-.1c-1.8-1-2.1-2.9-2.2-4.6l-5.7-3.3a16.5,16.5,0,0,0,4.8,10.5A13.1,13.1,0,0,0,118.9,205.2Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-1"
        d="M149.8,207.7v-5.3l-4.4-2.5v1.2a.7.7,0,0,1-.3.6h-.6l-.3-.3a13.5,13.5,0,0,0-5.2-5.9c-2.4-1.3-4.4-1.6-5.9-.7s-2.6,3.2-2.6,6.2c0,6.5,3.8,13.4,9,16.4,1.7.9,3.9,1.6,4.7.3a.4.4,0,0,1,.6-.3h.2a.5.5,0,0,1,.3.5v1.9l4.4,2.6Zm-7.5,5.9a4.4,4.4,0,0,1-2.5-.8,10.6,10.6,0,0,1-4.9-8.5c0-1.8.6-3.2,1.7-3.8s2.3-.4,3.8.4a10.3,10.3,0,0,1,4.9,8.6c0,1.8-.6,3.1-1.6,3.7l-1,.4Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-7"
        d="M145.3,209.5a10.3,10.3,0,0,0-4.9-8.6c-1.5-.8-2.8-1-3.8-.4a4.3,4.3,0,0,0-1.7,3.8,10.6,10.6,0,0,0,4.9,8.5,4.4,4.4,0,0,0,2.5.8h.4l1-.4C144.7,212.6,145.3,211.3,145.3,209.5Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-1"
        d="M182.4,230.2c0-1.1,0-2.1-.1-3.1a12.3,12.3,0,0,0-1.8-5.6,12.2,12.2,0,0,0-3.2-3.9l-1.4-.9c-1.6-.9-3.7-1.5-5.2.3-.1.2-.3.2-.5.2a.5.5,0,0,1-.5-.3,12.7,12.7,0,0,0-5.1-6.7c-2.1-1.2-3.6-1.2-4.4-.1s-.4.3-.7.2a.7.7,0,0,1-.4-.6v-1.9l-4-2.4v20.1l4.4,2.5V217.7c0-1.3.1-3.1,1.3-3.8a2.6,2.6,0,0,1,2.8.4c2.1,1.1,3.1,3.3,3.1,6.6v11.3l4.4,2.5V224.1c0-1.3.1-2.9,1.2-3.6s1.6-.3,2.8.4c2.8,1.6,3.1,4.3,3.1,6.9v11l4.4,2.6Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-1"
        d="M198.9,249.5a3.8,3.8,0,0,0,1.4-3.3c0-4.2-3.3-7.3-5.9-9.6s-3.5-3.2-3.5-4.8a1.6,1.6,0,0,1,.6-1.3,1.7,1.7,0,0,1,1.8.2,3.7,3.7,0,0,1,2,2.8l4.2,2.4a14.2,14.2,0,0,0-6.7-9.3,8,8,0,0,0-3.4-1.1,4.2,4.2,0,0,0-1.5.4h-.2a3.6,3.6,0,0,0-1.2,3.1c0,2.3,1.4,4.9,4.2,7.7l2.5,2.4.3.3c1,1.1,2.3,2.4,2.3,4a1.6,1.6,0,0,1-.6,1.3,2.5,2.5,0,0,1-2.2-.2,5,5,0,0,1-2.4-3.4l-4.1-2.5a14.5,14.5,0,0,0,7.1,9.9C195.7,249.8,197.7,250.2,198.9,249.5Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-1"
        d="M209.8,241.6a.5.5,0,0,1,.3-.5c.1-.2.4-.2.6,0h0l1.8,1v-3.5l-2.4-1.3a.9.9,0,0,1-.3-.6v-6.8l-4.3-2.5v6.1a.5.5,0,0,1-.3.5h-.6l-1.9-1v3.5l2.5,1.4a.5.5,0,0,1,.3.5v16.2l4.4,2.6Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-1"
        d="M234,251.1l-4-2.4-.4-.2v1.3a.5.5,0,0,1-.3.5h-.6c-.2,0-.2-.1-.3-.3a12.7,12.7,0,0,0-5.2-5.8c-2.4-1.4-4.4-1.6-5.9-.7s-2.6,3.2-2.6,6.2c0,6.4,3.8,13.3,9,16.3,1.7,1,3.9,1.6,4.7.3a.5.5,0,0,1,.8-.2h0a.5.5,0,0,1,.3.5v2l4.4,2.5Zm-10,10.4a10.7,10.7,0,0,1-4.9-8.6c0-1.8.6-3.1,1.7-3.7a3.8,3.8,0,0,1,3.8.3,10.7,10.7,0,0,1,4.9,8.7c0,1.8-.6,3.1-1.6,3.7a3.3,3.3,0,0,1-1.4.4A4.6,4.6,0,0,1,224,261.5Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-7"
        d="M227.9,261.9c1-.6,1.6-1.9,1.6-3.7a10.7,10.7,0,0,0-4.9-8.7c-1.5-.8-2.8-.9-3.8-.3a4.1,4.1,0,0,0-1.7,3.7,10.7,10.7,0,0,0,4.9,8.6,4.6,4.6,0,0,0,2.5.8A3.3,3.3,0,0,0,227.9,261.9Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-1"
        d="M256.8,277.5l-4.9-2.8c-.7.9-2.1,1.6-4.5.2a10,10,0,0,1-4.7-8.5c0-1.8.6-3.2,1.6-3.8s1.9-.6,3.6.4a9.5,9.5,0,0,1,4.3,5.5l4.3,2.4a21.2,21.2,0,0,0-9.3-13,9.3,9.3,0,0,0-4-1.2,4.6,4.6,0,0,0-2.3.6c-1.7.9-2.6,3.1-2.6,5.9,0,6.2,4.2,13.5,9.6,16.7,2.4,1.3,4.5,1.6,6.2.9A5.5,5.5,0,0,0,256.8,277.5Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-7"
        d="M292.2,269l6.2-4.7.4-.3a.5.5,0,0,0,.3-.5h0a.4.4,0,0,0-.1-.3c-.1-.2-.2-.2-.4-.3l-6.4-3.7h-.6l-4.4,2.6V249.5a.7.7,0,0,0-.3-.6l-5.6-3.2h-.6l-6.7,4a16.6,16.6,0,0,0-5.4-4.8c-2.8-1.7-5.5-1.9-7.6-.8l-5.1,3.1v-8.6a1.4,1.4,0,0,0-.2-.6l-5.6-3.1c-.1-.2-.4-.2-.6,0h0l-.4.2a15.7,15.7,0,0,0-4.6-4.3c-3.4-2-5.7-1.4-7.1-.7l-5.7,3.3v-.5l2.4-1.4a.5.5,0,0,0,.3-.5v-4.8h0V226c-.1-.1-.1-.3-.3-.4l-2.4-1.3v-6.8a1.4,1.4,0,0,0-.2-.6l-5.6-3.2h-.6l-6.4,3.8a18.1,18.1,0,0,0-4.6-4.1c-2.4-1.3-4.7-1.6-6.2-.7l-3.8,2.2a15.1,15.1,0,0,0-2-6.2,14.1,14.1,0,0,0-5.1-5.2h-.3c-2.4-1.3-4.1-1-5.2-.4l-.5.3a12.8,12.8,0,0,0-5.2-6.3c-2.1-1.2-3.8-1.4-5-.8v-.9a.7.7,0,0,0-.3-.6h-.2l-5-2.9h-.6l-3.2,1.8V190a.5.5,0,0,0-.3-.5l-5.6-3.2a.6.6,0,0,0-.6,0l-.4.3a14.2,14.2,0,0,0-4.5-4.3c-3.4-2-5.7-1.4-7.1-.7l-4.8,2.8v-15a.5.5,0,0,0-.3-.5h0l-6.3-3.7h-.6l-20.8,12.1h-.1a.7.7,0,0,0-.3.6v6.7l-10.3,6a.5.5,0,0,0-.3.5h0a17.4,17.4,0,0,0,8.6,15,10.3,10.3,0,0,0,4.5,1.4,5,5,0,0,0,2.4-.6h.2l4.3-2.5a20.7,20.7,0,0,0,9.3,14c2.1,1.2,4,1.5,5.3.8v1.1a.5.5,0,0,0,.3.5l5.5,3.2h.6l3.2-1.8V226a.9.9,0,0,0,.3.6l5.6,3.2h.6l.2-.3,4.9-2.9v6.1a.5.5,0,0,0,.3.5l5.5,3.2h.6l.2-.2,4.9-2.9v5.9a.5.5,0,0,0,.3.5l5.6,3.2h.5c.1,0,.1-.1.2-.3l2.6-1.5a15.7,15.7,0,0,0,7,8.2,8,8,0,0,0,4.5,1.4,5.4,5.4,0,0,0,2.2-.4l.4-.4,4.1-2.4v7.3a.5.5,0,0,0,.3.5l5.6,3.2h.6l4-2.3a20.5,20.5,0,0,0,8.4,10.6c2.1,1.2,4,1.5,5.3.9v1a.7.7,0,0,0,.3.6l5.5,3.2h.7l3.8-2.3a21.8,21.8,0,0,0,8.7,10.5,8.8,8.8,0,0,0,4.9,1.5,5,5,0,0,0,2.4-.6h.5l4.5-2.6v7.9a.5.5,0,0,0,.3.5l5.5,3.2h.6l2.8-1.6,1.7,4.4.2.3,6.4,3.7h.8l20.6-12a.8.8,0,0,0,.2-.8Zm-25.7,10.6-.3-.2h-.6a.5.5,0,0,0-.3.5v9.3l-4.4-2.5V259.4l4.3,2.5v14.6a.5.5,0,0,0,.3.5h0c.3.2.6.2.7,0l4.9-4.5,5.4,3.1-6.3,4.9a.6.6,0,0,0-.2.7l6.1,14.3-4.6-2.7Zm-18.6.3c-5.4-3.2-9.6-10.5-9.6-16.7,0-2.8.9-5,2.6-5.9a4.6,4.6,0,0,1,2.3-.6,9.3,9.3,0,0,1,4,1.2,21.2,21.2,0,0,1,9.3,13l-4.3-2.4a9.5,9.5,0,0,0-4.3-5.5c-1.7-1-2.9-.8-3.6-.4a4.8,4.8,0,0,0-1.6,3.8,10,10,0,0,0,4.7,8.5c2.4,1.4,3.8.7,4.5-.2l4.9,2.8a5.5,5.5,0,0,1-2.7,3.3c-1.7.7-3.8.4-6.2-.9Zm-18.4-13.3a.5.5,0,0,0-.3-.5h0a.5.5,0,0,0-.8.2c-.8,1.3-3,.7-4.7-.3-5.2-3-9-9.9-9-16.3,0-3,.9-5.3,2.6-6.2s3.5-.7,5.9.7a12.7,12.7,0,0,1,5.2,5.8c.1.2.1.3.3.3h.6a.5.5,0,0,0,.3-.5v-1.3l.4.2,4,2.4v20l-4.4-2.5Zm-24-28.2a.5.5,0,0,0-.3-.5l-2.5-1.4V233l1.9,1h.6a.5.5,0,0,0,.3-.5v-6.1l4.3,2.5v6.8a.9.9,0,0,0,.3.6l2.4,1.3v3.5l-1.8-1c-.1-.2-.4-.2-.6,0h0a.5.5,0,0,0-.3.5v15.6l-4.4-2.6Zm-11.9,10.2a14.5,14.5,0,0,1-7.1-9.9l4.1,2.5a5,5,0,0,0,2.4,3.4,2.5,2.5,0,0,0,2.2.2,1.6,1.6,0,0,0,.6-1.3c0-1.6-1.3-2.9-2.3-4l-.3-.3-2.5-2.4c-2.8-2.8-4.2-5.4-4.2-7.7a3.6,3.6,0,0,1,1.2-3.1h.2a4.2,4.2,0,0,1,1.5-.4,8,8,0,0,1,3.4,1.1,14.2,14.2,0,0,1,6.7,9.3l-4.2-2.4a3.7,3.7,0,0,0-2-2.8,1.7,1.7,0,0,0-1.8-.2,1.6,1.6,0,0,0-.6,1.3c0,1.6,1.5,3,3.5,4.8s5.9,5.4,5.9,9.6a3.8,3.8,0,0,1-1.4,3.3c-1.2.6-3.2.2-5.3-1Zm-15.5-20.8c0-2.6-.3-5.3-3.1-6.9-1.2-.7-2.1-.8-2.8-.4s-1.2,2.3-1.2,3.6v10.6l-4.4-2.5V220.9c0-3.3-1-5.5-3.1-6.6a2.6,2.6,0,0,0-2.8-.4c-1.2.7-1.3,2.5-1.3,3.8V228l-4.4-2.5V205.4l4,2.4v1.9a.7.7,0,0,0,.4.6c.3.1.5-.1.7-.2a4.9,4.9,0,0,1,4.4.1,12.7,12.7,0,0,1,5.1,6.7.5.5,0,0,0,.5.3c.2,0,.4,0,.5-.2,1.5-1.8,3.6-1.2,5.2-.3l1.4.9a12.2,12.2,0,0,1,3.2,3.9,12.3,12.3,0,0,1,1.8,5.6c.1,1,.1,2,.1,3.1v11.2l-4.4-2.6ZM145.3,218a.5.5,0,0,0-.3-.5h0a.5.5,0,0,0-.7,0v.2c-.8,1.3-3,.6-4.7-.3-5.2-3-9-9.9-9-16.4,0-3,.9-5.2,2.6-6.2s3.5-.6,5.9.7a13.5,13.5,0,0,1,5.2,5.9l.3.3h.6a.7.7,0,0,0,.3-.6v-1.2l4.4,2.5v20.1l-4.4-2.6Zm-34.5-25.8,5.7,3.3c.1,1.7.4,3.6,2.2,4.6a1.7,1.7,0,0,0,1.8.1c.9-.5.9-1.9.9-3.2V179l5.1,2.9V199c0,2.5,0,5.4-1.4,6.6s-3.8,1-6.3-.4a15.9,15.9,0,0,1-8-13Z"
        transform="translate(-57.9 0)"
      />
      <path
        class="cls-1"
        d="M271.6,292.8l4.6,2.7-6.1-14.3a.6.6,0,0,1,.2-.7l6.3-4.9-5.4-3.1-4.9,4.5c-.1.2-.4.2-.7,0h0a.5.5,0,0,1-.3-.5V261.9l-4.3-2.5v27.2l4.4,2.5v-9.3a.5.5,0,0,1,.3-.5h.6l.3.2Z"
        transform="translate(-57.9 0)"
      />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    goldengate() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-golden-gate",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1,
            transformOrigin: "50% 50%",
            ease: "back.out(1)",
          },
        })
        .add("goldengate")
        .from(
          "#Sun, #Clouds",
          {
            opacity: 0,
            scale: 0,
            stagger: 0.1,
          },
          "goldengate"
        )
        .from(
          "#Bridge",
          {
            opacity: 0,
            scale: 0.5,
          },
          "goldengate+=0.5"
        );
    },
  },
  mounted() {
    this.goldengate();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #fff;
}

.cls-2 {
  opacity: 0.3;
}

.cls-3 {
  opacity: 0.4;
}

.cls-4 {
  opacity: 0.2;
}

.cls-5 {
  opacity: 0.6;
}

.cls-6 {
  fill: #ffad43;
}

.cls-7 {
  fill: #0e1e25;
}
</style>